// GENERATED FILE — do not edit. Source: contracts/generated-ts/api-client/openapi.json
// in sarva-ai-pms-backend (built by `python -m sarva_api.openapi_spec` from services/api).
// Regenerate there with `make codegen`; sync into this repo with `pnpm sync:contract`.

import { request as send, SarvaApiError, type ClientConfig } from "../http";

import type {
  AccountingPeriodEnvelope,
  AccountingPeriodListEnvelope,
  AcknowledgementRecordRequest,
  AdjustmentApproveRequest,
  AdjustmentEnvelope,
  AdjustmentListEnvelope,
  AdjustmentRequestBody,
  AiSuggestionEnvelope,
  AiSuggestionListEnvelope,
  AppealApproveRequest,
  AppealCreateRequest,
  AppealEnvelope,
  AppealLetterSuggestionListEnvelope,
  AppealListEnvelope,
  AppealOutcomeRecordRequest,
  AppealOutcomesEnvelope,
  AppealSubmitRequest,
  AppointmentAuthorizationCheckEnvelope,
  AppointmentBookRequest,
  AppointmentCancelRequest,
  AppointmentDetailEnvelope,
  AppointmentEnvelope,
  AppointmentListEnvelope,
  AppointmentPriorAuthRequest,
  AppointmentSeriesEnvelope,
  AppointmentSeriesListEnvelope,
  AppointmentSeriesRequest,
  AuditEntryListEnvelope,
  AuthRequirementCreateRequest,
  AuthRequirementEnvelope,
  AuthRequirementListEnvelope,
  AwaitingCertificationEnvelope,
  BankStatementImportEnvelope,
  BankStatementImportRequest,
  BaselineDiagnosticEnvelope,
  BenefitSuggestionListEnvelope,
  BookingAcceptRequest,
  BookingDeclineRequest,
  BookingLinkEnvelope,
  BookingLinkRequest,
  BookingPageEnvelope,
  BookingRequestCreate,
  BookingRequestEnvelope,
  BookingRequestListEnvelope,
  BookingRequestReceivedEnvelope,
  BookingSlotListEnvelope,
  CallNotesRequest,
  CandidateEnvelope,
  CandidateRequest,
  CarePlanCertifyRequest,
  CarePlanCreateRequest,
  CarePlanEnvelope,
  CarePlanListEnvelope,
  CarePlanOutcomesEnvelope,
  CarePlanReasonRequest,
  CarePlanSignoffCreateRequest,
  CarePlanSignoffEnvelope,
  CarePlanSignoffListEnvelope,
  CarePlanUpdateRequest,
  ChargeAmendRequest,
  ChargeBatchAddEnvelope,
  ChargeBatchAddRequest,
  ChargeBatchCreateRequest,
  ChargeBatchEnvelope,
  ChargeBatchListEnvelope,
  ChargeCreateRequest,
  ChargeEnvelope,
  ChargeHoldRequest,
  ChargeListEnvelope,
  ChargeProposalEnvelope,
  ChargeReleaseEnvelope,
  ChargeRuleEnvelope,
  ChargeRuleListEnvelope,
  ChargeRuleUpsertRequest,
  ChargeTemplateApplyRequest,
  ChargeTemplateEnvelope,
  ChargeTemplateListEnvelope,
  ChargeTemplateRequest,
  ChargeVoidRequest,
  CheckoutEnvelope,
  CheckoutRequest,
  ClaimAcknowledgementEnvelope,
  ClaimAcknowledgementListEnvelope,
  ClaimClosureRequest,
  ClaimEnvelope,
  ClaimFilingRequest,
  ClaimFromChargesEnvelope,
  ClaimFromChargesRequest,
  ClaimListEnvelope,
  ClaimReceiptRequest,
  ClaimStatusCheckEnvelope,
  ClaimStatusHistoryEnvelope,
  ClaimStatusRecordRequest,
  ClaimSubmissionEnvelope,
  ClaimSubmissionListEnvelope,
  ClaimSubmissionReconcileRequest,
  ClaimSuggestionEnvelope,
  ClaimSuggestionListEnvelope,
  ClaimSuggestionReviewRequest,
  ClientTokenRequest,
  ClinicalNoteCreateRequest,
  ClinicalNoteDiscardRequest,
  ClinicalNoteEnterInErrorRequest,
  ClinicalNoteEnvelope,
  ClinicalNoteListEnvelope,
  ClinicalNotePurpose,
  ClinicalNoteUpdateRequest,
  ClosePeriodRequest,
  CodeGroupEnvelope,
  CodeGroupListEnvelope,
  CodeGroupUpsertRequest,
  CodeSetListEnvelope,
  CodingProposalEnvelope,
  CodingProposalReviewRequest,
  CodingReviewCreateRequest,
  CodingReviewEnvelope,
  CollectionsStatementEnvelope,
  ConsentEnvelope,
  ConsentFormCreateRequest,
  ConsentFormEnvelope,
  ConsentFormListEnvelope,
  ConsentLinkAcceptRequest,
  ConsentLinkAcceptedEnvelope,
  ConsentLinkEnvelope,
  ConsentRecordRequest,
  ConsentRequestCreateRequest,
  ConsentRequestEnvelope,
  ConsentRequestListEnvelope,
  ConsentStatusEnvelope,
  ConsentTemplateListEnvelope,
  CoordinationOfBenefitsEnvelope,
  CoreExchangeRequest,
  CoverageCreateRequest,
  CoverageEnvelope,
  CoverageListEnvelope,
  CoverageUpdateRequest,
  CreditBalanceListEnvelope,
  CustomFieldCreateRequest,
  CustomFieldDefinitionEnvelope,
  CustomFieldDefinitionListEnvelope,
  DailyDigestEnvelope,
  DaySheetEnvelope,
  DefaultPracticeEnvelope,
  DefaultPracticeRequest,
  DenialClassifyRequest,
  DenialEnvelope,
  DenialListEnvelope,
  DenialResolveRequest,
  DictationRequest,
  DocumentClassificationEnvelope,
  DocumentClassificationListEnvelope,
  DocumentClassificationReviewRequest,
  DocumentClassifyRequest,
  DocumentEnvelope,
  DocumentListEnvelope,
  DueCheckEnvelope,
  DueCheckRequest,
  DuplicateCheckEnvelope,
  DuplicateCheckRequest,
  DuplicatePairListEnvelope,
  EligibilityCheckRequest,
  EligibilityDueEnvelope,
  EligibilityEnvelope,
  EligibilityListEnvelope,
  EligibilityVerificationRequest,
  EmailLogEntryEnvelope,
  EmailLogEnvelope,
  EncounterListEnvelope,
  EncounterReconcileEnvelope,
  EncounterReconcileRequest,
  EnrollmentCreateRequest,
  EnrollmentUpdateRequest,
  EnteredInErrorRequest,
  Envelope_ArAgingResource_,
  Envelope_BalanceDriftResource_,
  Envelope_BalanceExplanationResource_,
  Envelope_BillingReadinessResource_,
  Envelope_ClaimClosureResource_,
  Envelope_ClaimReplacementResource_,
  Envelope_EnrollmentResource_,
  Envelope_EstimateQuoteResource_,
  Envelope_ExplanationSuggestionResource_,
  Envelope_FollowUpNoteResource_,
  Envelope_GuarantorResource_,
  Envelope_OperationResource_,
  Envelope_PatientEstimateResource_,
  Envelope_PatientStatementResource_,
  Envelope_PayerRuleResource_,
  Envelope_PolicyBandResource_,
  Envelope_ProviderIdentifierResource_,
  Envelope_ProviderObligationSweepResource_,
  Envelope_ProviderResource_,
  Envelope_ReconciliationSweepResource_,
  Envelope_ReviewSweepResource_,
  Envelope_RoleGrantResource_,
  Envelope_ScheduleBlockResource_,
  Envelope_ScoreboardProjectionResource_,
  Envelope_ScoreboardResource_,
  Envelope_ScrubRuleResource_,
  Envelope_ServiceMappingResource_,
  Envelope_SettingResource_,
  Envelope_SettledSweepResource_,
  Envelope_ShadowEvaluationResource_,
  Envelope_SubmissionEligibilityResource_,
  Envelope_SupportSessionResource_,
  Envelope_TemplateResource_,
  Envelope_UserResource_,
  Envelope_VisitTypeResource_,
  Envelope_list_BookableSlotResource__,
  Envelope_list_EnrollmentResource__,
  Envelope_list_ExplanationSuggestionResource__,
  Envelope_list_FollowUpNoteResource__,
  Envelope_list_GuarantorResource__,
  Envelope_list_PatientEstimateResource__,
  Envelope_list_PatientStatementResource__,
  Envelope_list_PayerRuleResource__,
  Envelope_list_PolicyBandResource__,
  Envelope_list_ProviderIdentifierResource__,
  Envelope_list_ProviderResource__,
  Envelope_list_RoleGrantResource__,
  Envelope_list_RoleResource__,
  Envelope_list_ScheduleBlockResource__,
  Envelope_list_ScrubRuleResource__,
  Envelope_list_ServiceMappingResource__,
  Envelope_list_SettingDefinitionResource__,
  Envelope_list_SettingResource__,
  Envelope_list_SupportSessionResource__,
  Envelope_list_TemplateResource__,
  Envelope_list_UserResource__,
  Envelope_list_VisitTypeResource__,
  EstateCapabilitiesEnvelope,
  EvaluationRequest,
  EvaluationResultEnvelope,
  ExplanationReviewRequest,
  FeeScheduleBulkEnvelope,
  FeeScheduleBulkRequest,
  FeeScheduleCreateRequest,
  FeeScheduleEnvelope,
  FeeScheduleLineCorrectionRequest,
  FeeScheduleLineCreateRequest,
  FeeScheduleLineEnvelope,
  FeeScheduleLineListEnvelope,
  FeeScheduleListEnvelope,
  FeedConflictAcceptRequest,
  FeedConflictCloseRequest,
  FeedConflictEnvelope,
  FeedConflictListEnvelope,
  FollowUpNoteCreateRequest,
  GuarantorCreateRequest,
  HealthEnvelope,
  ImportBatchEnvelope,
  ImportBatchListEnvelope,
  ImportCommitRequest,
  ImportMappingReviewRequest,
  ImportMappingSuggestRequest,
  ImportMappingSuggestionEnvelope,
  ImportMappingSuggestionListEnvelope,
  ImportSignOffRequest,
  ImportStageRequest,
  InsuranceCardReadRequest,
  InsuranceCardReadingListEnvelope,
  IntakeFormChoiceListEnvelope,
  IntakeFormEnvelope,
  IntakeInvitationCreateRequest,
  IntakeInvitationEnvelope,
  IntakeInvitationListEnvelope,
  IntakeSubmission,
  IntakeSubmittedEnvelope,
  LaunchRequest,
  LocationCreateRequest,
  LocationEnvelope,
  LocationListEnvelope,
  LocationUpdateRequest,
  LossIncidentEnvelope,
  LossIncidentListEnvelope,
  MatchStatus,
  MeEnvelope,
  MfaCodeRequest,
  MfaEnrolmentEnvelope,
  MfaStatusEnvelope,
  NoteAddendumRequest,
  NoteChargeCommitRequest,
  NoteSuggestionEnvelope,
  NoteSuggestionListEnvelope,
  NoteSuggestionReviewRequest,
  NoteTemplateCreateRequest,
  NoteTemplateEnvelope,
  NoteTemplateListEnvelope,
  NoteTemplateVersionEnvelope,
  NoteTemplateVersionRequest,
  NoteTimeEntriesRequest,
  ObligationEnvelope,
  ObligationListEnvelope,
  ObligationResolveRequest,
  ObligationWaiveRequest,
  OrganisationEnvelope,
  PackInstallEnvelope,
  PackInstallRequest,
  PackagePlanCreateRequest,
  PackagePlanEnvelope,
  PackagePlanListEnvelope,
  PackagePlanUpdateRequest,
  PackageSettleEnvelope,
  PackageSettleRequest,
  PasswordChangeEnvelope,
  PasswordChangeRequest,
  PasswordRecoveryEnvelope,
  PasswordResetAsk,
  PasswordResetSubmission,
  PatientAccountEnvelope,
  PatientAddressInput,
  PatientAddressSetEnvelope,
  PatientCustomFieldsEnvelope,
  PatientCustomFieldsUpdate,
  PatientEnvelope,
  PatientEstimateCreateRequest,
  PatientFeedEnvelope,
  PatientFeedRequest,
  PatientLedgerEnvelope,
  PatientListEnvelope,
  PatientMergeEnvelope,
  PatientMergeRequest,
  PatientOwingEnvelope,
  PatientPackageEnvelope,
  PatientPackageListEnvelope,
  PatientPackagePurchaseRequest,
  PatientPaymentEnvelope,
  PatientPaymentRequest,
  PatientPaymentReverseRequest,
  PatientRegisterRequest,
  PatientStatementCreateRequest,
  PatientUpdateRequest,
  PayerChoiceListEnvelope,
  PayerCreateRequest,
  PayerDirectoryEnvelope,
  PayerEnvelope,
  PayerIdentifierVerifyRequest,
  PayerListEnvelope,
  PayerNcciRequest,
  PayerResolveRequest,
  PayerRouteRequest,
  PayerRuleCreateRequest,
  PayerRuleExtractRequest,
  PayerRuleRejectRequest,
  PayerScorecardEnvelope,
  PayerUpdateRequest,
  PaymentPlanCancelRequest,
  PaymentPlanCreateRequest,
  PaymentPlanEnvelope,
  PaymentPlanListEnvelope,
  PeriodReconciliationEnvelope,
  PlacementCreateRequest,
  PlacementEnvelope,
  PlacementEventRequest,
  PlacementListEnvelope,
  PlanSignoffAnswer,
  PlanSignoffAnsweredEnvelope,
  PlanSignoffViewEnvelope,
  PolicyBandCreateRequest,
  PolicyBandPauseRequest,
  PostingReversalEnvelope,
  PostingReversalRequest,
  PostingRunEnvelope,
  PostingRunSummaryListEnvelope,
  PracticeActivityEnvelope,
  PracticeArchiveRequest,
  PracticeCreate,
  PracticeEnvelope,
  PracticeHubLinkRequest,
  PracticeListEnvelope,
  PracticeUpdate,
  PriorAuthCreateRequest,
  PriorAuthDecisionRequest,
  PriorAuthEnvelope,
  PriorAuthListEnvelope,
  Problem,
  ProcedureAttributeEnvelope,
  ProcedureAttributeListEnvelope,
  ProcedureAttributeUpsertRequest,
  ProcedureCodeChoiceListEnvelope,
  ProviderChoiceListEnvelope,
  ProviderCreateRequest,
  ProviderIdentifierCreateRequest,
  ProviderObligationSweepRequest,
  ProviderUpdateRequest,
  ProvisioningEnvelope,
  ProvisioningEvent,
  QueueHealthListEnvelope,
  RateCoverageEnvelope,
  RateExtractionRequest,
  RateSuggestionListEnvelope,
  ReasonCodeTextListEnvelope,
  ReconciliationSweepRequest,
  ReferralEnvelope,
  ReferralListEnvelope,
  ReferralRequest,
  ReferralUpdateRequest,
  ReferralVoidRequest,
  RefundApproveRequest,
  RefundEnvelope,
  RefundIssueRequest,
  RefundListEnvelope,
  RefundRequest,
  RejectionCorrectRequest,
  RejectionDiagnoseRequest,
  RejectionEnvelope,
  RejectionHistoryEnvelope,
  ReminderPageEnvelope,
  RemittanceDocumentRequest,
  RemittanceEnvelope,
  RemittanceExtractionEnvelope,
  RemittanceExtractionListEnvelope,
  RemittanceExtractionRejectRequest,
  RemittanceIngestRequest,
  RemittanceListEnvelope,
  RemittanceManualRequest,
  RemittancePostRequest,
  ReportDefinitionEnvelope,
  ReportDefinitionListEnvelope,
  ReportDefinitionSaveRequest,
  RevenueRecognitionEnvelope,
  RevenueRecognitionRequest,
  RoleGrantCreateRequest,
  ScheduleBlockCreateRequest,
  ScheduleDiffEnvelope,
  ScoreboardProjectionRequest,
  ScrubOverrideEnvelope,
  ScrubOverrideListEnvelope,
  ScrubOverrideRequest,
  ScrubResultListEnvelope,
  ScrubRuleCreateRequest,
  SendRemindersEnvelope,
  SendRemindersRequest,
  SeriesCancelRequest,
  ServiceMappingRequest,
  SettingCreateRequest,
  SettingRevertRequest,
  ShadowEvaluateRequest,
  SourceInvoiceEnvelope,
  SourceInvoiceIntakeEnvelope,
  SourceInvoiceIntakeRequest,
  SpecialtyPackListEnvelope,
  StatementSendRequest,
  StrandedReservationsEnvelope,
  SuggestionReviewRequest,
  SuperbillDocumentRequest,
  SuperbillExtractionEnvelope,
  SuperbillExtractionListEnvelope,
  SuperbillExtractionReviewRequest,
  SupportSessionEndRequest,
  SupportSessionStartRequest,
  SweepEnvelope,
  SweepHealthEnvelope,
  SweepRequest,
  SweepRunListEnvelope,
  TemplateCreateRequest,
  TemplateUpdateRequest,
  ThresholdProgressEnvelope,
  TokenEnvelope,
  TokenRequest,
  UnappliedCashEnvelope,
  UnitMethodEnvelope,
  UnitMethodListEnvelope,
  UnitMethodUpsertRequest,
  UnmatchedDepositListEnvelope,
  UserCreateRequest,
  VisitChoiceListEnvelope,
  VisitTypeCreateRequest,
  VisitTypeUpdateRequest,
  VoiceAppointmentEnvelope,
  VoiceBalanceEnvelope,
  VoiceCallListEnvelope,
  VoiceCallRequestedEnvelope,
  VoiceOutcomeListEnvelope,
  WaitlistAddRequest,
  WaitlistBookRequest,
  WaitlistEntryEnvelope,
  WaitlistEntryListEnvelope,
  WaitlistRemoveRequest,
  WorkItemAssignRequest,
  WorkItemEnvelope,
  WorkItemListEnvelope,
  WorkItemResolveRequest,
  WritebackDoneRequest,
  WritebackNotApplicableRequest,
  WritebackState,
  WritebackTaskEnvelope,
  WritebackTaskListEnvelope,
} from "./types";

/** Book the requested time. */
export interface AcceptBookingRequestRequest {
  /** Path parameters. */
  path: {
    booking_request_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: BookingAcceptRequest;
  signal?: AbortSignal;
}

/** Accept consent forms. */
export interface AcceptConsentLinkRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  body: ConsentLinkAcceptRequest;
  signal?: AbortSignal;
}

/** Take the EHR's name or date of birth for this patient. */
export interface AcceptPatientFeedConflictRequest {
  /** Path parameters. */
  path: {
    conflict_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FeedConflictAcceptRequest;
  signal?: AbortSignal;
}

/** Start treatment under the plan. */
export interface ActivateCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Put draft charges into a batch for review. */
export interface AddChargesToBatchRequest {
  /** Path parameters. */
  path: {
    batch_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeBatchAddRequest;
  signal?: AbortSignal;
}

/** Correct or add to a signed note. */
export interface AddClinicalNoteAddendumRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: NoteAddendumRequest;
  signal?: AbortSignal;
}

/** Put a policy on a patient. */
export interface AddPatientCoverageRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CoverageCreateRequest;
  signal?: AbortSignal;
}

/** Record who is financially responsible. */
export interface AddPatientGuarantorRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: GuarantorCreateRequest;
  signal?: AbortSignal;
}

/** Record an identifier or credential. */
export interface AddProviderIdentifierRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ProviderIdentifierCreateRequest;
  signal?: AbortSignal;
}

/** Put a patient on the waitlist. */
export interface AddToWaitlistRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WaitlistAddRequest;
  signal?: AbortSignal;
}

/** Correct a charge before it is billed. */
export interface AmendChargeRequest {
  /** Path parameters. */
  path: {
    charge_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeAmendRequest;
  signal?: AbortSignal;
}

/** Certify or decline a plan of care. */
export interface AnswerPlanSignoffRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  body: PlanSignoffAnswer;
  signal?: AbortSignal;
}

/** Enter a whole superbill against an encounter. */
export interface ApplyChargeTemplateRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeTemplateApplyRequest;
  signal?: AbortSignal;
}

/** Agree to it, which is what posts it. */
export interface ApproveAdjustmentRequest {
  /** Path parameters. */
  path: {
    adjustment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AdjustmentApproveRequest;
  signal?: AbortSignal;
}

/** Approve an appeal for submission. */
export interface ApproveAppealRequest {
  /** Path parameters. */
  path: {
    appeal_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppealApproveRequest;
  signal?: AbortSignal;
}

/** Approve a refund — the second signature. */
export interface ApproveRefundRequest {
  /** Path parameters. */
  path: {
    refund_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RefundApproveRequest;
  signal?: AbortSignal;
}

/** Retire a superbill. */
export interface ArchiveChargeTemplateRequest {
  /** Path parameters. */
  path: {
    template_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Archive a practice. */
export interface ArchivePracticeRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PracticeArchiveRequest;
  signal?: AbortSignal;
}

/** Grant a role to somebody. */
export interface AssignRoleRequest {
  /** Path parameters. */
  path: {
    user_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RoleGrantCreateRequest;
  signal?: AbortSignal;
}

/** Assign a work item. */
export interface AssignWorkItemRequest {
  /** Path parameters. */
  path: {
    work_item_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WorkItemAssignRequest;
  signal?: AbortSignal;
}

/** Put a visit on the schedule. */
export interface BookAppointmentRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppointmentBookRequest;
  signal?: AbortSignal;
}

/** Book a course of care. */
export interface BookAppointmentSeriesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppointmentSeriesRequest;
  signal?: AbortSignal;
}

/** Close a waitlist entry with the visit booked for it. */
export interface BookWaitlistEntryRequest {
  /** Path parameters. */
  path: {
    entry_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WaitlistBookRequest;
  signal?: AbortSignal;
}

/** Load a whole contract's prices in one call. */
export interface BulkLoadFeeScheduleLinesRequest {
  /** Path parameters. */
  path: {
    fee_schedule_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FeeScheduleBulkRequest;
  signal?: AbortSignal;
}

/** Somebody told us the visit will not happen. */
export interface CancelAppointmentRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppointmentCancelRequest;
  signal?: AbortSignal;
}

/** The patient is not coming. */
export interface CancelAppointmentFromReminderRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** Stop a course of care. */
export interface CancelAppointmentSeriesRequest {
  /** Path parameters. */
  path: {
    series_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SeriesCancelRequest;
  signal?: AbortSignal;
}

/** End a payment plan early, with the reason. */
export interface CancelPaymentPlanRequest {
  /** Path parameters. */
  path: {
    plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PaymentPlanCancelRequest;
  signal?: AbortSignal;
}

/** Record the practitioner's certification. */
export interface CertifyCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CarePlanCertifyRequest;
  signal?: AbortSignal;
}

/** Change your own password. */
export interface ChangeOwnPasswordRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PasswordChangeRequest;
  signal?: AbortSignal;
}

/** Charge the patient the practice's no-show or late-cancellation fee. */
export interface ChargeMissedVisitFeeRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What can be known about this visit's authorization before it happens. */
export interface CheckAppointmentAuthorizationRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask the payer what has happened to this claim. */
export interface CheckClaimStatusRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask a model whether the note supports the services billed from it. */
export interface CheckClinicalNoteDocumentationRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Choose the level this documentation supports — and refuse anything above it. */
export interface CheckCodingComplianceRequest {
  /** Path parameters. */
  path: {
    review_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask payers about every upcoming visit owed a coverage check. */
export interface CheckEligibilityForDueVisitsRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DueCheckRequest;
  signal?: AbortSignal;
}

/** Settle a visit at the desk: draw a package, take a payment, or both. */
export interface CheckoutVisitRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CheckoutRequest;
  signal?: AbortSignal;
}

/** May this patient be asked for money yet?. */
export interface CheckPatientBillingReadinessRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The encounter being billed. The question is per service. */
    encounter_id?: string | null;
    /**
     * Tenant configuration (R-PB-05). Off unless the tenant explicitly enabled up-front
     * collection.
     */
    upfront_collection_enabled?: boolean;
    /** False where the contract forbids balance-billing this claim. */
    patient_liability_permitted?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Is this person already on the books?. */
export interface CheckPatientDuplicatesRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DuplicateCheckRequest;
  signal?: AbortSignal;
}

/** Ask a payer whether a coverage was in force. */
export interface CheckPatientEligibilityRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EligibilityCheckRequest;
  signal?: AbortSignal;
}

/** May a claim be submitted for this provider and payer?. */
export interface CheckProviderSubmissionEligibilityRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice the claim belongs to. */
    practice_id: string;
    /** The payer the claim would be submitted to. */
    payer_id: string;
    /** Date of service, ISO 8601. The date that governs. */
    service_date: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Classify a denial to a root cause. */
export interface ClassifyDenialRequest {
  /** Path parameters. */
  path: {
    denial_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DenialClassifyRequest;
  signal?: AbortSignal;
}

/** Say what an arriving document is, and quote what says whose it is. */
export interface ClassifyDocumentRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DocumentClassifyRequest;
  signal?: AbortSignal;
}

/** Classify a document that arrived through the estate (a fax). */
export interface ClassifyRetainedDocumentRequest {
  /** Path parameters. */
  path: {
    document_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Close a month. */
export interface CloseAccountingPeriodRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClosePeriodRequest;
  signal?: AbortSignal;
}

/** Stop pursuing this claim, and say why. */
export interface CloseClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimClosureRequest;
  signal?: AbortSignal;
}

/** Keep our record, or note the change was made by hand. */
export interface ClosePatientFeedConflictRequest {
  /** Path parameters. */
  path: {
    conflict_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FeedConflictCloseRequest;
  signal?: AbortSignal;
}

/** Close the claims whose money question is already answered. */
export interface CloseSettledClaimsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    limit?: number;
    after_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Bill a signed note's charges. */
export interface CommitClinicalNoteChargesRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: NoteChargeCommitRequest;
  signal?: AbortSignal;
}

/** Commit a signed-off import, or write nothing. */
export interface CommitImportRequest {
  /** Path parameters. */
  path: {
    import_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ImportCommitRequest;
  signal?: AbortSignal;
}

/** The course of care is finished. */
export interface CompleteCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Recorded in the client system. */
export interface CompleteWritebackTaskRequest {
  /** Path parameters. */
  path: {
    task_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WritebackDoneRequest;
  signal?: AbortSignal;
}

/** The patient is coming. */
export interface ConfirmAppointmentFromReminderRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** Prove possession once, which turns the factor on. */
export interface ConfirmMfaRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: MfaCodeRequest;
  signal?: AbortSignal;
}

/** Raise a corrected claim that replaces this one. */
export interface CorrectClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimClosureRequest;
  signal?: AbortSignal;
}

/** Correct a rate that was keyed wrongly. */
export interface CorrectFeeScheduleLineRequest {
  /** Path parameters. */
  path: {
    fee_schedule_id: string;
    line_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FeeScheduleLineCorrectionRequest;
  signal?: AbortSignal;
}

/** Take a rejected claim back to draft to fix it and send it again. */
export interface CorrectRejectedClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
    rejection_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RejectionCorrectRequest;
  signal?: AbortSignal;
}

/** Co-sign an assistant's note as the supervising clinician. */
export interface CosignClinicalNoteRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Open an appeal against a denial. */
export interface CreateAppealRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppealCreateRequest;
  signal?: AbortSignal;
}

/** Draft a plan of care. */
export interface CreateCarePlanRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CarePlanCreateRequest;
  signal?: AbortSignal;
}

/** Ask a referring physician to sign a plan of care. */
export interface CreateCarePlanSignoffRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CarePlanSignoffCreateRequest;
  signal?: AbortSignal;
}

/** Enter a charge against an encounter. */
export interface CreateChargeRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeCreateRequest;
  signal?: AbortSignal;
}

/** Open a charge batch. */
export interface CreateChargeBatchRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeBatchCreateRequest;
  signal?: AbortSignal;
}

/** Assemble released charges into a claim. */
export interface CreateClaimFromChargesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimFromChargesRequest;
  signal?: AbortSignal;
}

/** Start a note from a template. */
export interface CreateClinicalNoteRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClinicalNoteCreateRequest;
  signal?: AbortSignal;
}

/** Ask a patient to read and accept the practice's consent forms. */
export interface CreateConsentRequestRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ConsentRequestCreateRequest;
  signal?: AbortSignal;
}

/** Add a custom field for patients. */
export interface CreateCustomFieldRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CustomFieldCreateRequest;
  signal?: AbortSignal;
}

/** Load a fee schedule. */
export interface CreateFeeScheduleRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FeeScheduleCreateRequest;
  signal?: AbortSignal;
}

/** Price a procedure on a schedule. */
export interface CreateFeeScheduleLineRequest {
  /** Path parameters. */
  path: {
    fee_schedule_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FeeScheduleLineCreateRequest;
  signal?: AbortSignal;
}

/** Make a single-use intake link for a patient. */
export interface CreateIntakeInvitationRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: IntakeInvitationCreateRequest;
  signal?: AbortSignal;
}

/** Add a service location. */
export interface CreateLocationRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: LocationCreateRequest;
  signal?: AbortSignal;
}

/** Create a note template (version 1). */
export interface CreateNoteTemplateRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: NoteTemplateCreateRequest;
  signal?: AbortSignal;
}

/** Offer a prepaid package. */
export interface CreatePackagePlanRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PackagePlanCreateRequest;
  signal?: AbortSignal;
}

/** Record an estimate. */
export interface CreatePatientEstimateRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientEstimateCreateRequest;
  signal?: AbortSignal;
}

/** Generate a statement. */
export interface CreatePatientStatementRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientStatementCreateRequest;
  signal?: AbortSignal;
}

/** Add a payer this organisation bills. */
export interface CreatePayerRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerCreateRequest;
  signal?: AbortSignal;
}

/** Record when a payer requires an authorization. */
export interface CreatePayerAuthRequirementRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AuthRequirementCreateRequest;
  signal?: AbortSignal;
}

/** Enter a payer deadline rule by hand. */
export interface CreatePayerRuleRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerRuleCreateRequest;
  signal?: AbortSignal;
}

/** Agree a payment plan with a patient. */
export interface CreatePaymentPlanRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PaymentPlanCreateRequest;
  signal?: AbortSignal;
}

/** Write a new version of an autonomy band. */
export interface CreatePolicyBandRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PolicyBandCreateRequest;
  signal?: AbortSignal;
}

/** Create a practice. */
export interface CreatePracticeRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PracticeCreate;
  signal?: AbortSignal;
}

/** Add a clinician the practice bills under. */
export interface CreateProviderRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ProviderCreateRequest;
  signal?: AbortSignal;
}

/** Record a payer enrollment. */
export interface CreateProviderEnrollmentRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EnrollmentCreateRequest;
  signal?: AbortSignal;
}

/** Close part of the calendar, and say why. */
export interface CreateScheduleBlockRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ScheduleBlockCreateRequest;
  signal?: AbortSignal;
}

/** Say when a provider works. */
export interface CreateScheduleTemplateRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: TemplateCreateRequest;
  signal?: AbortSignal;
}

/** Author a tier-2 payer rule. */
export interface CreateScrubRuleRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ScrubRuleCreateRequest;
  signal?: AbortSignal;
}

/** Set a configuration value. */
export interface CreateSettingRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SettingCreateRequest;
  signal?: AbortSignal;
}

/** Define a kind of visit, and how long it takes. */
export interface CreateVisitTypeRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: VisitTypeCreateRequest;
  signal?: AbortSignal;
}

/** Stop a person signing in. */
export interface DeactivateUserRequest {
  /** Path parameters. */
  path: {
    user_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Say no to a requested time. */
export interface DeclineBookingRequestRequest {
  /** Path parameters. */
  path: {
    booking_request_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: BookingDeclineRequest;
  signal?: AbortSignal;
}

/** Remove a saved report. */
export interface DeleteReportDefinitionRequest {
  /** Path parameters. */
  path: {
    definition_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Reopen time a block had closed. */
export interface DeleteScheduleBlockRequest {
  /** Path parameters. */
  path: {
    block_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The published descriptions of payer reason codes. */
export interface DescribeReasonCodesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    code_set: "CARC" | "RARC";
    codes: string[];
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Record what the payer could not accept. */
export interface DiagnoseClaimRejectionRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
    rejection_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RejectionDiagnoseRequest;
  signal?: AbortSignal;
}

/** What changed between two schedules. */
export interface DiffFeeSchedulesRequest {
  /** Path parameters. */
  path: {
    fee_schedule_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The candidate schedule to compare against. */
    against: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Turn off your own second factor, with a current code. */
export interface DisableMfaRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: MfaCodeRequest;
  signal?: AbortSignal;
}

/** Abandon a draft plan. */
export interface DiscardCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CarePlanReasonRequest;
  signal?: AbortSignal;
}

/** Abandon a draft. */
export interface DiscardClinicalNoteRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClinicalNoteDiscardRequest;
  signal?: AbortSignal;
}

/** Stop the course of care before it completes. */
export interface DiscontinueCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CarePlanReasonRequest;
  signal?: AbortSignal;
}

/** Nothing to record in the client system. */
export interface DismissWritebackTaskRequest {
  /** Path parameters. */
  path: {
    task_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WritebackNotApplicableRequest;
  signal?: AbortSignal;
}

/** Ask a model to draft this appeal's letter. */
export interface DraftAppealLetterRequest {
  /** Path parameters. */
  path: {
    appeal_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask a model to draft the note's answers from the clinician's dictation. */
export interface DraftClinicalNoteFromDictationRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DictationRequest;
  signal?: AbortSignal;
}

/** Close a support session before it expires. */
export interface EndSupportSessionRequest {
  /** Path parameters. */
  path: {
    session_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SupportSessionEndRequest;
  signal?: AbortSignal;
}

/** Start enrolling your own second factor. */
export interface EnrolMfaRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Type a remittance from a paper EOB. */
export interface EnterRemittanceByHandRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RemittanceManualRequest;
  signal?: AbortSignal;
}

/** Evaluate the escalation ladder. */
export interface EvaluateObligationsRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EvaluationRequest;
  signal?: AbortSignal;
}

/** Sign in with Sarva: a Core token for a PMS session in one organisation. */
export interface ExchangeCoreTokenRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /** `Bearer <Sarva Core token>` for audience `pms` (declared so clients send it). */
    Authorization?: string | null;
  };
  body: CoreExchangeRequest;
  signal?: AbortSignal;
}

/** Why does this patient owe this?. */
export interface ExplainPatientBalanceRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The encounter being explained. R-PB-02 is per episode of care. */
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Download the claims worklist as CSV. */
export interface ExportClaimsCsvRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    state?: string | null;
    "state[in]"?: string | null;
    payer_id?: string | null;
    patient_id?: string | null;
    "service_date[gte]"?: string | null;
    "service_date[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Download the denial worklist as CSV. */
export interface ExportDenialsCsvRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    state?: string | null;
    "state[in]"?: string | null;
    root_cause_code?: string | null;
    payer_id?: string | null;
    "denied_on[gte]"?: string | null;
    "denied_on[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Download a month's journal as CSV. */
export interface ExportGeneralLedgerCsvRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose book to export. */
    practice_id: string;
    /** The month, as its first day — e.g. `2026-09-01`. */
    period: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Read what the note documents, quoting it for every element. */
export interface ExtractCodingDocumentationRequest {
  /** Path parameters. */
  path: {
    review_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask a model to read rates out of a payer's fee schedule. */
export interface ExtractContractRatesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RateExtractionRequest;
  signal?: AbortSignal;
}

/** Ask a model to read deadline rules out of a payer policy document. */
export interface ExtractPayerRulesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerRuleExtractRequest;
  signal?: AbortSignal;
}

/** Read a paper EOB into the structure an 835 would have carried. */
export interface ExtractRemittanceDocumentRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RemittanceDocumentRequest;
  signal?: AbortSignal;
}

/** Read a photographed or scanned superbill into proposed charge lines. */
export interface ExtractSuperbillRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SuperbillDocumentRequest;
  signal?: AbortSignal;
}

/** Which organisation a sign-in code names. */
export interface FindOrganisationRequest {
  /** Path parameters. */
  path: {
    code: string;
  };
  signal?: AbortSignal;
}

/** Get one appeal. */
export interface GetAppealRequest {
  /** Path parameters. */
  path: {
    appeal_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Which appeals win, by denial cause and payer. */
export interface GetAppealOutcomesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    decided_from?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One appointment, its history and its coverage checks. */
export interface GetAppointmentRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What a reminder link shows. */
export interface GetAppointmentReminderRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** What is outstanding, by how long it has been outstanding. */
export interface GetArAgingRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to age. Must be in the caller's scope. */
    practice_id: string;
    /** The day to measure the bands from. Defaults to today, UTC. */
    as_of?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Claims whose stored balance disagrees with the ledger. */
export interface GetBalanceDriftRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to sweep. Must be in the caller's scope. */
    practice_id: string;
    /**
     * How many claims this batch examines. The ceiling is the sweep's own batch size: an
     * unbounded sweep of a six-year table is an outage.
     */
    limit?: number;
    /** Resume after this claim id — the previous batch's `next_after_id`. */
    after_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The baseline diagnostic for one practice. */
export interface GetBaselineDiagnosticRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to report on. Must be in the caller's scope. */
    practice_id: string;
    /** Ageing is computed against this date. Defaults to today. */
    as_of?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What a practice's booking link offers. */
export interface GetBookingPageRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** A plan of care, its visits and its live certification clocks. */
export interface GetCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The plan of care as a form for a physician to sign and fax back. */
export interface GetCarePlanCertificationFormRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The plan's outcome measures, first scored note against the latest. */
export interface GetCarePlanOutcomesRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Get one claim with its lines, obligations and history. */
export interface GetClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What the prior payers did, as the next payer is told it. */
export interface GetClaimCoordinationOfBenefitsRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A clinical note, its billable time and its addenda. */
export interface GetClinicalNoteRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What a note bills, and why — a preview while it is a draft. */
export interface GetClinicalNoteChargeProposalRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A signed note, printed for the patient. */
export interface GetClinicalNoteCopyRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Everything a note documents, everything proposed from it, and every gap found. */
export interface GetCodingReviewRequest {
  /** Path parameters. */
  path: {
    review_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What was collected on a practice in a period, split new and legacy AR. */
export interface GetCollectionsStatementRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    period_from: string;
    period_to: string;
    engagement_start: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The forms a consent link opens. */
export interface GetConsentLinkRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** One day in the practice, for its owner. */
export interface GetDailyDigestRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    /** The day, practice time. */
    date?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What moved through the ledger between two dates, by kind. */
export interface GetDaySheetRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    date_from: string;
    date_to: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Get one denial. */
export interface GetDenialRequest {
  /** Path parameters. */
  path: {
    denial_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One filed document. */
export interface GetDocumentRequest {
  /** Path parameters. */
  path: {
    document_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The document itself, as it arrived. */
export interface GetDocumentContentRequest {
  /** Path parameters. */
  path: {
    document_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The partner invoice a visit was made from, with a suggestion per item. */
export interface GetEncounterSourceInvoiceRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The visit's superbill and receipt, for the patient to submit to their insurer. */
export interface GetEncounterSuperbillRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What the RCM estate can do for this deployment. */
export interface GetEstateCapabilitiesRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Liveness probe. */
export interface GetHealthRequest {
  signal?: AbortSignal;
}

/** Get one import batch and its reconciliation report. */
export interface GetImportRequest {
  /** Path parameters. */
  path: {
    import_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The form an intake link opens. */
export interface GetIntakeFormRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** Get one loss incident. */
export interface GetLossIncidentRequest {
  /** Path parameters. */
  path: {
    loss_incident_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The authenticated caller. */
export interface GetMeRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One note template and its current definition. */
export interface GetNoteTemplateRequest {
  /** Path parameters. */
  path: {
    template_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The exact definition a note was written on. */
export interface GetNoteTemplateVersionRequest {
  /** Path parameters. */
  path: {
    version_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Get one obligation. */
export interface GetObligationRequest {
  /** Path parameters. */
  path: {
    obligation_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** How is a long-running operation getting on?. */
export interface GetOperationRequest {
  /** Path parameters. */
  path: {
    operation_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One patient. */
export interface GetPatientRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Everything about one patient's account, from visits to what they owe. */
export interface GetPatientAccountRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What this patient has agreed to, and what is still true. */
export interface GetPatientConsentsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's custom fields and values. */
export interface GetPatientCustomFieldsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What this person owes, and why. */
export interface GetPatientLedgerRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The statement as a PDF, to mail or hand to the patient. */
export interface GetPatientStatementDocumentRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
    statement_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Where the patient stands against the practice's threshold rules. */
export interface GetPatientThresholdsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    care_plan_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One payer, with its ids, addresses and contact details. */
export interface GetPayerRequest {
  /** Path parameters. */
  path: {
    payer_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** How each payer treats this practice: speed, denials, underpayment. */
export interface GetPayerScorecardRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    decided_from?: string | null;
    /** Exclusive. */
    decided_to?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Does this month tie?. */
export interface GetPeriodReconciliationRequest {
  /** Path parameters. */
  path: {
    /** The month, as its first day — e.g. `2026-09-01`. */
    period: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose book to read. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The plan of care a sign-off link opens. */
export interface GetPlanSignoffRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  signal?: AbortSignal;
}

/** What a posting run did. */
export interface GetPostingRunRequest {
  /** Path parameters. */
  path: {
    posting_run_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Get one practice. */
export interface GetPracticeRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A practice's visits, attendance, charges, packages and patient balances. */
export interface GetPracticeActivityRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to report on. */
    practice_id: string;
    from?: string | null;
    to?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One authorization, and every claim that has drawn on it. */
export interface GetPriorAuthorizationRequest {
  /** Path parameters. */
  path: {
    prior_auth_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Queue depth, age distribution and whether each queue is being kept up with. */
export interface GetQueueHealthRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Restrict to one practice's items. Omitted, the queue spans the tenant. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Codes billed with no agreed rate, and where the charge master is too low. */
export interface GetRateCoverageRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to examine. Must be in the caller's scope. */
    practice_id: string;
    /** Count lines serviced on or after this day. Defaults to a year back. */
    since?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Get one remittance. */
export interface GetRemittanceRequest {
  /** Path parameters. */
  path: {
    remittance_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The customer scoreboard for one practice and month. */
export interface GetScoreboardRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to report on. Must be in the caller's scope. */
    practice_id: string;
    /** The month, named by its first day — e.g. `2026-08-01`. */
    period: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One superbill reading, with every line and its validation. */
export interface GetSuperbillExtractionRequest {
  /** Path parameters. */
  path: {
    extraction_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Whether the hourly job finished recently. */
export interface GetSweepHealthRequest {
  signal?: AbortSignal;
}

/** Money received and not yet applied, by how long it has sat. */
export interface GetUnappliedCashRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    as_of?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What the patient owes for this visit at the desk. */
export interface GetVisitCheckoutRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Get one work item. */
export interface GetWorkItemRequest {
  /** Path parameters. */
  path: {
    work_item_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Hold or release one line of a batch. */
export interface HoldChargeRequest {
  /** Path parameters. */
  path: {
    charge_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeHoldRequest;
  signal?: AbortSignal;
}

/** Load a BAI2 bank statement and reconcile it. */
export interface ImportBankStatementRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: BankStatementImportRequest;
  signal?: AbortSignal;
}

/** Ingest an 835 file. */
export interface IngestRemittanceRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RemittanceIngestRequest;
  signal?: AbortSignal;
}

/** Install or update a specialty pack into a practice — or plan it. */
export interface InstallSpecialtyPackRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
    /** The pack's key. */
    pack_key: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PackInstallRequest;
  signal?: AbortSignal;
}

/** Turn a partner's point-of-sale invoice into a visit. */
export interface IntakeSourceInvoiceRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SourceInvoiceIntakeRequest;
  signal?: AbortSignal;
}

/** Add a person to this tenant. */
export interface InviteUserRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: UserCreateRequest;
  signal?: AbortSignal;
}

/** Sign a sibling Sarva product in, as its own service identity. */
export interface IssueClientTokenRequest {
  body: ClientTokenRequest;
  signal?: AbortSignal;
}

/** Record that the refund was sent, and move the ledger. */
export interface IssueRefundRequest {
  /** Path parameters. */
  path: {
    refund_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RefundIssueRequest;
  signal?: AbortSignal;
}

/** Sign in with an email, a password and, where enrolled, a code. */
export interface IssueTokenRequest {
  body: TokenRequest;
  signal?: AbortSignal;
}

/** Exchange a partner's signed launch assertion for a session. */
export interface LaunchSessionRequest {
  body: LaunchRequest;
  signal?: AbortSignal;
}

/** Book this visit under an authorization, or clear the one on it. */
export interface LinkAppointmentAuthorizationRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppointmentPriorAuthRequest;
  signal?: AbortSignal;
}

/** Record which RCM-estate practice this practice is. */
export interface LinkPracticeToHubRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PracticeHubLinkRequest;
  signal?: AbortSignal;
}

/** Months this practice has closed. */
export interface ListAccountingPeriodsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose book to read. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Adjustments, and which are waiting for a second party. */
export interface ListAdjustmentsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    /** Only those awaiting approval. */
    pending?: boolean | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Drafted letters awaiting a person's approval. */
export interface ListAppealLetterSuggestionsRequest {
  /** Path parameters. */
  path: {
    appeal_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List appeals. */
export interface ListAppealsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-amount_appealed`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    denial_id?: string | null;
    claim_id?: string | null;
    appeal_level?: string | null;
    outcome?: string | null;
    practice_id?: string | null;
    patient_id?: string | null;
    /**
     * At least 2 characters, case-insensitive: a claim number or MRN by prefix, or a patient's
     * name with every word somewhere in it (D245).
     */
    search?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** One day's schedule, for a practice or for one provider. */
export interface ListAppointmentsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice whose day this is. */
    practice_id: string;
    /** The calendar date, practice time. */
    service_date: string;
    /** Narrow to one provider. */
    provider_id?: string | null;
    /** Narrow to one location. */
    location_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Which upcoming visits are owed a coverage check (what an external scheduler calls). */
export interface ListAppointmentsDueEligibilityRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice to sweep. */
    practice_id: string;
    /** The day to answer for. Defaults to today, UTC. */
    as_of?: string | null;
    /** Last service date to consider. Defaults to 31 days. */
    through?: string | null;
    /**
     * How far ahead the pre-visit check runs, in business days. The cadence belongs to whoever
     * runs the schedule, so it is yours to choose.
     */
    lead_business_days?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What was changed, by whom, and why. */
export interface ListAuditEntriesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-sequence_no`. */
    sort?: string | null;
    actor_id?: string | null;
    action?: string | null;
    resource_type?: string | null;
    resource_id?: string | null;
    practice_id?: string | null;
    "occurred_at[gte]"?: string | null;
    "occurred_at[lte]"?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Proposed benefit normalisations awaiting a person's answer. */
export interface ListBenefitSuggestionsRequest {
  /** Path parameters. */
  path: {
    response_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** When this provider can be booked, for this kind of visit. */
export interface ListBookableSlotsRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    service_date: string;
    visit_type_id?: string | null;
    location_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Times patients asked for through the practice's booking link. */
export interface ListBookingRequestsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    state?: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Open times for one visit type with one clinician on one day. */
export interface ListBookingSlotsRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    visit_type_id: string;
    provider_id: string;
    date: string;
    location_id?: string | null;
  };
  signal?: AbortSignal;
}

/** The sign-off requests sent for a plan, and their answers. */
export interface ListCarePlanSignoffsRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Charge batches, so the release control does not take a pasted UUID. */
export interface ListChargeBatchesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `batch_number`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    batch_number?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The rules that propose modifiers, raise follow-ups and hold charges. */
export interface ListChargeRulesRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Charges across encounters — the billing worklist. */
export interface ListChargesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-total_charge_amount`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    encounter_id?: string | null;
    charge_batch_id?: string | null;
    /** R-CC-04's per-line hold — lines waiting on a person. */
    is_held?: boolean | null;
    procedure_code?: string | null;
    "service_date[gte]"?: string | null;
    "service_date[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The superbills this practice bills from. */
export interface ListChargeTemplatesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose shortlist to read. */
    practice_id: string;
    /** Put this provider's own favourites first. */
    provider_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Every acknowledgement received for this claim, newest first. */
export interface ListClaimAcknowledgementsRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Acknowledgements that still need somebody, across claims. */
export interface ListClaimAcknowledgementsAcrossClaimsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-received_at`. */
    sort?: string | null;
    claim_id?: string | null;
    claim_submission_id?: string | null;
    acknowledgement_type?: string | null;
    disposition?: string | null;
    repair_disposition?: string | null;
    repair_class?: string | null;
    /** Only the repairs [D102] says this system may not make on its own. */
    needs_a_person?: boolean | null;
    is_repaired?: boolean | null;
    unmatched?: boolean | null;
    "received_at[gte]"?: string | null;
    "received_at[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The denial-prevention proposals a model made for this claim. */
export interface ListClaimAiSuggestionsRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What has been tried on this claim, and what was said. */
export interface ListClaimFollowUpNotesRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Every time this claim was handed back without being adjudicated. */
export interface ListClaimRejectionsRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List claims. */
export interface ListClaimsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-balance_amount`. */
    sort?: string | null;
    /**
     * Up to 20 claim ids, comma separated. Lets a screen holding claim ids — a denial
     * worklist, for one — resolve their claim numbers in a single request.
     */
    "id[in]"?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    /**
     * The claim a replacement replaces. Answers 'has this claim been corrected, and where did
     * the correction go?' from the original's end — `:correct` writes the link on the
     * replacement, so without this the original is a dead end.
     */
    original_claim_id?: string | null;
    payer_id?: string | null;
    patient_id?: string | null;
    claim_number?: string | null;
    cob_sequence?: string | null;
    "service_date[gte]"?: string | null;
    "service_date[lte]"?: string | null;
    practice_id?: string | null;
    /**
     * At least 2 characters, case-insensitive: a claim number or MRN by prefix, or a patient's
     * name with every word somewhere in it (D245).
     */
    search?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The NCCI findings a biller has overridden on this claim, and why. */
export interface ListClaimScrubOverridesRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What the scrubber said about this claim. */
export interface ListClaimScrubResultsRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** This claim's status history, and what it adds up to. */
export interface ListClaimStatusChecksRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Every attempt at filing this claim, newest first. */
export interface ListClaimSubmissionsRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Every filing attempt that still needs somebody, across claims. */
export interface ListClaimSubmissionsAcrossClaimsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-reserved_at`. */
    sort?: string | null;
    /** Only attempts whose outcome nobody knows, which need a person. */
    needs_reconciliation?: boolean | null;
    /** Only attempts that stop the claim being filed again. */
    blocks_another_attempt?: boolean | null;
    /** One submission state. */
    state?: string | null;
    "state[in]"?: string | null;
    /** Narrow to one practice. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The drafts and documentation checks a model produced for this note. */
export interface ListClinicalNoteAiSuggestionsRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Named sets of procedure codes the practice's charge rules test. */
export interface ListCodeGroupsRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Which code sets are loaded, and which edition governs a date. */
export interface ListCodeSetsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Which date to resolve the governing edition for. Defaults to today. */
    service_date?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Accounts with an agency. */
export interface ListCollectionPlacementsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice whose accounts to list. */
    practice_id: string;
    /** Only accounts still with an agency. Defaults to true. */
    open_only?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A practice's consent forms. */
export interface ListConsentFormsRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    include_retired?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Starter consent texts a practice may begin from. */
export interface ListConsentFormTemplatesRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The consent links sent to a patient. */
export interface ListConsentRequestsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Money the practice holds that belongs to a patient or a payer. */
export interface ListCreditBalancesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The custom fields this organisation records on patients. */
export interface ListCustomFieldsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    include_retired?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** AI suggestions awaiting review on a denial. */
export interface ListDenialAiSuggestionsRequest {
  /** Path parameters. */
  path: {
    denial_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List denials. */
export interface ListDenialsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-denied_amount`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    root_cause_code?: string | null;
    "root_cause_code[in]"?: string | null;
    is_classified?: boolean | null;
    resolution_path?: string | null;
    payer_id?: string | null;
    claim_id?: string | null;
    primary_carc?: string | null;
    "denied_on[gte]"?: string | null;
    "denied_on[lte]"?: string | null;
    practice_id?: string | null;
    patient_id?: string | null;
    /**
     * At least 2 characters, case-insensitive: a claim number or MRN by prefix, or a patient's
     * name with every word somewhere in it (D245).
     */
    search?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Documents this practice has had classified, awaiting a person's answer. */
export interface ListDocumentClassificationsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice whose post to read. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A practice's filed documents — newest first, and the quarantined pile on request. */
export interface ListDocumentsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice whose post to read. */
    practice_id: string;
    /**
     * Keep only these statuses. Repeat the parameter to ask for more than one — `unmatched`
     * and `quarantined` together are the work queue.
     */
    match_status?: MatchStatus[] | null;
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What was promised for today, across every account. */
export interface ListDueFollowUpNotesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    /** The working day being asked about, in the practice's zone. */
    on_or_before?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Patients who look registered twice. */
export interface ListDuplicatePatientsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Recent transactional email and whether it went out. */
export interface ListEmailOutboxRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    status?: string | null;
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Charges on an encounter. */
export interface ListEncounterChargesRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The notes documenting one visit. */
export interface ListEncounterClinicalNotesRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Visits, and which of them nobody has coded. */
export interface ListEncountersRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-service_date`. */
    sort?: string | null;
    /** One visit, so charge capture can open on it (D244). */
    id?: string | null;
    /** Up to 20 visit ids, comma separated. */
    "id[in]"?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    patient_id?: string | null;
    rendering_provider_id?: string | null;
    location_id?: string | null;
    /**
     * `false` is the uncoded worklist, asked of the charges rather than of the encounter's own
     * state.
     */
    has_charges?: boolean | null;
    service_date?: string | null;
    "service_date[gte]"?: string | null;
    "service_date[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The rates on one schedule. */
export interface ListFeeScheduleLinesRequest {
  /** Path parameters. */
  path: {
    fee_schedule_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Exact procedure code. Omit for the whole sheet. */
    procedure_code?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Fee schedules on file. */
export interface ListFeeSchedulesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Narrow to one practice. Tenant-wide schedules are still included. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Proposed column mappings awaiting a person's answer. */
export interface ListImportMappingSuggestionsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice whose proposals to read. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List import batches. */
export interface ListImportsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-staged_at`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    source_system?: string | null;
    accounting_period?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What a model read off this patient's insurance card. */
export interface ListInsuranceCardReadingsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The intake forms a practice can send. */
export interface ListIntakeFormsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The intake links sent to a patient. */
export interface ListIntakeInvitationsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Where this practice delivers care. */
export interface ListLocationsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    /** `active` narrows to bookable sites. */
    status?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List loss incidents. */
export interface ListLossIncidentsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-amount_lost`. */
    sort?: string | null;
    obligation_type?: string | null;
    "obligation_type[in]"?: string | null;
    subject_type?: string | null;
    subject_id?: string | null;
    "occurred_on[gte]"?: string | null;
    "occurred_on[lte]"?: string | null;
    was_platform_fault?: boolean | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Assistants' notes waiting for a co-signature. */
export interface ListNotesAwaitingCosignatureRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The note templates a practice writes on. */
export interface ListNoteTemplatesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Include this practice's own. */
    practice_id?: string | null;
    /** Only this purpose. */
    purpose?: ClinicalNotePurpose | null;
    /** Retired templates too. */
    include_retired?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List obligations. */
export interface ListObligationsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-amount_at_risk,due_date`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    obligation_type?: string | null;
    "obligation_type[in]"?: string | null;
    escalation_band?: string | null;
    "escalation_band[gte]"?: string | null;
    "due_date[gte]"?: string | null;
    "due_date[lte]"?: string | null;
    subject_type?: string | null;
    subject_id?: string | null;
    is_assumed?: boolean | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The prepaid packages a practice sells. */
export interface ListPackagePlansRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The packages a person taking a payment may sell. */
export interface ListPackagePlansOnSaleRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The courses of care this patient is booked into. */
export interface ListPatientAppointmentSeriesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's plans of care, newest first. */
export interface ListPatientCarePlansRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's notes, newest first. */
export interface ListPatientClinicalNotesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's policies, primary first. */
export interface ListPatientCoveragesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What this patient has been asked about, and what came back. */
export interface ListPatientEligibilityChecksRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Estimates given to this patient. */
export interface ListPatientEstimatesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Model-proposed wordings of this encounter's balance explanation. */
export interface ListPatientExplanationSuggestionsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The encounter being explained. R-PB-02 is per episode of care. */
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What the EHR sent that differs from this patient's record. */
export interface ListPatientFeedConflictsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What this person has been told, and what was promised. */
export interface ListPatientFollowUpNotesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Who is financially responsible for this patient. */
export interface ListPatientGuarantorsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's prepaid packages. */
export interface ListPatientPackagesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Every authorization a patient holds, with what is left of each. */
export interface ListPatientPriorAuthorizationsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The referrals this patient holds. */
export interface ListPatientReferralsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Find a patient by name, date of birth or a local identifier. */
export interface ListPatientsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-created_at`. */
    sort?: string | null;
    /**
     * Up to 20 patient ids, comma separated. Returns exactly those patients, so a screen
     * holding ids can name the people on it in one request.
     */
    "id[in]"?: string | null;
    /** Every word must appear in the name, in any order. At least 2 characters. */
    name?: string | null;
    /** An exact date, ISO format. Narrows the search; never appears in the response. */
    date_of_birth?: string | null;
    mrn?: string | null;
    external_patient_id?: string | null;
    /** One of active, inactive, merged, deceased. */
    status?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Patients who owe the practice, largest balance first. */
export interface ListPatientsOwingRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    min_balance?: number | string;
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Statements sent to this patient. */
export interface ListPatientStatementsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's visits, newest first, to choose one from. */
export interface ListPatientVisitChoicesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Calls asked of Voice for this patient, newest first. */
export interface ListPatientVoiceCallsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What calls with this patient achieved, newest first. */
export interface ListPatientVoiceOutcomesRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** When each payer requires an authorization. */
export interface ListPayerAuthRequirementsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    payer_id?: string | null;
    procedure_code?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The payers a patient's insurance can be recorded against, by name. */
export interface ListPayerChoicesRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Payer deadline rules on file. */
export interface ListPayerRulesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** `proposed`, `active`, `superseded` or `rejected`. */
    state?: string | null;
    /** Narrow to one practice's own rules. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The payers this practice bills, and which of them can be billed electronically. */
export interface ListPayersRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** `false` returns only the payers that cannot be billed electronically. */
    edi_ready?: boolean | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A patient's payment plans and where each stands. */
export interface ListPaymentPlansRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Plans of care whose certification is still unsigned, soonest due first. */
export interface ListPlansAwaitingCertificationRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The autonomy bands on file, every version. */
export interface ListPolicyBandsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Narrow to one process, e.g. `remittance_posting`. */
    process_key?: string | null;
    /** Narrow to one practice's own bands. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The committed runs against this deposit. */
export interface ListPostingRunsRequest {
  /** Path parameters. */
  path: {
    remittance_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List practices. */
export interface ListPracticesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-created_at,code`. */
    sort?: string | null;
    status?: string | null;
    "status[in]"?: string | null;
    code?: string | null;
    "code[contains]"?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Authorizations across patients — what is about to expire, and what nobody chased. */
export interface ListPriorAuthorizationsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-valid_to`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    patient_id?: string | null;
    payer_id?: string | null;
    coverage_id?: string | null;
    provider_id?: string | null;
    auth_number?: string | null;
    "valid_to[gte]"?: string | null;
    /** The expiry threshold. Yours, not the system's — see the note above. */
    "valid_to[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Which procedures are timed, their unit length and the practice's own labels. */
export interface ListProcedureAttributesRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The practice's billable codes, by label, for a note's billable time. */
export interface ListProcedureCodeChoicesRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The clinicians a visit can be booked with, by name. */
export interface ListProviderChoicesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A provider's payer enrollments. */
export interface ListProviderEnrollmentsRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Narrow to one practice. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** A provider's identifiers. */
export interface ListProviderIdentifiersRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The provider roster. */
export interface ListProvidersRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-last_name`. */
    sort?: string | null;
    /** Every word must appear in the name, in any order. At least 2 chars. */
    name?: string | null;
    /** `active` or `inactive`. */
    status?: string | null;
    /** `individual` or `organization`. */
    provider_type?: string | null;
    /** Exact match. */
    individual_npi?: string | null;
    primary_taxonomy_code?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Rates a model proposed, for review. */
export interface ListRateSuggestionsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Exactly the rows one extraction run produced. */
    operation_id?: string | null;
    /** Everything proposed for this payer, newest first. */
    payer_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Referrals running out. */
export interface ListReferralsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose book to read. */
    practice_id: string;
    /** Only referrals that stop covering care by this day. */
    expiring_before?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Refunds on this practice's books. */
export interface ListRefundsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose book to read. */
    practice_id: string;
    /** Narrow to these workflow states. */
    state?: string[] | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Paper EOBs read into structure, awaiting a person's answer. */
export interface ListRemittanceExtractionsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice whose EOBs to read. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List remittances. */
export interface ListRemittancesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `-total_payment_amount`. */
    sort?: string | null;
    state?: string | null;
    "state[in]"?: string | null;
    reconciliation_state?: string | null;
    payer_id?: string | null;
    check_or_eft_number?: string | null;
    "payment_date[gte]"?: string | null;
    "payment_date[lte]"?: string | null;
    practice_id?: string | null;
    /**
     * At least 2 characters, case-insensitive: a check/EFT number or claim number by prefix, a
     * patient's MRN by prefix, or a patient's name with every word in it — through the claims
     * the remittance paid (D258).
     */
    search?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Saved reports. */
export interface ListReportDefinitionsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Narrow to one practice. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What one person has been granted, and what they used to have. */
export interface ListRoleGrantsRequest {
  /** Path parameters. */
  path: {
    user_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Include grants that have been revoked. */
    include_revoked?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The roles this tenant may grant. */
export interface ListRolesRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** When the calendar is closed, despite the rota. */
export interface ListScheduleBlocksRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    provider_id?: string | null;
    from?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** When each provider works. */
export interface ListScheduleTemplatesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    provider_id?: string | null;
    status?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Tier-2 scrub rules on file. */
export interface ListScrubRulesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** `draft`, `shadow`, `active`, `disabled` or `superseded`. */
    state?: string | null;
    /** Narrow to one practice's own rules. */
    practice_id?: string | null;
    /** Narrow to one payer's rules. */
    payer_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What this practice's partner services mean in billing terms. */
export interface ListServiceMappingsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose mapping to read. */
    practice_id: string;
    /** Narrow to one partner, e.g. the source system key. */
    source_system?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What may be configured, and which permission each setting needs. */
export interface ListSettingDefinitionsRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Configuration, every version, with who changed it and why. */
export interface ListSettingsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Narrow to one setting. */
    setting_key?: string | null;
    /** Narrow to one practice's own overrides. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The specialty packs this product ships, and which a practice has installed. */
export interface ListSpecialtyPacksRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Report this practice's installs. */
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Superbills read against this encounter, newest first. */
export interface ListSuperbillExtractionsRequest {
  /** Path parameters. */
  path: {
    encounter_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Who from Sarva has been in this tenant's data, and why. */
export interface ListSupportSessionsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Only sessions that have not ended or expired. */
    active_only?: boolean;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What the hourly job did for a practice, newest first. */
export interface ListSweepRunsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** How each payer turns minutes into units, and the practice default. */
export interface ListUnitMethodsRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Deposits nothing explains. */
export interface ListUnmatchedBankDepositsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose book to read. */
    practice_id: string;
    /** Only deposits posted on or after this day. */
    since?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The people in this tenant. */
export interface ListUsersRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** `invited`, `active`, `suspended`, `deactivated`. */
    status?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What kinds of visit this practice books, and how long each takes. */
export interface ListVisitTypesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    status?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Booked visits in a window, for the voice agent's reminder calls. */
export interface ListVoiceAppointmentsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    date_from: string;
    date_to: string;
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Patients who owe at least an amount, for the voice agent's balance calls. */
export interface ListVoiceBalancesRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    min_balance?: number | string;
    limit?: number;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Patients waiting for a visit, longest-waiting first. */
export interface ListWaitlistRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** List work items. */
export interface ListWorkItemsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Page size. Default 50, maximum 200. */
    limit?: number | null;
    /** Opaque cursor from a previous page. */
    cursor?: string | null;
    /** e.g. `due_at,-priority_score`. */
    sort?: string | null;
    work_queue_id?: string | null;
    assigned_actor_id?: string | null;
    unassigned?: boolean | null;
    state?: string | null;
    "state[in]"?: string | null;
    work_item_type?: string | null;
    "priority_score[gte]"?: string | null;
    subject_type?: string | null;
    subject_id?: string | null;
    obligation_id?: string | null;
    "due_at[lte]"?: string | null;
    practice_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** What still has to be recorded in the client system. */
export interface ListWritebackTasksRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id: string;
    state?: WritebackState[] | null;
    claim_id?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Take a signed note off the record — kept, never billed. */
export interface MarkClinicalNoteEnteredInErrorRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClinicalNoteEnterInErrorRequest;
  signal?: AbortSignal;
}

/** Retire a patient record that should never have existed. */
export interface MarkPatientEnteredInErrorRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EnteredInErrorRequest;
  signal?: AbortSignal;
}

/** Merge a duplicate into this patient. */
export interface MergePatientRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientMergeRequest;
  signal?: AbortSignal;
}

/** Read a payer's benefit lines into structured benefits. */
export interface NormaliseEligibilityBenefitsRequest {
  /** Path parameters. */
  path: {
    response_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Present a clinical note for coding, against the encounter it documents. */
export interface OpenCodingReviewRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CodingReviewCreateRequest;
  signal?: AbortSignal;
}

/** Record why a line an NCCI edit flags should go anyway. */
export interface OverrideClaimScrubFindingRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ScrubOverrideRequest;
  signal?: AbortSignal;
}

/** Stop an agent acting under this band, now. */
export interface PausePolicyBandRequest {
  /** Path parameters. */
  path: {
    band_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PolicyBandPauseRequest;
  signal?: AbortSignal;
}

/** Hand an account to a collections agency. */
export interface PlaceAccountWithAgencyRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PlacementCreateRequest;
  signal?: AbortSignal;
}

/** Run a posting run through the reconciliation gate. */
export interface PostRemittanceRequest {
  /** Path parameters. */
  path: {
    remittance_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RemittancePostRequest;
  signal?: AbortSignal;
}

/** Compute a practice's scoreboard for a month. */
export interface ProjectScoreboardRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ScoreboardProjectionRequest;
  signal?: AbortSignal;
}

/** Make a proposed rule govern deadlines. */
export interface PromotePayerRuleRequest {
  /** Path parameters. */
  path: {
    rule_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Let a tier-2 rule start stopping claims. */
export interface PromoteScrubRuleRequest {
  /** Path parameters. */
  path: {
    rule_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Save a new version of the practice's form for one consent type. */
export interface PublishConsentFormRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ConsentFormCreateRequest;
  signal?: AbortSignal;
}

/** Sell a prepaid package to a patient. */
export interface PurchasePatientPackageRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientPackagePurchaseRequest;
  signal?: AbortSignal;
}

/** What this patient is expected to owe, from the payer's own benefits. */
export interface QuotePatientEstimateRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Whose contracted rates price the service. */
    practice_id: string;
    /** The CPT/HCPCS being quoted. */
    procedure_code: string;
    /** Which schedule edition and which benefit year apply. */
    date_of_service: string;
    units?: number;
    /**
     * Narrows which benefit lines apply where the payer broke them out. Omitted, lines
     * carrying no service type are used — which is how most copays arrive.
     */
    service_type_code?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Raise an appeal candidate for each payer downcode. */
export interface RaiseDowncodeAppealsRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CandidateRequest;
  signal?: AbortSignal;
}

/** Raise a deadline for every fee schedule that needs looking at. */
export interface RaiseFeeScheduleReviewsRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    practice_id?: string | null;
    /** The working day being asked about, in the practice's zone. */
    today?: string | null;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Raise a challenge for each recorded underpayment. */
export interface RaiseUnderpaymentChallengesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CandidateRequest;
  signal?: AbortSignal;
}

/** Ask a model to read an insurance card. */
export interface ReadInsuranceCardRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: InsuranceCardReadRequest;
  signal?: AbortSignal;
}

/** Sarva Core tells the PMS who may act here, and as what. */
export interface ReceiveCoreProvisioningRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /** `Bearer <Sarva Core token>` for audience `pms` (declared so clients send it). */
    Authorization?: string | null;
  };
  body: ProvisioningEvent;
  signal?: AbortSignal;
}

/** Receive a notification pushed by the RCM estate. */
export interface ReceiveHubWebhookRequest {
  /** Path parameters. */
  path: {
    tenant_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    "X-Sarva-Signature"?: string | null;
  };
  signal?: AbortSignal;
}

/** Receive patients and coverage from an EHR's ongoing feed. */
export interface ReceivePatientFeedRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientFeedRequest;
  signal?: AbortSignal;
}

/** Raise the receivable for charges that have none. */
export interface RecogniseChargeRevenueRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RevenueRecognitionRequest;
  signal?: AbortSignal;
}

/** Record whether an unresolved submission reached the payer. */
export interface ReconcileClaimSubmissionRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
    submission_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimSubmissionReconcileRequest;
  signal?: AbortSignal;
}

/** Raise a work item for every unbilled completed encounter. */
export interface ReconcileEncounterChargesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EncounterReconcileRequest;
  signal?: AbortSignal;
}

/** Reconcile estimates and open refund obligations. */
export interface ReconcilePatientEstimatesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ReconciliationSweepRequest;
  signal?: AbortSignal;
}

/** Record the payer's determination on a submitted appeal. */
export interface RecordAppealOutcomeRequest {
  /** Path parameters. */
  path: {
    appeal_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppealOutcomeRecordRequest;
  signal?: AbortSignal;
}

/** The patient is here. */
export interface RecordAppointmentArrivalRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Service was delivered. */
export interface RecordAppointmentCompletionRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** The patient did not attend and did not tell us. */
export interface RecordAppointmentNoShowRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Record a 999 or 277CA and match it to the attempt that produced it. */
export interface RecordClaimAcknowledgementRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AcknowledgementRecordRequest;
  signal?: AbortSignal;
}

/** Record that this claim was filed by portal, paper or fax. */
export interface RecordClaimFilingRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimFilingRequest;
  signal?: AbortSignal;
}

/** Write down what was tried, or what the payer said. */
export interface RecordClaimFollowUpNoteRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FollowUpNoteCreateRequest;
  signal?: AbortSignal;
}

/** Record that the payer confirmed it has this claim. */
export interface RecordClaimReceiptRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimReceiptRequest;
  signal?: AbortSignal;
}

/** Record what a payer said about this claim. */
export interface RecordClaimStatusCheckRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimStatusRecordRequest;
  signal?: AbortSignal;
}

/** Record eligibility a person verified by phone or on the payer's portal. */
export interface RecordEligibilityVerificationRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EligibilityVerificationRequest;
  signal?: AbortSignal;
}

/** Record what the patient said. */
export interface RecordPatientConsentRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ConsentRecordRequest;
  signal?: AbortSignal;
}

/** Write down a conversation about this account. */
export interface RecordPatientFollowUpNoteRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: FollowUpNoteCreateRequest;
  signal?: AbortSignal;
}

/** Record what happened to a placed account. */
export interface RecordPlacementEventRequest {
  /** Path parameters. */
  path: {
    placement_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PlacementEventRequest;
  signal?: AbortSignal;
}

/** Open an authorization record for a service. */
export interface RecordPriorAuthorizationRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PriorAuthCreateRequest;
  signal?: AbortSignal;
}

/** Record what the payer determined. */
export interface RecordPriorAuthorizationDecisionRequest {
  /** Path parameters. */
  path: {
    prior_auth_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PriorAuthDecisionRequest;
  signal?: AbortSignal;
}

/** Record a referral the PCP issued. */
export interface RecordReferralRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ReferralRequest;
  signal?: AbortSignal;
}

/** Trade a live session for a fresh access token. */
export interface RefreshTokenRequest {
  /** Request headers declared by this operation. */
  headers?: {
    "X-Sarva-Tenant-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Register a patient. */
export interface RegisterPatientRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientRegisterRequest;
  signal?: AbortSignal;
}

/** Refuse a proposed rule. */
export interface RejectPayerRuleRequest {
  /** Path parameters. */
  path: {
    rule_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerRuleRejectRequest;
  signal?: AbortSignal;
}

/** Discard an AI reading of a paper EOB. */
export interface RejectRemittanceExtractionRequest {
  /** Path parameters. */
  path: {
    extraction_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RemittanceExtractionRejectRequest;
  signal?: AbortSignal;
}

/** Review and release a batch. */
export interface ReleaseChargeBatchRequest {
  /** Path parameters. */
  path: {
    batch_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Take a patient off the waitlist, with the reason. */
export interface RemoveWaitlistEntryRequest {
  /** Path parameters. */
  path: {
    entry_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WaitlistRemoveRequest;
  signal?: AbortSignal;
}

/** The claim as a printable CMS-1500. */
export interface RenderCms1500Request {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Take a closed claim back, because the payer came back. */
export interface ReopenClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimClosureRequest;
  signal?: AbortSignal;
}

/** Correct the one element this system generated and file the claim again. */
export interface RepairAndResubmitClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
    acknowledgement_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Record the services provided and the minutes on each. */
export interface ReplaceClinicalNoteTimeEntriesRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: NoteTimeEntriesRequest;
  signal?: AbortSignal;
}

/** Ask to write an amount off. */
export interface RequestAdjustmentRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AdjustmentRequestBody;
  signal?: AbortSignal;
}

/** Ask Voice to remind the patient of this visit. */
export interface RequestAppointmentVoiceCallRequest {
  /** Path parameters. */
  path: {
    appointment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask Voice to call the patient about their balance. */
export interface RequestBalanceVoiceCallRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask the practice for a time. */
export interface RequestBookingRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  body: BookingRequestCreate;
  signal?: AbortSignal;
}

/** Email a password-reset link. */
export interface RequestPasswordResetRequest {
  body: PasswordResetAsk;
  signal?: AbortSignal;
}

/** Ask Voice to call the payer about this claim. */
export interface RequestPayerVoiceCallRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Request a refund. */
export interface RequestRefundRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: RefundRequest;
  signal?: AbortSignal;
}

/** Set a new password from an emailed link. */
export interface ResetPasswordRequest {
  body: PasswordResetSubmission;
  signal?: AbortSignal;
}

/** Clear another user's second factor when they are locked out. */
export interface ResetUserMfaRequest {
  /** Path parameters. */
  path: {
    user_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Set a denial's resolution path. */
export interface ResolveDenialRequest {
  /** Path parameters. */
  path: {
    denial_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DenialResolveRequest;
  signal?: AbortSignal;
}

/** Resolve an obligation. */
export interface ResolveObligationRequest {
  /** Path parameters. */
  path: {
    obligation_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ObligationResolveRequest;
  signal?: AbortSignal;
}

/** Record which clearinghouse payer this payer is. */
export interface ResolvePayerToDirectoryRequest {
  /** Path parameters. */
  path: {
    payer_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerResolveRequest;
  signal?: AbortSignal;
}

/** Resolve a work item. */
export interface ResolveWorkItemRequest {
  /** Path parameters. */
  path: {
    work_item_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: WorkItemResolveRequest;
  signal?: AbortSignal;
}

/** Let an agent act under this band again. */
export interface ResumePolicyBandRequest {
  /** Path parameters. */
  path: {
    band_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Stop sending a form. */
export interface RetireConsentFormRequest {
  /** Path parameters. */
  path: {
    form_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Stop recording a custom field. */
export interface RetireCustomFieldRequest {
  /** Path parameters. */
  path: {
    field_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Stop offering a template. */
export interface RetireNoteTemplateRequest {
  /** Path parameters. */
  path: {
    template_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Send a failed or stuck email again. */
export interface RetryEmailOutboxMessageRequest {
  /** Path parameters. */
  path: {
    message_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Take back a payment taken from a patient. */
export interface ReversePatientPaymentRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
    payment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientPaymentReverseRequest;
  signal?: AbortSignal;
}

/** Take a committed posting back. */
export interface ReversePostingRunRequest {
  /** Path parameters. */
  path: {
    posting_run_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PostingReversalRequest;
  signal?: AbortSignal;
}

/** Restore an earlier configuration value. */
export interface RevertSettingRequest {
  /** Path parameters. */
  path: {
    setting_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SettingRevertRequest;
  signal?: AbortSignal;
}

/** Accept or reject an AI suggestion on a claim. */
export interface ReviewClaimAiSuggestionRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
    suggestion_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimSuggestionReviewRequest;
  signal?: AbortSignal;
}

/** Answer a draft or a documentation check. */
export interface ReviewClinicalNoteAiSuggestionRequest {
  /** Path parameters. */
  path: {
    note_id: string;
    suggestion_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: NoteSuggestionReviewRequest;
  signal?: AbortSignal;
}

/** A coder answers one proposed code. */
export interface ReviewCodingProposalRequest {
  /** Path parameters. */
  path: {
    proposal_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CodingProposalReviewRequest;
  signal?: AbortSignal;
}

/** Answer an AI suggestion: accept, correct or reject it. */
export interface ReviewDenialAiSuggestionRequest {
  /** Path parameters. */
  path: {
    denial_id: string;
    suggestion_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SuggestionReviewRequest;
  signal?: AbortSignal;
}

/** Answer a proposed classification: accept it, correct the type, or reject it. */
export interface ReviewDocumentClassificationRequest {
  /** Path parameters. */
  path: {
    suggestion_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DocumentClassificationReviewRequest;
  signal?: AbortSignal;
}

/** Accept, correct or reject a proposed column mapping. */
export interface ReviewImportMappingRequest {
  /** Path parameters. */
  path: {
    suggestion_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ImportMappingReviewRequest;
  signal?: AbortSignal;
}

/** Answer a proposed wording. */
export interface ReviewPatientExplanationSuggestionRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
    suggestion_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ExplanationReviewRequest;
  signal?: AbortSignal;
}

/** Answer every line of a superbill and create charges from the ones taken. */
export interface ReviewSuperbillExtractionRequest {
  /** Path parameters. */
  path: {
    extraction_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SuperbillExtractionReviewRequest;
  signal?: AbortSignal;
}

/** Make an unanswered sign-off link stop working. */
export interface RevokeCarePlanSignoffRequest {
  /** Path parameters. */
  path: {
    signoff_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Withdraw a consent link before it is used. */
export interface RevokeConsentRequestRequest {
  /** Path parameters. */
  path: {
    request_row_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Make an unused intake link stop working. */
export interface RevokeIntakeInvitationRequest {
  /** Path parameters. */
  path: {
    invitation_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Take a role away. */
export interface RevokeRoleGrantRequest {
  /** Path parameters. */
  path: {
    grant_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Save a superbill. */
export interface SaveChargeTemplateRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeTemplateRequest;
  signal?: AbortSignal;
}

/** Save a named set of filters. */
export interface SaveReportDefinitionRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ReportDefinitionSaveRequest;
  signal?: AbortSignal;
}

/** Say what one partner service maps to. */
export interface SaveServiceMappingRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ServiceMappingRequest;
  signal?: AbortSignal;
}

/** Search the clearinghouse's payer directory. */
export interface SearchPayerDirectoryRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** Name or id fragment. */
    query: string;
    /** Whose clearinghouse connection to ask. Must be linked to the estate. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Email a confirm-or-cancel reminder for every visit on a coming day. */
export interface SendAppointmentRemindersRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SendRemindersRequest;
  signal?: AbortSignal;
}

/** Email the patient that a statement is ready, with how to pay. */
export interface SendPatientStatementRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
    statement_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: StatementSendRequest;
  signal?: AbortSignal;
}

/** Choose the practice your sessions open in. */
export interface SetOwnDefaultPracticeRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: DefaultPracticeRequest;
  signal?: AbortSignal;
}

/** Record the patient's current home address. */
export interface SetPatientAddressRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientAddressInput;
  signal?: AbortSignal;
}

/** Record a patient's custom field values. */
export interface SetPatientCustomFieldsRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientCustomFieldsUpdate;
  signal?: AbortSignal;
}

/** Say whether NCCI edits stop a claim to this payer. */
export interface SetPayerNcciRequest {
  /** Path parameters. */
  path: {
    payer_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerNcciRequest;
  signal?: AbortSignal;
}

/** Say how one kind of work reaches this payer: clearinghouse, portal, paper, fax, phone. */
export interface SetPayerRouteRequest {
  /** Path parameters. */
  path: {
    payer_id: string;
    transaction: "professional_claim" | "eligibility" | "claim_status";
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerRouteRequest;
  signal?: AbortSignal;
}

/** Turn the practice's public booking link on (issuing a new one) or off. */
export interface SetPracticeBookingLinkRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: BookingLinkRequest;
  signal?: AbortSignal;
}

/** Settle the practice's expired packages: refund or keep their unused visits. */
export interface SettleExpiredPackagesRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PackageSettleRequest;
  signal?: AbortSignal;
}

/** Run a rule over claims the payer has already answered. */
export interface ShadowEvaluateScrubRuleRequest {
  /** Path parameters. */
  path: {
    rule_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ShadowEvaluateRequest;
  signal?: AbortSignal;
}

/** Sign a note — it becomes permanent. */
export interface SignClinicalNoteRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Sign off an import's reconciliation report on the practice's behalf. */
export interface SignOffImportRequest {
  /** Path parameters. */
  path: {
    import_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ImportSignOffRequest;
  signal?: AbortSignal;
}

/** End the session now. */
export interface SignOutRequest {
  /** Request headers declared by this operation. */
  headers?: {
    "X-Sarva-Tenant-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Stage a practice's extracts against its declared totals. */
export interface StageImportRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ImportStageRequest;
  signal?: AbortSignal;
}

/** Open an audited, time-bounded internal access session. */
export interface StartSupportSessionRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SupportSessionStartRequest;
  signal?: AbortSignal;
}

/** Convert reservations whose runner died into unresolved outcomes. */
export interface StrandExpiredClaimSubmissionsRequest {
  /** Request headers declared by this operation. */
  headers?: {
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Record an appeal submission. */
export interface SubmitAppealRequest {
  /** Path parameters. */
  path: {
    appeal_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: AppealSubmitRequest;
  signal?: AbortSignal;
}

/** File a claim with the payer. */
export interface SubmitClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Submit an intake form. */
export interface SubmitIntakeFormRequest {
  /** Path parameters. */
  path: {
    token: string;
  };
  body: IntakeSubmission;
  signal?: AbortSignal;
}

/** Ask a model what to change on this claim to avoid a denial seen before. */
export interface SuggestClaimDenialPreventionRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask a model to propose this denial's root cause. */
export interface SuggestDenialRootCauseRequest {
  /** Path parameters. */
  path: {
    denial_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Propose which of a practice's export columns is which of ours. */
export interface SuggestImportMappingRequest {
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The practice the extract belongs to. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ImportMappingSuggestRequest;
  signal?: AbortSignal;
}

/** Ask a model to phrase the explanation for a patient. */
export interface SuggestPatientBalanceExplanationRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Query parameters. Omitted keys are not sent. */
  query?: {
    /** The encounter being explained. R-PB-02 is per episode of care. */
    encounter_id: string;
    /** D303: the patient's question, from the desk's fixed list. */
    question?: "why_owe_with_insurance" | "what_is_the_deductible" | "why_less_than_charged" | "what_did_insurance_pay" | "do_i_owe_the_discount" | "coinsurance_or_copay" | null;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Draft a call note from a biller's notes of a payer call. */
export interface SummariseClaimPayerCallRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CallNotesRequest;
  signal?: AbortSignal;
}

/** Open the revalidation and credential-expiry obligations. */
export interface SweepProviderObligationsRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ProviderObligationSweepRequest;
  signal?: AbortSignal;
}

/** Compute expected payment and record variances. */
export interface SweepUnderpaymentsRequest {
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: SweepRequest;
  signal?: AbortSignal;
}

/** Take a payment from a patient. */
export interface TakePatientPaymentRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientPaymentRequest;
  signal?: AbortSignal;
}

/** Amend a draft or active plan. */
export interface UpdateCarePlanRequest {
  /** Path parameters. */
  path: {
    care_plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CarePlanUpdateRequest;
  signal?: AbortSignal;
}

/** Autosave a draft. */
export interface UpdateClinicalNoteRequest {
  /** Path parameters. */
  path: {
    note_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClinicalNoteUpdateRequest;
  signal?: AbortSignal;
}

/** Correct a policy, or end it. */
export interface UpdateCoverageRequest {
  /** Path parameters. */
  path: {
    coverage_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CoverageUpdateRequest;
  signal?: AbortSignal;
}

/** Correct a location, or retire it. */
export interface UpdateLocationRequest {
  /** Path parameters. */
  path: {
    location_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: LocationUpdateRequest;
  signal?: AbortSignal;
}

/** Retire or reinstate a prepaid package. */
export interface UpdatePackagePlanRequest {
  /** Path parameters. */
  path: {
    plan_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PackagePlanUpdateRequest;
  signal?: AbortSignal;
}

/** Correct a patient's details. */
export interface UpdatePatientRequest {
  /** Path parameters. */
  path: {
    patient_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PatientUpdateRequest;
  signal?: AbortSignal;
}

/** Change what is known about a payer: details, addresses, ids. */
export interface UpdatePayerRequest {
  /** Path parameters. */
  path: {
    payer_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerUpdateRequest;
  signal?: AbortSignal;
}

/** Update a practice. */
export interface UpdatePracticeRequest {
  /** Path parameters. */
  path: {
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PracticeUpdate;
  signal?: AbortSignal;
}

/** Record whether a provider is an assistant, and who supervises them. */
export interface UpdateProviderRequest {
  /** Path parameters. */
  path: {
    provider_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ProviderUpdateRequest;
  signal?: AbortSignal;
}

/** Advance an enrollment. */
export interface UpdateProviderEnrollmentRequest {
  /** Path parameters. */
  path: {
    enrollment_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: EnrollmentUpdateRequest;
  signal?: AbortSignal;
}

/** Correct a transcription. */
export interface UpdateReferralRequest {
  /** Path parameters. */
  path: {
    referral_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ReferralUpdateRequest;
  signal?: AbortSignal;
}

/** Change a rota, or end it. */
export interface UpdateScheduleTemplateRequest {
  /** Path parameters. */
  path: {
    template_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: TemplateUpdateRequest;
  signal?: AbortSignal;
}

/** Correct a visit type, or retire it. */
export interface UpdateVisitTypeRequest {
  /** Path parameters. */
  path: {
    visit_type_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: VisitTypeUpdateRequest;
  signal?: AbortSignal;
}

/** Create, change or retire one of the practice's charge rules. */
export interface UpsertChargeRuleRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
    key: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeRuleUpsertRequest;
  signal?: AbortSignal;
}

/** Create or replace one of the practice's code groups. */
export interface UpsertCodeGroupRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
    key: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: CodeGroupUpsertRequest;
  signal?: AbortSignal;
}

/** Set whether a procedure is timed, its unit length and the practice's label. */
export interface UpsertProcedureAttributeRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
    procedure_code_set: string;
    procedure_code: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ProcedureAttributeUpsertRequest;
  signal?: AbortSignal;
}

/** Set a payer's unit method, or the practice default. */
export interface UpsertUnitMethodRequest {
  /** Path parameters. */
  path: {
    /** The practice configured. */
    practice_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: UnitMethodUpsertRequest;
  signal?: AbortSignal;
}

/** Run tier 0 over a claim, sending nothing to a payer. */
export interface ValidateClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Ask the clearinghouse directory about one of this payer's ids, and record the answer. */
export interface VerifyPayerIdentifierRequest {
  /** Path parameters. */
  path: {
    payer_id: string;
    transaction: "professional_claim" | "eligibility" | "claim_status" | "remittance";
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: PayerIdentifierVerifyRequest;
  signal?: AbortSignal;
}

/** Change a template by writing its next version. */
export interface VersionNoteTemplateRequest {
  /** Path parameters. */
  path: {
    template_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: NoteTemplateVersionRequest;
  signal?: AbortSignal;
}

/** Withdraw a charge. */
export interface VoidChargeRequest {
  /** Path parameters. */
  path: {
    charge_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ChargeVoidRequest;
  signal?: AbortSignal;
}

/** Void a claim that should never have existed. */
export interface VoidClaimRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ClaimClosureRequest;
  signal?: AbortSignal;
}

/** The PCP withdrew it. */
export interface VoidReferralRequest {
  /** Path parameters. */
  path: {
    referral_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ReferralVoidRequest;
  signal?: AbortSignal;
}

/** Waive an obligation. */
export interface WaiveObligationRequest {
  /** Path parameters. */
  path: {
    obligation_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * The entity tag the caller is editing, e.g. "7". Required on PATCH: absent is 428, stale
     * is 412 with the current version in meta (doc 22 §7).
     */
    "If-Match"?: string | null;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  body: ObligationWaiveRequest;
  signal?: AbortSignal;
}

/** Withdraw an override — the finding is back. */
export interface WithdrawClaimScrubOverrideRequest {
  /** Path parameters. */
  path: {
    claim_id: string;
    override_id: string;
  };
  /** Request headers declared by this operation. */
  headers: {
    /**
     * Required on every POST and PATCH (doc 22 §6). A repeat with the same key and the same
     * body replays the stored response; the same key with a different body is 409
     * IDEMPOTENCY_KEY_REUSED.
     */
    "Idempotency-Key": string;
    /**
     * Selects the active practice when the identity has access to several. Validated against
     * the caller's grants on every request.
     */
    "X-Sarva-Practice-Id"?: string | null;
  };
  signal?: AbortSignal;
}

/** Every operation the API exposes, one method each. */
export interface SarvaApiClient {
  acceptBookingRequest(input: AcceptBookingRequestRequest): Promise<BookingRequestEnvelope>;
  acceptConsentLink(input: AcceptConsentLinkRequest): Promise<ConsentLinkAcceptedEnvelope>;
  acceptPatientFeedConflict(input: AcceptPatientFeedConflictRequest): Promise<FeedConflictEnvelope>;
  activateCarePlan(input: ActivateCarePlanRequest): Promise<CarePlanEnvelope>;
  addChargesToBatch(input: AddChargesToBatchRequest): Promise<ChargeBatchAddEnvelope>;
  addClinicalNoteAddendum(input: AddClinicalNoteAddendumRequest): Promise<ClinicalNoteEnvelope>;
  addPatientCoverage(input: AddPatientCoverageRequest): Promise<CoverageEnvelope>;
  addPatientGuarantor(input: AddPatientGuarantorRequest): Promise<Envelope_GuarantorResource_>;
  addProviderIdentifier(input: AddProviderIdentifierRequest): Promise<Envelope_ProviderIdentifierResource_>;
  addToWaitlist(input: AddToWaitlistRequest): Promise<WaitlistEntryEnvelope>;
  amendCharge(input: AmendChargeRequest): Promise<ChargeEnvelope>;
  answerPlanSignoff(input: AnswerPlanSignoffRequest): Promise<PlanSignoffAnsweredEnvelope>;
  applyChargeTemplate(input: ApplyChargeTemplateRequest): Promise<ChargeListEnvelope>;
  approveAdjustment(input: ApproveAdjustmentRequest): Promise<AdjustmentEnvelope>;
  approveAppeal(input: ApproveAppealRequest): Promise<AppealEnvelope>;
  approveRefund(input: ApproveRefundRequest): Promise<RefundEnvelope>;
  archiveChargeTemplate(input: ArchiveChargeTemplateRequest): Promise<ChargeTemplateEnvelope>;
  archivePractice(input: ArchivePracticeRequest): Promise<PracticeEnvelope>;
  assignRole(input: AssignRoleRequest): Promise<Envelope_RoleGrantResource_>;
  assignWorkItem(input: AssignWorkItemRequest): Promise<WorkItemEnvelope>;
  bookAppointment(input: BookAppointmentRequest): Promise<AppointmentEnvelope>;
  bookAppointmentSeries(input: BookAppointmentSeriesRequest): Promise<AppointmentSeriesEnvelope>;
  bookWaitlistEntry(input: BookWaitlistEntryRequest): Promise<WaitlistEntryEnvelope>;
  bulkLoadFeeScheduleLines(input: BulkLoadFeeScheduleLinesRequest): Promise<FeeScheduleBulkEnvelope>;
  cancelAppointment(input: CancelAppointmentRequest): Promise<AppointmentEnvelope>;
  cancelAppointmentFromReminder(input: CancelAppointmentFromReminderRequest): Promise<ReminderPageEnvelope>;
  cancelAppointmentSeries(input: CancelAppointmentSeriesRequest): Promise<AppointmentSeriesEnvelope>;
  cancelPaymentPlan(input: CancelPaymentPlanRequest): Promise<PaymentPlanEnvelope>;
  certifyCarePlan(input: CertifyCarePlanRequest): Promise<CarePlanEnvelope>;
  changeOwnPassword(input: ChangeOwnPasswordRequest): Promise<PasswordChangeEnvelope>;
  chargeMissedVisitFee(input: ChargeMissedVisitFeeRequest): Promise<AppointmentEnvelope>;
  checkAppointmentAuthorization(input: CheckAppointmentAuthorizationRequest): Promise<AppointmentAuthorizationCheckEnvelope>;
  checkClaimStatus(input: CheckClaimStatusRequest): Promise<Envelope_OperationResource_>;
  checkClinicalNoteDocumentation(input: CheckClinicalNoteDocumentationRequest): Promise<Envelope_OperationResource_>;
  checkCodingCompliance(input: CheckCodingComplianceRequest): Promise<Envelope_OperationResource_>;
  checkEligibilityForDueVisits(input: CheckEligibilityForDueVisitsRequest): Promise<DueCheckEnvelope>;
  checkoutVisit(input: CheckoutVisitRequest): Promise<CheckoutEnvelope>;
  checkPatientBillingReadiness(input: CheckPatientBillingReadinessRequest): Promise<Envelope_BillingReadinessResource_>;
  checkPatientDuplicates(input: CheckPatientDuplicatesRequest): Promise<DuplicateCheckEnvelope>;
  checkPatientEligibility(input: CheckPatientEligibilityRequest): Promise<Envelope_OperationResource_>;
  checkProviderSubmissionEligibility(input: CheckProviderSubmissionEligibilityRequest): Promise<Envelope_SubmissionEligibilityResource_>;
  classifyDenial(input: ClassifyDenialRequest): Promise<DenialEnvelope>;
  classifyDocument(input: ClassifyDocumentRequest): Promise<Envelope_OperationResource_>;
  classifyRetainedDocument(input: ClassifyRetainedDocumentRequest): Promise<Envelope_OperationResource_>;
  closeAccountingPeriod(input: CloseAccountingPeriodRequest): Promise<AccountingPeriodEnvelope>;
  closeClaim(input: CloseClaimRequest): Promise<Envelope_ClaimClosureResource_>;
  closePatientFeedConflict(input: ClosePatientFeedConflictRequest): Promise<FeedConflictEnvelope>;
  closeSettledClaims(input?: CloseSettledClaimsRequest): Promise<Envelope_SettledSweepResource_>;
  commitClinicalNoteCharges(input: CommitClinicalNoteChargesRequest): Promise<ChargeProposalEnvelope>;
  commitImport(input: CommitImportRequest): Promise<Envelope_OperationResource_>;
  completeCarePlan(input: CompleteCarePlanRequest): Promise<CarePlanEnvelope>;
  completeWritebackTask(input: CompleteWritebackTaskRequest): Promise<WritebackTaskEnvelope>;
  confirmAppointmentFromReminder(input: ConfirmAppointmentFromReminderRequest): Promise<ReminderPageEnvelope>;
  confirmMfa(input: ConfirmMfaRequest): Promise<MfaStatusEnvelope>;
  correctClaim(input: CorrectClaimRequest): Promise<Envelope_ClaimReplacementResource_>;
  correctFeeScheduleLine(input: CorrectFeeScheduleLineRequest): Promise<FeeScheduleLineEnvelope>;
  correctRejectedClaim(input: CorrectRejectedClaimRequest): Promise<RejectionEnvelope>;
  cosignClinicalNote(input: CosignClinicalNoteRequest): Promise<ClinicalNoteEnvelope>;
  createAppeal(input: CreateAppealRequest): Promise<AppealEnvelope>;
  createCarePlan(input: CreateCarePlanRequest): Promise<CarePlanEnvelope>;
  createCarePlanSignoff(input: CreateCarePlanSignoffRequest): Promise<CarePlanSignoffEnvelope>;
  createCharge(input: CreateChargeRequest): Promise<ChargeEnvelope>;
  createChargeBatch(input: CreateChargeBatchRequest): Promise<ChargeBatchEnvelope>;
  createClaimFromCharges(input: CreateClaimFromChargesRequest): Promise<ClaimFromChargesEnvelope>;
  createClinicalNote(input: CreateClinicalNoteRequest): Promise<ClinicalNoteEnvelope>;
  createConsentRequest(input: CreateConsentRequestRequest): Promise<ConsentRequestEnvelope>;
  createCustomField(input: CreateCustomFieldRequest): Promise<CustomFieldDefinitionEnvelope>;
  createFeeSchedule(input: CreateFeeScheduleRequest): Promise<FeeScheduleEnvelope>;
  createFeeScheduleLine(input: CreateFeeScheduleLineRequest): Promise<FeeScheduleLineEnvelope>;
  createIntakeInvitation(input: CreateIntakeInvitationRequest): Promise<IntakeInvitationEnvelope>;
  createLocation(input: CreateLocationRequest): Promise<LocationEnvelope>;
  createNoteTemplate(input: CreateNoteTemplateRequest): Promise<NoteTemplateEnvelope>;
  createPackagePlan(input: CreatePackagePlanRequest): Promise<PackagePlanEnvelope>;
  createPatientEstimate(input: CreatePatientEstimateRequest): Promise<Envelope_PatientEstimateResource_>;
  createPatientStatement(input: CreatePatientStatementRequest): Promise<Envelope_PatientStatementResource_>;
  createPayer(input: CreatePayerRequest): Promise<PayerEnvelope>;
  createPayerAuthRequirement(input: CreatePayerAuthRequirementRequest): Promise<AuthRequirementEnvelope>;
  createPayerRule(input: CreatePayerRuleRequest): Promise<Envelope_PayerRuleResource_>;
  createPaymentPlan(input: CreatePaymentPlanRequest): Promise<PaymentPlanEnvelope>;
  createPolicyBand(input: CreatePolicyBandRequest): Promise<Envelope_PolicyBandResource_>;
  createPractice(input: CreatePracticeRequest): Promise<PracticeEnvelope>;
  createProvider(input: CreateProviderRequest): Promise<Envelope_ProviderResource_>;
  createProviderEnrollment(input: CreateProviderEnrollmentRequest): Promise<Envelope_EnrollmentResource_>;
  createScheduleBlock(input: CreateScheduleBlockRequest): Promise<Envelope_ScheduleBlockResource_>;
  createScheduleTemplate(input: CreateScheduleTemplateRequest): Promise<Envelope_TemplateResource_>;
  createScrubRule(input: CreateScrubRuleRequest): Promise<Envelope_ScrubRuleResource_>;
  createSetting(input: CreateSettingRequest): Promise<Envelope_SettingResource_>;
  createVisitType(input: CreateVisitTypeRequest): Promise<Envelope_VisitTypeResource_>;
  deactivateUser(input: DeactivateUserRequest): Promise<Envelope_UserResource_>;
  declineBookingRequest(input: DeclineBookingRequestRequest): Promise<BookingRequestEnvelope>;
  deleteReportDefinition(input: DeleteReportDefinitionRequest): Promise<void>;
  deleteScheduleBlock(input: DeleteScheduleBlockRequest): Promise<void>;
  describeReasonCodes(input?: DescribeReasonCodesRequest): Promise<ReasonCodeTextListEnvelope>;
  diagnoseClaimRejection(input: DiagnoseClaimRejectionRequest): Promise<RejectionEnvelope>;
  diffFeeSchedules(input: DiffFeeSchedulesRequest): Promise<ScheduleDiffEnvelope>;
  disableMfa(input: DisableMfaRequest): Promise<MfaStatusEnvelope>;
  discardCarePlan(input: DiscardCarePlanRequest): Promise<CarePlanEnvelope>;
  discardClinicalNote(input: DiscardClinicalNoteRequest): Promise<ClinicalNoteEnvelope>;
  discontinueCarePlan(input: DiscontinueCarePlanRequest): Promise<CarePlanEnvelope>;
  dismissWritebackTask(input: DismissWritebackTaskRequest): Promise<WritebackTaskEnvelope>;
  draftAppealLetter(input: DraftAppealLetterRequest): Promise<Envelope_OperationResource_>;
  draftClinicalNoteFromDictation(input: DraftClinicalNoteFromDictationRequest): Promise<Envelope_OperationResource_>;
  endSupportSession(input: EndSupportSessionRequest): Promise<Envelope_SupportSessionResource_>;
  enrolMfa(input: EnrolMfaRequest): Promise<MfaEnrolmentEnvelope>;
  enterRemittanceByHand(input: EnterRemittanceByHandRequest): Promise<RemittanceEnvelope>;
  evaluateObligations(input: EvaluateObligationsRequest): Promise<EvaluationResultEnvelope>;
  exchangeCoreToken(input: ExchangeCoreTokenRequest): Promise<TokenEnvelope>;
  explainPatientBalance(input: ExplainPatientBalanceRequest): Promise<Envelope_BalanceExplanationResource_>;
  exportClaimsCsv(input?: ExportClaimsCsvRequest): Promise<void>;
  exportDenialsCsv(input?: ExportDenialsCsvRequest): Promise<void>;
  exportGeneralLedgerCsv(input?: ExportGeneralLedgerCsvRequest): Promise<void>;
  extractCodingDocumentation(input: ExtractCodingDocumentationRequest): Promise<Envelope_OperationResource_>;
  extractContractRates(input: ExtractContractRatesRequest): Promise<Envelope_OperationResource_>;
  extractPayerRules(input: ExtractPayerRulesRequest): Promise<Envelope_OperationResource_>;
  extractRemittanceDocument(input: ExtractRemittanceDocumentRequest): Promise<Envelope_OperationResource_>;
  extractSuperbill(input: ExtractSuperbillRequest): Promise<Envelope_OperationResource_>;
  findOrganisation(input: FindOrganisationRequest): Promise<OrganisationEnvelope>;
  getAppeal(input: GetAppealRequest): Promise<AppealEnvelope>;
  getAppealOutcomes(input?: GetAppealOutcomesRequest): Promise<AppealOutcomesEnvelope>;
  getAppointment(input: GetAppointmentRequest): Promise<AppointmentDetailEnvelope>;
  getAppointmentReminder(input: GetAppointmentReminderRequest): Promise<ReminderPageEnvelope>;
  getArAging(input?: GetArAgingRequest): Promise<Envelope_ArAgingResource_>;
  getBalanceDrift(input?: GetBalanceDriftRequest): Promise<Envelope_BalanceDriftResource_>;
  getBaselineDiagnostic(input?: GetBaselineDiagnosticRequest): Promise<BaselineDiagnosticEnvelope>;
  getBookingPage(input: GetBookingPageRequest): Promise<BookingPageEnvelope>;
  getCarePlan(input: GetCarePlanRequest): Promise<CarePlanEnvelope>;
  getCarePlanCertificationForm(input: GetCarePlanCertificationFormRequest): Promise<void>;
  getCarePlanOutcomes(input: GetCarePlanOutcomesRequest): Promise<CarePlanOutcomesEnvelope>;
  getClaim(input: GetClaimRequest): Promise<ClaimEnvelope>;
  getClaimCoordinationOfBenefits(input: GetClaimCoordinationOfBenefitsRequest): Promise<CoordinationOfBenefitsEnvelope>;
  getClinicalNote(input: GetClinicalNoteRequest): Promise<ClinicalNoteEnvelope>;
  getClinicalNoteChargeProposal(input: GetClinicalNoteChargeProposalRequest): Promise<ChargeProposalEnvelope>;
  getClinicalNoteCopy(input: GetClinicalNoteCopyRequest): Promise<void>;
  getCodingReview(input: GetCodingReviewRequest): Promise<CodingReviewEnvelope>;
  getCollectionsStatement(input: GetCollectionsStatementRequest): Promise<CollectionsStatementEnvelope>;
  getConsentLink(input: GetConsentLinkRequest): Promise<ConsentLinkEnvelope>;
  getDailyDigest(input?: GetDailyDigestRequest): Promise<DailyDigestEnvelope>;
  getDaySheet(input?: GetDaySheetRequest): Promise<DaySheetEnvelope>;
  getDenial(input: GetDenialRequest): Promise<DenialEnvelope>;
  getDocument(input: GetDocumentRequest): Promise<DocumentEnvelope>;
  getDocumentContent(input: GetDocumentContentRequest): Promise<void>;
  getEncounterSourceInvoice(input: GetEncounterSourceInvoiceRequest): Promise<SourceInvoiceEnvelope>;
  getEncounterSuperbill(input: GetEncounterSuperbillRequest): Promise<void>;
  getEstateCapabilities(input?: GetEstateCapabilitiesRequest): Promise<EstateCapabilitiesEnvelope>;
  getHealth(input?: GetHealthRequest): Promise<HealthEnvelope>;
  getImport(input: GetImportRequest): Promise<ImportBatchEnvelope>;
  getIntakeForm(input: GetIntakeFormRequest): Promise<IntakeFormEnvelope>;
  getLossIncident(input: GetLossIncidentRequest): Promise<LossIncidentEnvelope>;
  getMe(input?: GetMeRequest): Promise<MeEnvelope>;
  getNoteTemplate(input: GetNoteTemplateRequest): Promise<NoteTemplateEnvelope>;
  getNoteTemplateVersion(input: GetNoteTemplateVersionRequest): Promise<NoteTemplateVersionEnvelope>;
  getObligation(input: GetObligationRequest): Promise<ObligationEnvelope>;
  getOperation(input: GetOperationRequest): Promise<Envelope_OperationResource_>;
  getPatient(input: GetPatientRequest): Promise<PatientEnvelope>;
  getPatientAccount(input: GetPatientAccountRequest): Promise<PatientAccountEnvelope>;
  getPatientConsents(input: GetPatientConsentsRequest): Promise<ConsentStatusEnvelope>;
  getPatientCustomFields(input: GetPatientCustomFieldsRequest): Promise<PatientCustomFieldsEnvelope>;
  getPatientLedger(input: GetPatientLedgerRequest): Promise<PatientLedgerEnvelope>;
  getPatientStatementDocument(input: GetPatientStatementDocumentRequest): Promise<void>;
  getPatientThresholds(input: GetPatientThresholdsRequest): Promise<ThresholdProgressEnvelope>;
  getPayer(input: GetPayerRequest): Promise<PayerEnvelope>;
  getPayerScorecard(input?: GetPayerScorecardRequest): Promise<PayerScorecardEnvelope>;
  getPeriodReconciliation(input: GetPeriodReconciliationRequest): Promise<PeriodReconciliationEnvelope>;
  getPlanSignoff(input: GetPlanSignoffRequest): Promise<PlanSignoffViewEnvelope>;
  getPostingRun(input: GetPostingRunRequest): Promise<PostingRunEnvelope>;
  getPractice(input: GetPracticeRequest): Promise<PracticeEnvelope>;
  getPracticeActivity(input?: GetPracticeActivityRequest): Promise<PracticeActivityEnvelope>;
  getPriorAuthorization(input: GetPriorAuthorizationRequest): Promise<PriorAuthEnvelope>;
  getQueueHealth(input?: GetQueueHealthRequest): Promise<QueueHealthListEnvelope>;
  getRateCoverage(input?: GetRateCoverageRequest): Promise<RateCoverageEnvelope>;
  getRemittance(input: GetRemittanceRequest): Promise<RemittanceEnvelope>;
  getScoreboard(input?: GetScoreboardRequest): Promise<Envelope_ScoreboardResource_>;
  getSuperbillExtraction(input: GetSuperbillExtractionRequest): Promise<SuperbillExtractionEnvelope>;
  getSweepHealth(input?: GetSweepHealthRequest): Promise<SweepHealthEnvelope>;
  getUnappliedCash(input?: GetUnappliedCashRequest): Promise<UnappliedCashEnvelope>;
  getVisitCheckout(input: GetVisitCheckoutRequest): Promise<CheckoutEnvelope>;
  getWorkItem(input: GetWorkItemRequest): Promise<WorkItemEnvelope>;
  holdCharge(input: HoldChargeRequest): Promise<ChargeEnvelope>;
  importBankStatement(input: ImportBankStatementRequest): Promise<BankStatementImportEnvelope>;
  ingestRemittance(input: IngestRemittanceRequest): Promise<RemittanceEnvelope>;
  installSpecialtyPack(input: InstallSpecialtyPackRequest): Promise<PackInstallEnvelope>;
  intakeSourceInvoice(input: IntakeSourceInvoiceRequest): Promise<SourceInvoiceIntakeEnvelope>;
  inviteUser(input: InviteUserRequest): Promise<Envelope_UserResource_>;
  issueClientToken(input: IssueClientTokenRequest): Promise<TokenEnvelope>;
  issueRefund(input: IssueRefundRequest): Promise<RefundEnvelope>;
  issueToken(input: IssueTokenRequest): Promise<TokenEnvelope>;
  launchSession(input: LaunchSessionRequest): Promise<TokenEnvelope>;
  linkAppointmentAuthorization(input: LinkAppointmentAuthorizationRequest): Promise<AppointmentEnvelope>;
  linkPracticeToHub(input: LinkPracticeToHubRequest): Promise<PracticeEnvelope>;
  listAccountingPeriods(input?: ListAccountingPeriodsRequest): Promise<AccountingPeriodListEnvelope>;
  listAdjustments(input?: ListAdjustmentsRequest): Promise<AdjustmentListEnvelope>;
  listAppealLetterSuggestions(input: ListAppealLetterSuggestionsRequest): Promise<AppealLetterSuggestionListEnvelope>;
  listAppeals(input?: ListAppealsRequest): Promise<AppealListEnvelope>;
  listAppointments(input?: ListAppointmentsRequest): Promise<AppointmentListEnvelope>;
  listAppointmentsDueEligibility(input?: ListAppointmentsDueEligibilityRequest): Promise<EligibilityDueEnvelope>;
  listAuditEntries(input?: ListAuditEntriesRequest): Promise<AuditEntryListEnvelope>;
  listBenefitSuggestions(input: ListBenefitSuggestionsRequest): Promise<BenefitSuggestionListEnvelope>;
  listBookableSlots(input: ListBookableSlotsRequest): Promise<Envelope_list_BookableSlotResource__>;
  listBookingRequests(input?: ListBookingRequestsRequest): Promise<BookingRequestListEnvelope>;
  listBookingSlots(input: ListBookingSlotsRequest): Promise<BookingSlotListEnvelope>;
  listCarePlanSignoffs(input: ListCarePlanSignoffsRequest): Promise<CarePlanSignoffListEnvelope>;
  listChargeBatches(input?: ListChargeBatchesRequest): Promise<ChargeBatchListEnvelope>;
  listChargeRules(input: ListChargeRulesRequest): Promise<ChargeRuleListEnvelope>;
  listCharges(input?: ListChargesRequest): Promise<ChargeListEnvelope>;
  listChargeTemplates(input?: ListChargeTemplatesRequest): Promise<ChargeTemplateListEnvelope>;
  listClaimAcknowledgements(input: ListClaimAcknowledgementsRequest): Promise<ClaimAcknowledgementListEnvelope>;
  listClaimAcknowledgementsAcrossClaims(input?: ListClaimAcknowledgementsAcrossClaimsRequest): Promise<ClaimAcknowledgementListEnvelope>;
  listClaimAiSuggestions(input: ListClaimAiSuggestionsRequest): Promise<ClaimSuggestionListEnvelope>;
  listClaimFollowUpNotes(input: ListClaimFollowUpNotesRequest): Promise<Envelope_list_FollowUpNoteResource__>;
  listClaimRejections(input: ListClaimRejectionsRequest): Promise<RejectionHistoryEnvelope>;
  listClaims(input?: ListClaimsRequest): Promise<ClaimListEnvelope>;
  listClaimScrubOverrides(input: ListClaimScrubOverridesRequest): Promise<ScrubOverrideListEnvelope>;
  listClaimScrubResults(input: ListClaimScrubResultsRequest): Promise<ScrubResultListEnvelope>;
  listClaimStatusChecks(input: ListClaimStatusChecksRequest): Promise<ClaimStatusHistoryEnvelope>;
  listClaimSubmissions(input: ListClaimSubmissionsRequest): Promise<ClaimSubmissionListEnvelope>;
  listClaimSubmissionsAcrossClaims(input?: ListClaimSubmissionsAcrossClaimsRequest): Promise<ClaimSubmissionListEnvelope>;
  listClinicalNoteAiSuggestions(input: ListClinicalNoteAiSuggestionsRequest): Promise<NoteSuggestionListEnvelope>;
  listCodeGroups(input: ListCodeGroupsRequest): Promise<CodeGroupListEnvelope>;
  listCodeSets(input?: ListCodeSetsRequest): Promise<CodeSetListEnvelope>;
  listCollectionPlacements(input?: ListCollectionPlacementsRequest): Promise<PlacementListEnvelope>;
  listConsentForms(input: ListConsentFormsRequest): Promise<ConsentFormListEnvelope>;
  listConsentFormTemplates(input?: ListConsentFormTemplatesRequest): Promise<ConsentTemplateListEnvelope>;
  listConsentRequests(input: ListConsentRequestsRequest): Promise<ConsentRequestListEnvelope>;
  listCreditBalances(input?: ListCreditBalancesRequest): Promise<CreditBalanceListEnvelope>;
  listCustomFields(input?: ListCustomFieldsRequest): Promise<CustomFieldDefinitionListEnvelope>;
  listDenialAiSuggestions(input: ListDenialAiSuggestionsRequest): Promise<AiSuggestionListEnvelope>;
  listDenials(input?: ListDenialsRequest): Promise<DenialListEnvelope>;
  listDocumentClassifications(input?: ListDocumentClassificationsRequest): Promise<DocumentClassificationListEnvelope>;
  listDocuments(input?: ListDocumentsRequest): Promise<DocumentListEnvelope>;
  listDueFollowUpNotes(input?: ListDueFollowUpNotesRequest): Promise<Envelope_list_FollowUpNoteResource__>;
  listDuplicatePatients(input?: ListDuplicatePatientsRequest): Promise<DuplicatePairListEnvelope>;
  listEmailOutbox(input?: ListEmailOutboxRequest): Promise<EmailLogEnvelope>;
  listEncounterCharges(input: ListEncounterChargesRequest): Promise<ChargeListEnvelope>;
  listEncounterClinicalNotes(input: ListEncounterClinicalNotesRequest): Promise<ClinicalNoteListEnvelope>;
  listEncounters(input?: ListEncountersRequest): Promise<EncounterListEnvelope>;
  listFeeScheduleLines(input: ListFeeScheduleLinesRequest): Promise<FeeScheduleLineListEnvelope>;
  listFeeSchedules(input?: ListFeeSchedulesRequest): Promise<FeeScheduleListEnvelope>;
  listImportMappingSuggestions(input?: ListImportMappingSuggestionsRequest): Promise<ImportMappingSuggestionListEnvelope>;
  listImports(input?: ListImportsRequest): Promise<ImportBatchListEnvelope>;
  listInsuranceCardReadings(input: ListInsuranceCardReadingsRequest): Promise<InsuranceCardReadingListEnvelope>;
  listIntakeForms(input?: ListIntakeFormsRequest): Promise<IntakeFormChoiceListEnvelope>;
  listIntakeInvitations(input: ListIntakeInvitationsRequest): Promise<IntakeInvitationListEnvelope>;
  listLocations(input?: ListLocationsRequest): Promise<LocationListEnvelope>;
  listLossIncidents(input?: ListLossIncidentsRequest): Promise<LossIncidentListEnvelope>;
  listNotesAwaitingCosignature(input?: ListNotesAwaitingCosignatureRequest): Promise<ClinicalNoteListEnvelope>;
  listNoteTemplates(input?: ListNoteTemplatesRequest): Promise<NoteTemplateListEnvelope>;
  listObligations(input?: ListObligationsRequest): Promise<ObligationListEnvelope>;
  listPackagePlans(input?: ListPackagePlansRequest): Promise<PackagePlanListEnvelope>;
  listPackagePlansOnSale(input?: ListPackagePlansOnSaleRequest): Promise<PackagePlanListEnvelope>;
  listPatientAppointmentSeries(input: ListPatientAppointmentSeriesRequest): Promise<AppointmentSeriesListEnvelope>;
  listPatientCarePlans(input: ListPatientCarePlansRequest): Promise<CarePlanListEnvelope>;
  listPatientClinicalNotes(input: ListPatientClinicalNotesRequest): Promise<ClinicalNoteListEnvelope>;
  listPatientCoverages(input: ListPatientCoveragesRequest): Promise<CoverageListEnvelope>;
  listPatientEligibilityChecks(input: ListPatientEligibilityChecksRequest): Promise<EligibilityListEnvelope>;
  listPatientEstimates(input: ListPatientEstimatesRequest): Promise<Envelope_list_PatientEstimateResource__>;
  listPatientExplanationSuggestions(input: ListPatientExplanationSuggestionsRequest): Promise<Envelope_list_ExplanationSuggestionResource__>;
  listPatientFeedConflicts(input: ListPatientFeedConflictsRequest): Promise<FeedConflictListEnvelope>;
  listPatientFollowUpNotes(input: ListPatientFollowUpNotesRequest): Promise<Envelope_list_FollowUpNoteResource__>;
  listPatientGuarantors(input: ListPatientGuarantorsRequest): Promise<Envelope_list_GuarantorResource__>;
  listPatientPackages(input: ListPatientPackagesRequest): Promise<PatientPackageListEnvelope>;
  listPatientPriorAuthorizations(input: ListPatientPriorAuthorizationsRequest): Promise<PriorAuthListEnvelope>;
  listPatientReferrals(input: ListPatientReferralsRequest): Promise<ReferralListEnvelope>;
  listPatients(input?: ListPatientsRequest): Promise<PatientListEnvelope>;
  listPatientsOwing(input?: ListPatientsOwingRequest): Promise<PatientOwingEnvelope>;
  listPatientStatements(input: ListPatientStatementsRequest): Promise<Envelope_list_PatientStatementResource__>;
  listPatientVisitChoices(input: ListPatientVisitChoicesRequest): Promise<VisitChoiceListEnvelope>;
  listPatientVoiceCalls(input: ListPatientVoiceCallsRequest): Promise<VoiceCallListEnvelope>;
  listPatientVoiceOutcomes(input: ListPatientVoiceOutcomesRequest): Promise<VoiceOutcomeListEnvelope>;
  listPayerAuthRequirements(input?: ListPayerAuthRequirementsRequest): Promise<AuthRequirementListEnvelope>;
  listPayerChoices(input?: ListPayerChoicesRequest): Promise<PayerChoiceListEnvelope>;
  listPayerRules(input?: ListPayerRulesRequest): Promise<Envelope_list_PayerRuleResource__>;
  listPayers(input?: ListPayersRequest): Promise<PayerListEnvelope>;
  listPaymentPlans(input: ListPaymentPlansRequest): Promise<PaymentPlanListEnvelope>;
  listPlansAwaitingCertification(input?: ListPlansAwaitingCertificationRequest): Promise<AwaitingCertificationEnvelope>;
  listPolicyBands(input?: ListPolicyBandsRequest): Promise<Envelope_list_PolicyBandResource__>;
  listPostingRuns(input: ListPostingRunsRequest): Promise<PostingRunSummaryListEnvelope>;
  listPractices(input?: ListPracticesRequest): Promise<PracticeListEnvelope>;
  listPriorAuthorizations(input?: ListPriorAuthorizationsRequest): Promise<PriorAuthListEnvelope>;
  listProcedureAttributes(input: ListProcedureAttributesRequest): Promise<ProcedureAttributeListEnvelope>;
  listProcedureCodeChoices(input: ListProcedureCodeChoicesRequest): Promise<ProcedureCodeChoiceListEnvelope>;
  listProviderChoices(input?: ListProviderChoicesRequest): Promise<ProviderChoiceListEnvelope>;
  listProviderEnrollments(input: ListProviderEnrollmentsRequest): Promise<Envelope_list_EnrollmentResource__>;
  listProviderIdentifiers(input: ListProviderIdentifiersRequest): Promise<Envelope_list_ProviderIdentifierResource__>;
  listProviders(input?: ListProvidersRequest): Promise<Envelope_list_ProviderResource__>;
  listRateSuggestions(input?: ListRateSuggestionsRequest): Promise<RateSuggestionListEnvelope>;
  listReferrals(input?: ListReferralsRequest): Promise<ReferralListEnvelope>;
  listRefunds(input?: ListRefundsRequest): Promise<RefundListEnvelope>;
  listRemittanceExtractions(input?: ListRemittanceExtractionsRequest): Promise<RemittanceExtractionListEnvelope>;
  listRemittances(input?: ListRemittancesRequest): Promise<RemittanceListEnvelope>;
  listReportDefinitions(input?: ListReportDefinitionsRequest): Promise<ReportDefinitionListEnvelope>;
  listRoleGrants(input: ListRoleGrantsRequest): Promise<Envelope_list_RoleGrantResource__>;
  listRoles(input?: ListRolesRequest): Promise<Envelope_list_RoleResource__>;
  listScheduleBlocks(input?: ListScheduleBlocksRequest): Promise<Envelope_list_ScheduleBlockResource__>;
  listScheduleTemplates(input?: ListScheduleTemplatesRequest): Promise<Envelope_list_TemplateResource__>;
  listScrubRules(input?: ListScrubRulesRequest): Promise<Envelope_list_ScrubRuleResource__>;
  listServiceMappings(input?: ListServiceMappingsRequest): Promise<Envelope_list_ServiceMappingResource__>;
  listSettingDefinitions(input?: ListSettingDefinitionsRequest): Promise<Envelope_list_SettingDefinitionResource__>;
  listSettings(input?: ListSettingsRequest): Promise<Envelope_list_SettingResource__>;
  listSpecialtyPacks(input?: ListSpecialtyPacksRequest): Promise<SpecialtyPackListEnvelope>;
  listSuperbillExtractions(input: ListSuperbillExtractionsRequest): Promise<SuperbillExtractionListEnvelope>;
  listSupportSessions(input?: ListSupportSessionsRequest): Promise<Envelope_list_SupportSessionResource__>;
  listSweepRuns(input?: ListSweepRunsRequest): Promise<SweepRunListEnvelope>;
  listUnitMethods(input: ListUnitMethodsRequest): Promise<UnitMethodListEnvelope>;
  listUnmatchedBankDeposits(input?: ListUnmatchedBankDepositsRequest): Promise<UnmatchedDepositListEnvelope>;
  listUsers(input?: ListUsersRequest): Promise<Envelope_list_UserResource__>;
  listVisitTypes(input?: ListVisitTypesRequest): Promise<Envelope_list_VisitTypeResource__>;
  listVoiceAppointments(input?: ListVoiceAppointmentsRequest): Promise<VoiceAppointmentEnvelope>;
  listVoiceBalances(input?: ListVoiceBalancesRequest): Promise<VoiceBalanceEnvelope>;
  listWaitlist(input?: ListWaitlistRequest): Promise<WaitlistEntryListEnvelope>;
  listWorkItems(input?: ListWorkItemsRequest): Promise<WorkItemListEnvelope>;
  listWritebackTasks(input?: ListWritebackTasksRequest): Promise<WritebackTaskListEnvelope>;
  markClinicalNoteEnteredInError(input: MarkClinicalNoteEnteredInErrorRequest): Promise<ClinicalNoteEnvelope>;
  markPatientEnteredInError(input: MarkPatientEnteredInErrorRequest): Promise<PatientEnvelope>;
  mergePatient(input: MergePatientRequest): Promise<PatientMergeEnvelope>;
  normaliseEligibilityBenefits(input: NormaliseEligibilityBenefitsRequest): Promise<Envelope_OperationResource_>;
  openCodingReview(input: OpenCodingReviewRequest): Promise<CodingReviewEnvelope>;
  overrideClaimScrubFinding(input: OverrideClaimScrubFindingRequest): Promise<ScrubOverrideEnvelope>;
  pausePolicyBand(input: PausePolicyBandRequest): Promise<Envelope_PolicyBandResource_>;
  placeAccountWithAgency(input: PlaceAccountWithAgencyRequest): Promise<PlacementEnvelope>;
  postRemittance(input: PostRemittanceRequest): Promise<Envelope_OperationResource_>;
  projectScoreboard(input: ProjectScoreboardRequest): Promise<Envelope_ScoreboardProjectionResource_>;
  promotePayerRule(input: PromotePayerRuleRequest): Promise<Envelope_PayerRuleResource_>;
  promoteScrubRule(input: PromoteScrubRuleRequest): Promise<Envelope_ScrubRuleResource_>;
  publishConsentForm(input: PublishConsentFormRequest): Promise<ConsentFormEnvelope>;
  purchasePatientPackage(input: PurchasePatientPackageRequest): Promise<PatientPackageEnvelope>;
  quotePatientEstimate(input: QuotePatientEstimateRequest): Promise<Envelope_EstimateQuoteResource_>;
  raiseDowncodeAppeals(input: RaiseDowncodeAppealsRequest): Promise<CandidateEnvelope>;
  raiseFeeScheduleReviews(input?: RaiseFeeScheduleReviewsRequest): Promise<Envelope_ReviewSweepResource_>;
  raiseUnderpaymentChallenges(input: RaiseUnderpaymentChallengesRequest): Promise<CandidateEnvelope>;
  readInsuranceCard(input: ReadInsuranceCardRequest): Promise<Envelope_OperationResource_>;
  receiveCoreProvisioning(input: ReceiveCoreProvisioningRequest): Promise<ProvisioningEnvelope>;
  receiveHubWebhook(input: ReceiveHubWebhookRequest): Promise<void>;
  receivePatientFeed(input: ReceivePatientFeedRequest): Promise<PatientFeedEnvelope>;
  recogniseChargeRevenue(input: RecogniseChargeRevenueRequest): Promise<RevenueRecognitionEnvelope>;
  reconcileClaimSubmission(input: ReconcileClaimSubmissionRequest): Promise<ClaimSubmissionEnvelope>;
  reconcileEncounterCharges(input: ReconcileEncounterChargesRequest): Promise<EncounterReconcileEnvelope>;
  reconcilePatientEstimates(input: ReconcilePatientEstimatesRequest): Promise<Envelope_ReconciliationSweepResource_>;
  recordAppealOutcome(input: RecordAppealOutcomeRequest): Promise<AppealEnvelope>;
  recordAppointmentArrival(input: RecordAppointmentArrivalRequest): Promise<AppointmentEnvelope>;
  recordAppointmentCompletion(input: RecordAppointmentCompletionRequest): Promise<AppointmentEnvelope>;
  recordAppointmentNoShow(input: RecordAppointmentNoShowRequest): Promise<AppointmentEnvelope>;
  recordClaimAcknowledgement(input: RecordClaimAcknowledgementRequest): Promise<ClaimAcknowledgementEnvelope>;
  recordClaimFiling(input: RecordClaimFilingRequest): Promise<ClaimSubmissionEnvelope>;
  recordClaimFollowUpNote(input: RecordClaimFollowUpNoteRequest): Promise<Envelope_FollowUpNoteResource_>;
  recordClaimReceipt(input: RecordClaimReceiptRequest): Promise<ClaimEnvelope>;
  recordClaimStatusCheck(input: RecordClaimStatusCheckRequest): Promise<ClaimStatusCheckEnvelope>;
  recordEligibilityVerification(input: RecordEligibilityVerificationRequest): Promise<EligibilityEnvelope>;
  recordPatientConsent(input: RecordPatientConsentRequest): Promise<ConsentEnvelope>;
  recordPatientFollowUpNote(input: RecordPatientFollowUpNoteRequest): Promise<Envelope_FollowUpNoteResource_>;
  recordPlacementEvent(input: RecordPlacementEventRequest): Promise<PlacementEnvelope>;
  recordPriorAuthorization(input: RecordPriorAuthorizationRequest): Promise<PriorAuthEnvelope>;
  recordPriorAuthorizationDecision(input: RecordPriorAuthorizationDecisionRequest): Promise<PriorAuthEnvelope>;
  recordReferral(input: RecordReferralRequest): Promise<ReferralEnvelope>;
  refreshToken(input?: RefreshTokenRequest): Promise<TokenEnvelope>;
  registerPatient(input: RegisterPatientRequest): Promise<PatientEnvelope>;
  rejectPayerRule(input: RejectPayerRuleRequest): Promise<Envelope_PayerRuleResource_>;
  rejectRemittanceExtraction(input: RejectRemittanceExtractionRequest): Promise<RemittanceExtractionEnvelope>;
  releaseChargeBatch(input: ReleaseChargeBatchRequest): Promise<ChargeReleaseEnvelope>;
  removeWaitlistEntry(input: RemoveWaitlistEntryRequest): Promise<WaitlistEntryEnvelope>;
  renderCms1500(input: RenderCms1500Request): Promise<void>;
  reopenClaim(input: ReopenClaimRequest): Promise<Envelope_ClaimClosureResource_>;
  repairAndResubmitClaim(input: RepairAndResubmitClaimRequest): Promise<Envelope_OperationResource_>;
  replaceClinicalNoteTimeEntries(input: ReplaceClinicalNoteTimeEntriesRequest): Promise<ClinicalNoteEnvelope>;
  requestAdjustment(input: RequestAdjustmentRequest): Promise<AdjustmentEnvelope>;
  requestAppointmentVoiceCall(input: RequestAppointmentVoiceCallRequest): Promise<VoiceCallRequestedEnvelope>;
  requestBalanceVoiceCall(input: RequestBalanceVoiceCallRequest): Promise<VoiceCallRequestedEnvelope>;
  requestBooking(input: RequestBookingRequest): Promise<BookingRequestReceivedEnvelope>;
  requestPasswordReset(input: RequestPasswordResetRequest): Promise<PasswordRecoveryEnvelope>;
  requestPayerVoiceCall(input: RequestPayerVoiceCallRequest): Promise<VoiceCallRequestedEnvelope>;
  requestRefund(input: RequestRefundRequest): Promise<RefundEnvelope>;
  resetPassword(input: ResetPasswordRequest): Promise<PasswordRecoveryEnvelope>;
  resetUserMfa(input: ResetUserMfaRequest): Promise<MfaStatusEnvelope>;
  resolveDenial(input: ResolveDenialRequest): Promise<DenialEnvelope>;
  resolveObligation(input: ResolveObligationRequest): Promise<ObligationEnvelope>;
  resolvePayerToDirectory(input: ResolvePayerToDirectoryRequest): Promise<PayerEnvelope>;
  resolveWorkItem(input: ResolveWorkItemRequest): Promise<WorkItemEnvelope>;
  resumePolicyBand(input: ResumePolicyBandRequest): Promise<Envelope_PolicyBandResource_>;
  retireConsentForm(input: RetireConsentFormRequest): Promise<ConsentFormEnvelope>;
  retireCustomField(input: RetireCustomFieldRequest): Promise<CustomFieldDefinitionEnvelope>;
  retireNoteTemplate(input: RetireNoteTemplateRequest): Promise<NoteTemplateEnvelope>;
  retryEmailOutboxMessage(input: RetryEmailOutboxMessageRequest): Promise<EmailLogEntryEnvelope>;
  reversePatientPayment(input: ReversePatientPaymentRequest): Promise<PatientPaymentEnvelope>;
  reversePostingRun(input: ReversePostingRunRequest): Promise<PostingReversalEnvelope>;
  revertSetting(input: RevertSettingRequest): Promise<Envelope_SettingResource_>;
  reviewClaimAiSuggestion(input: ReviewClaimAiSuggestionRequest): Promise<ClaimSuggestionEnvelope>;
  reviewClinicalNoteAiSuggestion(input: ReviewClinicalNoteAiSuggestionRequest): Promise<NoteSuggestionEnvelope>;
  reviewCodingProposal(input: ReviewCodingProposalRequest): Promise<CodingProposalEnvelope>;
  reviewDenialAiSuggestion(input: ReviewDenialAiSuggestionRequest): Promise<AiSuggestionEnvelope>;
  reviewDocumentClassification(input: ReviewDocumentClassificationRequest): Promise<DocumentClassificationEnvelope>;
  reviewImportMapping(input: ReviewImportMappingRequest): Promise<ImportMappingSuggestionEnvelope>;
  reviewPatientExplanationSuggestion(input: ReviewPatientExplanationSuggestionRequest): Promise<Envelope_ExplanationSuggestionResource_>;
  reviewSuperbillExtraction(input: ReviewSuperbillExtractionRequest): Promise<SuperbillExtractionEnvelope>;
  revokeCarePlanSignoff(input: RevokeCarePlanSignoffRequest): Promise<CarePlanSignoffEnvelope>;
  revokeConsentRequest(input: RevokeConsentRequestRequest): Promise<ConsentRequestEnvelope>;
  revokeIntakeInvitation(input: RevokeIntakeInvitationRequest): Promise<IntakeInvitationEnvelope>;
  revokeRoleGrant(input: RevokeRoleGrantRequest): Promise<Envelope_RoleGrantResource_>;
  saveChargeTemplate(input: SaveChargeTemplateRequest): Promise<ChargeTemplateEnvelope>;
  saveReportDefinition(input: SaveReportDefinitionRequest): Promise<ReportDefinitionEnvelope>;
  saveServiceMapping(input: SaveServiceMappingRequest): Promise<Envelope_ServiceMappingResource_>;
  searchPayerDirectory(input?: SearchPayerDirectoryRequest): Promise<PayerDirectoryEnvelope>;
  sendAppointmentReminders(input: SendAppointmentRemindersRequest): Promise<SendRemindersEnvelope>;
  sendPatientStatement(input: SendPatientStatementRequest): Promise<Envelope_PatientStatementResource_>;
  setOwnDefaultPractice(input: SetOwnDefaultPracticeRequest): Promise<DefaultPracticeEnvelope>;
  setPatientAddress(input: SetPatientAddressRequest): Promise<PatientAddressSetEnvelope>;
  setPatientCustomFields(input: SetPatientCustomFieldsRequest): Promise<PatientCustomFieldsEnvelope>;
  setPayerNcci(input: SetPayerNcciRequest): Promise<PayerEnvelope>;
  setPayerRoute(input: SetPayerRouteRequest): Promise<PayerEnvelope>;
  setPracticeBookingLink(input: SetPracticeBookingLinkRequest): Promise<BookingLinkEnvelope>;
  settleExpiredPackages(input: SettleExpiredPackagesRequest): Promise<PackageSettleEnvelope>;
  shadowEvaluateScrubRule(input: ShadowEvaluateScrubRuleRequest): Promise<Envelope_ShadowEvaluationResource_>;
  signClinicalNote(input: SignClinicalNoteRequest): Promise<ClinicalNoteEnvelope>;
  signOffImport(input: SignOffImportRequest): Promise<ImportBatchEnvelope>;
  signOut(input?: SignOutRequest): Promise<void>;
  stageImport(input: StageImportRequest): Promise<ImportBatchEnvelope>;
  startSupportSession(input: StartSupportSessionRequest): Promise<Envelope_SupportSessionResource_>;
  strandExpiredClaimSubmissions(input?: StrandExpiredClaimSubmissionsRequest): Promise<StrandedReservationsEnvelope>;
  submitAppeal(input: SubmitAppealRequest): Promise<AppealEnvelope>;
  submitClaim(input: SubmitClaimRequest): Promise<Envelope_OperationResource_>;
  submitIntakeForm(input: SubmitIntakeFormRequest): Promise<IntakeSubmittedEnvelope>;
  suggestClaimDenialPrevention(input: SuggestClaimDenialPreventionRequest): Promise<Envelope_OperationResource_>;
  suggestDenialRootCause(input: SuggestDenialRootCauseRequest): Promise<Envelope_OperationResource_>;
  suggestImportMapping(input: SuggestImportMappingRequest): Promise<Envelope_OperationResource_>;
  suggestPatientBalanceExplanation(input: SuggestPatientBalanceExplanationRequest): Promise<Envelope_OperationResource_>;
  summariseClaimPayerCall(input: SummariseClaimPayerCallRequest): Promise<Envelope_OperationResource_>;
  sweepProviderObligations(input: SweepProviderObligationsRequest): Promise<Envelope_ProviderObligationSweepResource_>;
  sweepUnderpayments(input: SweepUnderpaymentsRequest): Promise<SweepEnvelope>;
  takePatientPayment(input: TakePatientPaymentRequest): Promise<PatientPaymentEnvelope>;
  updateCarePlan(input: UpdateCarePlanRequest): Promise<CarePlanEnvelope>;
  updateClinicalNote(input: UpdateClinicalNoteRequest): Promise<ClinicalNoteEnvelope>;
  updateCoverage(input: UpdateCoverageRequest): Promise<CoverageEnvelope>;
  updateLocation(input: UpdateLocationRequest): Promise<LocationEnvelope>;
  updatePackagePlan(input: UpdatePackagePlanRequest): Promise<PackagePlanEnvelope>;
  updatePatient(input: UpdatePatientRequest): Promise<PatientEnvelope>;
  updatePayer(input: UpdatePayerRequest): Promise<PayerEnvelope>;
  updatePractice(input: UpdatePracticeRequest): Promise<PracticeEnvelope>;
  updateProvider(input: UpdateProviderRequest): Promise<Envelope_ProviderResource_>;
  updateProviderEnrollment(input: UpdateProviderEnrollmentRequest): Promise<Envelope_EnrollmentResource_>;
  updateReferral(input: UpdateReferralRequest): Promise<ReferralEnvelope>;
  updateScheduleTemplate(input: UpdateScheduleTemplateRequest): Promise<Envelope_TemplateResource_>;
  updateVisitType(input: UpdateVisitTypeRequest): Promise<Envelope_VisitTypeResource_>;
  upsertChargeRule(input: UpsertChargeRuleRequest): Promise<ChargeRuleEnvelope>;
  upsertCodeGroup(input: UpsertCodeGroupRequest): Promise<CodeGroupEnvelope>;
  upsertProcedureAttribute(input: UpsertProcedureAttributeRequest): Promise<ProcedureAttributeEnvelope>;
  upsertUnitMethod(input: UpsertUnitMethodRequest): Promise<UnitMethodEnvelope>;
  validateClaim(input: ValidateClaimRequest): Promise<Envelope_OperationResource_>;
  verifyPayerIdentifier(input: VerifyPayerIdentifierRequest): Promise<PayerEnvelope>;
  versionNoteTemplate(input: VersionNoteTemplateRequest): Promise<NoteTemplateEnvelope>;
  voidCharge(input: VoidChargeRequest): Promise<ChargeEnvelope>;
  voidClaim(input: VoidClaimRequest): Promise<Envelope_ClaimClosureResource_>;
  voidReferral(input: VoidReferralRequest): Promise<ReferralEnvelope>;
  waiveObligation(input: WaiveObligationRequest): Promise<ObligationEnvelope>;
  withdrawClaimScrubOverride(input: WithdrawClaimScrubOverrideRequest): Promise<void>;
}

/**
 * Build a client bound to one configuration.
 *
 * Every method returns the parsed success envelope and throws `SarvaApiError` carrying the
 * RFC 9457 problem document on any non-2xx (doc 22 §3, §4).
 */
export function createSarvaApiClient(config: ClientConfig): SarvaApiClient {
  return {
    acceptBookingRequest: (input) =>
      send<BookingRequestEnvelope>(config, {
        method: "POST",
        path: `/api/v1/booking-requests/${encodeURIComponent(String(input.path.booking_request_id))}:accept`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    acceptConsentLink: (input) =>
      send<ConsentLinkAcceptedEnvelope>(config, {
        method: "POST",
        path: `/api/v1/consent/${encodeURIComponent(String(input.path.token))}`,
        body: input.body,
        signal: input.signal,
      }),
    acceptPatientFeedConflict: (input) =>
      send<FeedConflictEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patient-feed-conflicts/${encodeURIComponent(String(input.path.conflict_id))}:accept`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    activateCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}:activate`,
        headers: input.headers,
        signal: input.signal,
      }),
    addChargesToBatch: (input) =>
      send<ChargeBatchAddEnvelope>(config, {
        method: "POST",
        path: `/api/v1/charge-batches/${encodeURIComponent(String(input.path.batch_id))}:add-charges`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    addClinicalNoteAddendum: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}/addenda`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    addPatientCoverage: (input) =>
      send<CoverageEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/coverages`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    addPatientGuarantor: (input) =>
      send<Envelope_GuarantorResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/guarantors`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    addProviderIdentifier: (input) =>
      send<Envelope_ProviderIdentifierResource_>(config, {
        method: "POST",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}/identifiers`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    addToWaitlist: (input) =>
      send<WaitlistEntryEnvelope>(config, {
        method: "POST",
        path: "/api/v1/waitlist",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    amendCharge: (input) =>
      send<ChargeEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/charges/${encodeURIComponent(String(input.path.charge_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    answerPlanSignoff: (input) =>
      send<PlanSignoffAnsweredEnvelope>(config, {
        method: "POST",
        path: `/api/v1/plan-signoff/${encodeURIComponent(String(input.path.token))}`,
        body: input.body,
        signal: input.signal,
      }),
    applyChargeTemplate: (input) =>
      send<ChargeListEnvelope>(config, {
        method: "POST",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/charges:from-template`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    approveAdjustment: (input) =>
      send<AdjustmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/adjustments/${encodeURIComponent(String(input.path.adjustment_id))}:approve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    approveAppeal: (input) =>
      send<AppealEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appeals/${encodeURIComponent(String(input.path.appeal_id))}:approve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    approveRefund: (input) =>
      send<RefundEnvelope>(config, {
        method: "POST",
        path: `/api/v1/refunds/${encodeURIComponent(String(input.path.refund_id))}:approve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    archiveChargeTemplate: (input) =>
      send<ChargeTemplateEnvelope>(config, {
        method: "POST",
        path: `/api/v1/charge-templates/${encodeURIComponent(String(input.path.template_id))}:archive`,
        headers: input.headers,
        signal: input.signal,
      }),
    archivePractice: (input) =>
      send<PracticeEnvelope>(config, {
        method: "POST",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}:archive`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    assignRole: (input) =>
      send<Envelope_RoleGrantResource_>(config, {
        method: "POST",
        path: `/api/v1/users/${encodeURIComponent(String(input.path.user_id))}/role-grants`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    assignWorkItem: (input) =>
      send<WorkItemEnvelope>(config, {
        method: "POST",
        path: `/api/v1/work-items/${encodeURIComponent(String(input.path.work_item_id))}:assign`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    bookAppointment: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: "/api/v1/appointments",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    bookAppointmentSeries: (input) =>
      send<AppointmentSeriesEnvelope>(config, {
        method: "POST",
        path: "/api/v1/appointment-series",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    bookWaitlistEntry: (input) =>
      send<WaitlistEntryEnvelope>(config, {
        method: "POST",
        path: `/api/v1/waitlist/${encodeURIComponent(String(input.path.entry_id))}:book`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    bulkLoadFeeScheduleLines: (input) =>
      send<FeeScheduleBulkEnvelope>(config, {
        method: "POST",
        path: `/api/v1/fee-schedules/${encodeURIComponent(String(input.path.fee_schedule_id))}/lines:bulk`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    cancelAppointment: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:cancel`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    cancelAppointmentFromReminder: (input) =>
      send<ReminderPageEnvelope>(config, {
        method: "POST",
        path: `/api/v1/reminders/${encodeURIComponent(String(input.path.token))}:cancel`,
        signal: input.signal,
      }),
    cancelAppointmentSeries: (input) =>
      send<AppointmentSeriesEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointment-series/${encodeURIComponent(String(input.path.series_id))}:cancel`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    cancelPaymentPlan: (input) =>
      send<PaymentPlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/payment-plans/${encodeURIComponent(String(input.path.plan_id))}:cancel`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    certifyCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}:certify`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    changeOwnPassword: (input) =>
      send<PasswordChangeEnvelope>(config, {
        method: "POST",
        path: "/api/v1/me/password",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    chargeMissedVisitFee: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:charge-missed-visit-fee`,
        headers: input.headers,
        signal: input.signal,
      }),
    checkAppointmentAuthorization: (input) =>
      send<AppointmentAuthorizationCheckEnvelope>(config, {
        method: "GET",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}/authorization-check`,
        headers: input.headers,
        signal: input.signal,
      }),
    checkClaimStatus: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:check-status`,
        headers: input.headers,
        signal: input.signal,
      }),
    checkClinicalNoteDocumentation: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:check-documentation`,
        headers: input.headers,
        signal: input.signal,
      }),
    checkCodingCompliance: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/coding-reviews/${encodeURIComponent(String(input.path.review_id))}:check-compliance`,
        headers: input.headers,
        signal: input.signal,
      }),
    checkEligibilityForDueVisits: (input) =>
      send<DueCheckEnvelope>(config, {
        method: "POST",
        path: "/api/v1/appointments:check-eligibility-due",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    checkoutVisit: (input) =>
      send<CheckoutEnvelope>(config, {
        method: "POST",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}:checkout`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    checkPatientBillingReadiness: (input) =>
      send<Envelope_BillingReadinessResource_>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:billing-readiness`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    checkPatientDuplicates: (input) =>
      send<DuplicateCheckEnvelope>(config, {
        method: "POST",
        path: "/api/v1/patients:check-duplicates",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    checkPatientEligibility: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:check-eligibility`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    checkProviderSubmissionEligibility: (input) =>
      send<Envelope_SubmissionEligibilityResource_>(config, {
        method: "GET",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}:submission-eligibility`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    classifyDenial: (input) =>
      send<DenialEnvelope>(config, {
        method: "POST",
        path: `/api/v1/denials/${encodeURIComponent(String(input.path.denial_id))}:classify`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    classifyDocument: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: "/api/v1/documents:classify",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    classifyRetainedDocument: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/documents/${encodeURIComponent(String(input.path.document_id))}:classify`,
        headers: input.headers,
        signal: input.signal,
      }),
    closeAccountingPeriod: (input) =>
      send<AccountingPeriodEnvelope>(config, {
        method: "POST",
        path: "/api/v1/accounting-periods:close",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    closeClaim: (input) =>
      send<Envelope_ClaimClosureResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:close`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    closePatientFeedConflict: (input) =>
      send<FeedConflictEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patient-feed-conflicts/${encodeURIComponent(String(input.path.conflict_id))}:close`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    closeSettledClaims: (input = {}) =>
      send<Envelope_SettledSweepResource_>(config, {
        method: "POST",
        path: "/api/v1/claims:close-settled",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    commitClinicalNoteCharges: (input) =>
      send<ChargeProposalEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:commit-charges`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    commitImport: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/imports/${encodeURIComponent(String(input.path.import_id))}:commit`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    completeCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}:complete`,
        headers: input.headers,
        signal: input.signal,
      }),
    completeWritebackTask: (input) =>
      send<WritebackTaskEnvelope>(config, {
        method: "POST",
        path: `/api/v1/writeback-tasks/${encodeURIComponent(String(input.path.task_id))}:done`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    confirmAppointmentFromReminder: (input) =>
      send<ReminderPageEnvelope>(config, {
        method: "POST",
        path: `/api/v1/reminders/${encodeURIComponent(String(input.path.token))}:confirm`,
        signal: input.signal,
      }),
    confirmMfa: (input) =>
      send<MfaStatusEnvelope>(config, {
        method: "POST",
        path: "/api/v1/me/mfa:confirm",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    correctClaim: (input) =>
      send<Envelope_ClaimReplacementResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:correct`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    correctFeeScheduleLine: (input) =>
      send<FeeScheduleLineEnvelope>(config, {
        method: "POST",
        path: `/api/v1/fee-schedules/${encodeURIComponent(String(input.path.fee_schedule_id))}/lines/${encodeURIComponent(String(input.path.line_id))}:correct`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    correctRejectedClaim: (input) =>
      send<RejectionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/rejections/${encodeURIComponent(String(input.path.rejection_id))}:correct`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    cosignClinicalNote: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:cosign`,
        headers: input.headers,
        signal: input.signal,
      }),
    createAppeal: (input) =>
      send<AppealEnvelope>(config, {
        method: "POST",
        path: "/api/v1/appeals",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "POST",
        path: "/api/v1/care-plans",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createCarePlanSignoff: (input) =>
      send<CarePlanSignoffEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}/signoff-requests`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createCharge: (input) =>
      send<ChargeEnvelope>(config, {
        method: "POST",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/charges`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createChargeBatch: (input) =>
      send<ChargeBatchEnvelope>(config, {
        method: "POST",
        path: "/api/v1/charge-batches",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createClaimFromCharges: (input) =>
      send<ClaimFromChargesEnvelope>(config, {
        method: "POST",
        path: "/api/v1/claims:from-charges",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createClinicalNote: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "POST",
        path: "/api/v1/clinical-notes",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createConsentRequest: (input) =>
      send<ConsentRequestEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/consent-requests`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createCustomField: (input) =>
      send<CustomFieldDefinitionEnvelope>(config, {
        method: "POST",
        path: "/api/v1/custom-fields",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createFeeSchedule: (input) =>
      send<FeeScheduleEnvelope>(config, {
        method: "POST",
        path: "/api/v1/fee-schedules",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createFeeScheduleLine: (input) =>
      send<FeeScheduleLineEnvelope>(config, {
        method: "POST",
        path: `/api/v1/fee-schedules/${encodeURIComponent(String(input.path.fee_schedule_id))}/lines`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createIntakeInvitation: (input) =>
      send<IntakeInvitationEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/intake-invitations`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createLocation: (input) =>
      send<LocationEnvelope>(config, {
        method: "POST",
        path: "/api/v1/locations",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createNoteTemplate: (input) =>
      send<NoteTemplateEnvelope>(config, {
        method: "POST",
        path: "/api/v1/note-templates",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPackagePlan: (input) =>
      send<PackagePlanEnvelope>(config, {
        method: "POST",
        path: "/api/v1/package-plans",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPatientEstimate: (input) =>
      send<Envelope_PatientEstimateResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/estimates`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPatientStatement: (input) =>
      send<Envelope_PatientStatementResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/statements`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPayer: (input) =>
      send<PayerEnvelope>(config, {
        method: "POST",
        path: "/api/v1/payers",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPayerAuthRequirement: (input) =>
      send<AuthRequirementEnvelope>(config, {
        method: "POST",
        path: "/api/v1/payer-auth-requirements",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPayerRule: (input) =>
      send<Envelope_PayerRuleResource_>(config, {
        method: "POST",
        path: "/api/v1/payer-rules",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPaymentPlan: (input) =>
      send<PaymentPlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/payment-plans`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPolicyBand: (input) =>
      send<Envelope_PolicyBandResource_>(config, {
        method: "POST",
        path: "/api/v1/policy-bands",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createPractice: (input) =>
      send<PracticeEnvelope>(config, {
        method: "POST",
        path: "/api/v1/practices",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createProvider: (input) =>
      send<Envelope_ProviderResource_>(config, {
        method: "POST",
        path: "/api/v1/providers",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createProviderEnrollment: (input) =>
      send<Envelope_EnrollmentResource_>(config, {
        method: "POST",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}/enrollments`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createScheduleBlock: (input) =>
      send<Envelope_ScheduleBlockResource_>(config, {
        method: "POST",
        path: "/api/v1/schedule-blocks",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createScheduleTemplate: (input) =>
      send<Envelope_TemplateResource_>(config, {
        method: "POST",
        path: "/api/v1/schedule-templates",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createScrubRule: (input) =>
      send<Envelope_ScrubRuleResource_>(config, {
        method: "POST",
        path: "/api/v1/scrub-rules",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createSetting: (input) =>
      send<Envelope_SettingResource_>(config, {
        method: "POST",
        path: "/api/v1/settings",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    createVisitType: (input) =>
      send<Envelope_VisitTypeResource_>(config, {
        method: "POST",
        path: "/api/v1/visit-types",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    deactivateUser: (input) =>
      send<Envelope_UserResource_>(config, {
        method: "POST",
        path: `/api/v1/users/${encodeURIComponent(String(input.path.user_id))}:deactivate`,
        headers: input.headers,
        signal: input.signal,
      }),
    declineBookingRequest: (input) =>
      send<BookingRequestEnvelope>(config, {
        method: "POST",
        path: `/api/v1/booking-requests/${encodeURIComponent(String(input.path.booking_request_id))}:decline`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    deleteReportDefinition: (input) =>
      send<void>(config, {
        method: "DELETE",
        path: `/api/v1/report-definitions/${encodeURIComponent(String(input.path.definition_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    deleteScheduleBlock: (input) =>
      send<void>(config, {
        method: "DELETE",
        path: `/api/v1/schedule-blocks/${encodeURIComponent(String(input.path.block_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    describeReasonCodes: (input = {}) =>
      send<ReasonCodeTextListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reason-codes",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    diagnoseClaimRejection: (input) =>
      send<RejectionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/rejections/${encodeURIComponent(String(input.path.rejection_id))}:diagnose`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    diffFeeSchedules: (input) =>
      send<ScheduleDiffEnvelope>(config, {
        method: "GET",
        path: `/api/v1/fee-schedules/${encodeURIComponent(String(input.path.fee_schedule_id))}/diff`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    disableMfa: (input) =>
      send<MfaStatusEnvelope>(config, {
        method: "POST",
        path: "/api/v1/me/mfa:disable",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    discardCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}:discard`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    discardClinicalNote: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:discard`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    discontinueCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}:discontinue`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    dismissWritebackTask: (input) =>
      send<WritebackTaskEnvelope>(config, {
        method: "POST",
        path: `/api/v1/writeback-tasks/${encodeURIComponent(String(input.path.task_id))}:not-applicable`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    draftAppealLetter: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/appeals/${encodeURIComponent(String(input.path.appeal_id))}:draft-letter`,
        headers: input.headers,
        signal: input.signal,
      }),
    draftClinicalNoteFromDictation: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:draft-from-dictation`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    endSupportSession: (input) =>
      send<Envelope_SupportSessionResource_>(config, {
        method: "POST",
        path: `/api/v1/support-sessions/${encodeURIComponent(String(input.path.session_id))}:end`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    enrolMfa: (input) =>
      send<MfaEnrolmentEnvelope>(config, {
        method: "POST",
        path: "/api/v1/me/mfa:enrol",
        headers: input.headers,
        signal: input.signal,
      }),
    enterRemittanceByHand: (input) =>
      send<RemittanceEnvelope>(config, {
        method: "POST",
        path: "/api/v1/remittances:enter",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    evaluateObligations: (input) =>
      send<EvaluationResultEnvelope>(config, {
        method: "POST",
        path: "/api/v1/obligations:evaluate",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    exchangeCoreToken: (input) =>
      send<TokenEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/core-exchange",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    explainPatientBalance: (input) =>
      send<Envelope_BalanceExplanationResource_>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:balance-explanation`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    exportClaimsCsv: (input = {}) =>
      send<void>(config, {
        method: "GET",
        path: "/api/v1/exports/claims.csv",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    exportDenialsCsv: (input = {}) =>
      send<void>(config, {
        method: "GET",
        path: "/api/v1/exports/denials.csv",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    exportGeneralLedgerCsv: (input = {}) =>
      send<void>(config, {
        method: "GET",
        path: "/api/v1/exports/general-ledger.csv",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    extractCodingDocumentation: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/coding-reviews/${encodeURIComponent(String(input.path.review_id))}:extract`,
        headers: input.headers,
        signal: input.signal,
      }),
    extractContractRates: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: "/api/v1/fee-schedules:extract-rates",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    extractPayerRules: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: "/api/v1/payer-rules:extract",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    extractRemittanceDocument: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: "/api/v1/remittances:extract-document",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    extractSuperbill: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/superbill:extract`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    findOrganisation: (input) =>
      send<OrganisationEnvelope>(config, {
        method: "GET",
        path: `/api/v1/auth/organisations/${encodeURIComponent(String(input.path.code))}`,
        signal: input.signal,
      }),
    getAppeal: (input) =>
      send<AppealEnvelope>(config, {
        method: "GET",
        path: `/api/v1/appeals/${encodeURIComponent(String(input.path.appeal_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getAppealOutcomes: (input = {}) =>
      send<AppealOutcomesEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/appeal-outcomes",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getAppointment: (input) =>
      send<AppointmentDetailEnvelope>(config, {
        method: "GET",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getAppointmentReminder: (input) =>
      send<ReminderPageEnvelope>(config, {
        method: "GET",
        path: `/api/v1/reminders/${encodeURIComponent(String(input.path.token))}`,
        signal: input.signal,
      }),
    getArAging: (input = {}) =>
      send<Envelope_ArAgingResource_>(config, {
        method: "GET",
        path: "/api/v1/reports/ar-aging",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getBalanceDrift: (input = {}) =>
      send<Envelope_BalanceDriftResource_>(config, {
        method: "GET",
        path: "/api/v1/reports/balance-drift",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getBaselineDiagnostic: (input = {}) =>
      send<BaselineDiagnosticEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/baseline-diagnostic",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getBookingPage: (input) =>
      send<BookingPageEnvelope>(config, {
        method: "GET",
        path: `/api/v1/booking/${encodeURIComponent(String(input.path.token))}`,
        signal: input.signal,
      }),
    getCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "GET",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getCarePlanCertificationForm: (input) =>
      send<void>(config, {
        method: "GET",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}/certification.pdf`,
        headers: input.headers,
        signal: input.signal,
      }),
    getCarePlanOutcomes: (input) =>
      send<CarePlanOutcomesEnvelope>(config, {
        method: "GET",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}/outcomes`,
        headers: input.headers,
        signal: input.signal,
      }),
    getClaim: (input) =>
      send<ClaimEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getClaimCoordinationOfBenefits: (input) =>
      send<CoordinationOfBenefitsEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/coordination-of-benefits`,
        headers: input.headers,
        signal: input.signal,
      }),
    getClinicalNote: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "GET",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getClinicalNoteChargeProposal: (input) =>
      send<ChargeProposalEnvelope>(config, {
        method: "GET",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}/charge-proposal`,
        headers: input.headers,
        signal: input.signal,
      }),
    getClinicalNoteCopy: (input) =>
      send<void>(config, {
        method: "GET",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}/copy.pdf`,
        headers: input.headers,
        signal: input.signal,
      }),
    getCodingReview: (input) =>
      send<CodingReviewEnvelope>(config, {
        method: "GET",
        path: `/api/v1/coding-reviews/${encodeURIComponent(String(input.path.review_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getCollectionsStatement: (input) =>
      send<CollectionsStatementEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/collections-statement`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getConsentLink: (input) =>
      send<ConsentLinkEnvelope>(config, {
        method: "GET",
        path: `/api/v1/consent/${encodeURIComponent(String(input.path.token))}`,
        signal: input.signal,
      }),
    getDailyDigest: (input = {}) =>
      send<DailyDigestEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/daily-digest",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getDaySheet: (input = {}) =>
      send<DaySheetEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/day-sheet",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getDenial: (input) =>
      send<DenialEnvelope>(config, {
        method: "GET",
        path: `/api/v1/denials/${encodeURIComponent(String(input.path.denial_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getDocument: (input) =>
      send<DocumentEnvelope>(config, {
        method: "GET",
        path: `/api/v1/documents/${encodeURIComponent(String(input.path.document_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getDocumentContent: (input) =>
      send<void>(config, {
        method: "GET",
        path: `/api/v1/documents/${encodeURIComponent(String(input.path.document_id))}/content`,
        headers: input.headers,
        signal: input.signal,
      }),
    getEncounterSourceInvoice: (input) =>
      send<SourceInvoiceEnvelope>(config, {
        method: "GET",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/source-invoice`,
        headers: input.headers,
        signal: input.signal,
      }),
    getEncounterSuperbill: (input) =>
      send<void>(config, {
        method: "GET",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/superbill.pdf`,
        headers: input.headers,
        signal: input.signal,
      }),
    getEstateCapabilities: (input = {}) =>
      send<EstateCapabilitiesEnvelope>(config, {
        method: "GET",
        path: "/api/v1/estate/capabilities",
        headers: input.headers,
        signal: input.signal,
      }),
    getHealth: (input = {}) =>
      send<HealthEnvelope>(config, {
        method: "GET",
        path: "/api/v1/health",
        signal: input.signal,
      }),
    getImport: (input) =>
      send<ImportBatchEnvelope>(config, {
        method: "GET",
        path: `/api/v1/imports/${encodeURIComponent(String(input.path.import_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getIntakeForm: (input) =>
      send<IntakeFormEnvelope>(config, {
        method: "GET",
        path: `/api/v1/intake/${encodeURIComponent(String(input.path.token))}`,
        signal: input.signal,
      }),
    getLossIncident: (input) =>
      send<LossIncidentEnvelope>(config, {
        method: "GET",
        path: `/api/v1/loss-incidents/${encodeURIComponent(String(input.path.loss_incident_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getMe: (input = {}) =>
      send<MeEnvelope>(config, {
        method: "GET",
        path: "/api/v1/me",
        headers: input.headers,
        signal: input.signal,
      }),
    getNoteTemplate: (input) =>
      send<NoteTemplateEnvelope>(config, {
        method: "GET",
        path: `/api/v1/note-templates/${encodeURIComponent(String(input.path.template_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getNoteTemplateVersion: (input) =>
      send<NoteTemplateVersionEnvelope>(config, {
        method: "GET",
        path: `/api/v1/note-template-versions/${encodeURIComponent(String(input.path.version_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getObligation: (input) =>
      send<ObligationEnvelope>(config, {
        method: "GET",
        path: `/api/v1/obligations/${encodeURIComponent(String(input.path.obligation_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getOperation: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "GET",
        path: `/api/v1/operations/${encodeURIComponent(String(input.path.operation_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatient: (input) =>
      send<PatientEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatientAccount: (input) =>
      send<PatientAccountEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/account`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatientConsents: (input) =>
      send<ConsentStatusEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/consents`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatientCustomFields: (input) =>
      send<PatientCustomFieldsEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/custom-fields`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatientLedger: (input) =>
      send<PatientLedgerEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/ledger`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatientStatementDocument: (input) =>
      send<void>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/statements/${encodeURIComponent(String(input.path.statement_id))}/statement.pdf`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPatientThresholds: (input) =>
      send<ThresholdProgressEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/thresholds`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getPayer: (input) =>
      send<PayerEnvelope>(config, {
        method: "GET",
        path: `/api/v1/payers/${encodeURIComponent(String(input.path.payer_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPayerScorecard: (input = {}) =>
      send<PayerScorecardEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/payer-scorecard",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getPeriodReconciliation: (input) =>
      send<PeriodReconciliationEnvelope>(config, {
        method: "GET",
        path: `/api/v1/accounting-periods/${encodeURIComponent(String(input.path.period))}/reconciliation`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getPlanSignoff: (input) =>
      send<PlanSignoffViewEnvelope>(config, {
        method: "GET",
        path: `/api/v1/plan-signoff/${encodeURIComponent(String(input.path.token))}`,
        signal: input.signal,
      }),
    getPostingRun: (input) =>
      send<PostingRunEnvelope>(config, {
        method: "GET",
        path: `/api/v1/posting-runs/${encodeURIComponent(String(input.path.posting_run_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPractice: (input) =>
      send<PracticeEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getPracticeActivity: (input = {}) =>
      send<PracticeActivityEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/practice-activity",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getPriorAuthorization: (input) =>
      send<PriorAuthEnvelope>(config, {
        method: "GET",
        path: `/api/v1/prior-authorizations/${encodeURIComponent(String(input.path.prior_auth_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getQueueHealth: (input = {}) =>
      send<QueueHealthListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/work-queues/health",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getRateCoverage: (input = {}) =>
      send<RateCoverageEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/rate-coverage",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getRemittance: (input) =>
      send<RemittanceEnvelope>(config, {
        method: "GET",
        path: `/api/v1/remittances/${encodeURIComponent(String(input.path.remittance_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getScoreboard: (input = {}) =>
      send<Envelope_ScoreboardResource_>(config, {
        method: "GET",
        path: "/api/v1/reports/scoreboard",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getSuperbillExtraction: (input) =>
      send<SuperbillExtractionEnvelope>(config, {
        method: "GET",
        path: `/api/v1/superbill-extractions/${encodeURIComponent(String(input.path.extraction_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    getSweepHealth: (input = {}) =>
      send<SweepHealthEnvelope>(config, {
        method: "GET",
        path: "/api/v1/health/sweep",
        signal: input.signal,
      }),
    getUnappliedCash: (input = {}) =>
      send<UnappliedCashEnvelope>(config, {
        method: "GET",
        path: "/api/v1/reports/unapplied-cash",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    getVisitCheckout: (input) =>
      send<CheckoutEnvelope>(config, {
        method: "GET",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/checkout`,
        headers: input.headers,
        signal: input.signal,
      }),
    getWorkItem: (input) =>
      send<WorkItemEnvelope>(config, {
        method: "GET",
        path: `/api/v1/work-items/${encodeURIComponent(String(input.path.work_item_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    holdCharge: (input) =>
      send<ChargeEnvelope>(config, {
        method: "POST",
        path: `/api/v1/charges/${encodeURIComponent(String(input.path.charge_id))}:hold`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    importBankStatement: (input) =>
      send<BankStatementImportEnvelope>(config, {
        method: "POST",
        path: "/api/v1/bank-statements",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    ingestRemittance: (input) =>
      send<RemittanceEnvelope>(config, {
        method: "POST",
        path: "/api/v1/remittances",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    installSpecialtyPack: (input) =>
      send<PackInstallEnvelope>(config, {
        method: "POST",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/specialty-packs/${encodeURIComponent(String(input.path.pack_key))}:install`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    intakeSourceInvoice: (input) =>
      send<SourceInvoiceIntakeEnvelope>(config, {
        method: "POST",
        path: "/api/v1/encounters:from-source-invoice",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    inviteUser: (input) =>
      send<Envelope_UserResource_>(config, {
        method: "POST",
        path: "/api/v1/users",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    issueClientToken: (input) =>
      send<TokenEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/client-token",
        body: input.body,
        signal: input.signal,
      }),
    issueRefund: (input) =>
      send<RefundEnvelope>(config, {
        method: "POST",
        path: `/api/v1/refunds/${encodeURIComponent(String(input.path.refund_id))}:issue`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    issueToken: (input) =>
      send<TokenEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/token",
        body: input.body,
        signal: input.signal,
      }),
    launchSession: (input) =>
      send<TokenEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/launch",
        body: input.body,
        signal: input.signal,
      }),
    linkAppointmentAuthorization: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:link-authorization`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    linkPracticeToHub: (input) =>
      send<PracticeEnvelope>(config, {
        method: "POST",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}:link-hub`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    listAccountingPeriods: (input = {}) =>
      send<AccountingPeriodListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/accounting-periods",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listAdjustments: (input = {}) =>
      send<AdjustmentListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/adjustments",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listAppealLetterSuggestions: (input) =>
      send<AppealLetterSuggestionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/appeals/${encodeURIComponent(String(input.path.appeal_id))}/letter-suggestions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listAppeals: (input = {}) =>
      send<AppealListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/appeals",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listAppointments: (input = {}) =>
      send<AppointmentListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/appointments",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listAppointmentsDueEligibility: (input = {}) =>
      send<EligibilityDueEnvelope>(config, {
        method: "GET",
        path: "/api/v1/appointments:eligibility-due",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listAuditEntries: (input = {}) =>
      send<AuditEntryListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/audit-log",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listBenefitSuggestions: (input) =>
      send<BenefitSuggestionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/eligibility-responses/${encodeURIComponent(String(input.path.response_id))}/benefit-suggestions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listBookableSlots: (input) =>
      send<Envelope_list_BookableSlotResource__>(config, {
        method: "GET",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}/slots`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listBookingRequests: (input = {}) =>
      send<BookingRequestListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/booking-requests",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listBookingSlots: (input) =>
      send<BookingSlotListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/booking/${encodeURIComponent(String(input.path.token))}/slots`,
        query: input.query,
        signal: input.signal,
      }),
    listCarePlanSignoffs: (input) =>
      send<CarePlanSignoffListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}/signoff-requests`,
        headers: input.headers,
        signal: input.signal,
      }),
    listChargeBatches: (input = {}) =>
      send<ChargeBatchListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/charge-batches",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listChargeRules: (input) =>
      send<ChargeRuleListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/charge-rules`,
        headers: input.headers,
        signal: input.signal,
      }),
    listCharges: (input = {}) =>
      send<ChargeListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/charges",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listChargeTemplates: (input = {}) =>
      send<ChargeTemplateListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/charge-templates",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimAcknowledgements: (input) =>
      send<ClaimAcknowledgementListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/acknowledgements`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimAcknowledgementsAcrossClaims: (input = {}) =>
      send<ClaimAcknowledgementListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/claim-acknowledgements",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimAiSuggestions: (input) =>
      send<ClaimSuggestionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/ai-suggestions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimFollowUpNotes: (input) =>
      send<Envelope_list_FollowUpNoteResource__>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/notes`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimRejections: (input) =>
      send<RejectionHistoryEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/rejections`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaims: (input = {}) =>
      send<ClaimListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/claims",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimScrubOverrides: (input) =>
      send<ScrubOverrideListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/scrub-overrides`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimScrubResults: (input) =>
      send<ScrubResultListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/scrub-results`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimStatusChecks: (input) =>
      send<ClaimStatusHistoryEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/status-checks`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimSubmissions: (input) =>
      send<ClaimSubmissionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/submissions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listClaimSubmissionsAcrossClaims: (input = {}) =>
      send<ClaimSubmissionListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/claim-submissions",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listClinicalNoteAiSuggestions: (input) =>
      send<NoteSuggestionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}/ai-suggestions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listCodeGroups: (input) =>
      send<CodeGroupListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/code-groups`,
        headers: input.headers,
        signal: input.signal,
      }),
    listCodeSets: (input = {}) =>
      send<CodeSetListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/code-sets",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listCollectionPlacements: (input = {}) =>
      send<PlacementListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/collection-placements",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listConsentForms: (input) =>
      send<ConsentFormListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/consent-forms`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listConsentFormTemplates: (input = {}) =>
      send<ConsentTemplateListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/consent-form-templates",
        headers: input.headers,
        signal: input.signal,
      }),
    listConsentRequests: (input) =>
      send<ConsentRequestListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/consent-requests`,
        headers: input.headers,
        signal: input.signal,
      }),
    listCreditBalances: (input = {}) =>
      send<CreditBalanceListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/credit-balances",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listCustomFields: (input = {}) =>
      send<CustomFieldDefinitionListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/custom-fields",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listDenialAiSuggestions: (input) =>
      send<AiSuggestionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/denials/${encodeURIComponent(String(input.path.denial_id))}/ai-suggestions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listDenials: (input = {}) =>
      send<DenialListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/denials",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listDocumentClassifications: (input = {}) =>
      send<DocumentClassificationListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/document-classifications",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listDocuments: (input = {}) =>
      send<DocumentListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/documents",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listDueFollowUpNotes: (input = {}) =>
      send<Envelope_list_FollowUpNoteResource__>(config, {
        method: "GET",
        path: "/api/v1/follow-up-notes:due",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listDuplicatePatients: (input = {}) =>
      send<DuplicatePairListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/patients:duplicates",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listEmailOutbox: (input = {}) =>
      send<EmailLogEnvelope>(config, {
        method: "GET",
        path: "/api/v1/email-outbox",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listEncounterCharges: (input) =>
      send<ChargeListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/charges`,
        headers: input.headers,
        signal: input.signal,
      }),
    listEncounterClinicalNotes: (input) =>
      send<ClinicalNoteListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/clinical-notes`,
        headers: input.headers,
        signal: input.signal,
      }),
    listEncounters: (input = {}) =>
      send<EncounterListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/encounters",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listFeeScheduleLines: (input) =>
      send<FeeScheduleLineListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/fee-schedules/${encodeURIComponent(String(input.path.fee_schedule_id))}/lines`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listFeeSchedules: (input = {}) =>
      send<FeeScheduleListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/fee-schedules",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listImportMappingSuggestions: (input = {}) =>
      send<ImportMappingSuggestionListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/import-mappings",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listImports: (input = {}) =>
      send<ImportBatchListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/imports",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listInsuranceCardReadings: (input) =>
      send<InsuranceCardReadingListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/insurance-card-readings`,
        headers: input.headers,
        signal: input.signal,
      }),
    listIntakeForms: (input = {}) =>
      send<IntakeFormChoiceListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/intake-forms",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listIntakeInvitations: (input) =>
      send<IntakeInvitationListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/intake-invitations`,
        headers: input.headers,
        signal: input.signal,
      }),
    listLocations: (input = {}) =>
      send<LocationListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/locations",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listLossIncidents: (input = {}) =>
      send<LossIncidentListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/loss-incidents",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listNotesAwaitingCosignature: (input = {}) =>
      send<ClinicalNoteListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/clinical-notes:awaiting-cosignature",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listNoteTemplates: (input = {}) =>
      send<NoteTemplateListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/note-templates",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listObligations: (input = {}) =>
      send<ObligationListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/obligations",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPackagePlans: (input = {}) =>
      send<PackagePlanListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/package-plans",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPackagePlansOnSale: (input = {}) =>
      send<PackagePlanListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/package-plans:on-sale",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientAppointmentSeries: (input) =>
      send<AppointmentSeriesListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/appointment-series`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientCarePlans: (input) =>
      send<CarePlanListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/care-plans`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientClinicalNotes: (input) =>
      send<ClinicalNoteListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/clinical-notes`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientCoverages: (input) =>
      send<CoverageListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/coverages`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientEligibilityChecks: (input) =>
      send<EligibilityListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/eligibility-checks`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientEstimates: (input) =>
      send<Envelope_list_PatientEstimateResource__>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/estimates`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientExplanationSuggestions: (input) =>
      send<Envelope_list_ExplanationSuggestionResource__>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/explanation-suggestions`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientFeedConflicts: (input) =>
      send<FeedConflictListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/feed-conflicts`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientFollowUpNotes: (input) =>
      send<Envelope_list_FollowUpNoteResource__>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/notes`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientGuarantors: (input) =>
      send<Envelope_list_GuarantorResource__>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/guarantors`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientPackages: (input) =>
      send<PatientPackageListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/packages`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientPriorAuthorizations: (input) =>
      send<PriorAuthListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/prior-authorizations`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientReferrals: (input) =>
      send<ReferralListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/referrals`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatients: (input = {}) =>
      send<PatientListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/patients",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientsOwing: (input = {}) =>
      send<PatientOwingEnvelope>(config, {
        method: "GET",
        path: "/api/v1/patient-balances",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientStatements: (input) =>
      send<Envelope_list_PatientStatementResource__>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/statements`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientVisitChoices: (input) =>
      send<VisitChoiceListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/visits:choices`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientVoiceCalls: (input) =>
      send<VoiceCallListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/voice-calls`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPatientVoiceOutcomes: (input) =>
      send<VoiceOutcomeListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/voice-outcomes`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPayerAuthRequirements: (input = {}) =>
      send<AuthRequirementListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/payer-auth-requirements",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPayerChoices: (input = {}) =>
      send<PayerChoiceListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/payers:choices",
        headers: input.headers,
        signal: input.signal,
      }),
    listPayerRules: (input = {}) =>
      send<Envelope_list_PayerRuleResource__>(config, {
        method: "GET",
        path: "/api/v1/payer-rules",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPayers: (input = {}) =>
      send<PayerListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/payers",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPaymentPlans: (input) =>
      send<PaymentPlanListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/payment-plans`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPlansAwaitingCertification: (input = {}) =>
      send<AwaitingCertificationEnvelope>(config, {
        method: "GET",
        path: "/api/v1/care-plans:awaiting-certification",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPolicyBands: (input = {}) =>
      send<Envelope_list_PolicyBandResource__>(config, {
        method: "GET",
        path: "/api/v1/policy-bands",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPostingRuns: (input) =>
      send<PostingRunSummaryListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/remittances/${encodeURIComponent(String(input.path.remittance_id))}/posting-runs`,
        headers: input.headers,
        signal: input.signal,
      }),
    listPractices: (input = {}) =>
      send<PracticeListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/practices",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listPriorAuthorizations: (input = {}) =>
      send<PriorAuthListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/prior-authorizations",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listProcedureAttributes: (input) =>
      send<ProcedureAttributeListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/procedure-attributes`,
        headers: input.headers,
        signal: input.signal,
      }),
    listProcedureCodeChoices: (input) =>
      send<ProcedureCodeChoiceListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/procedure-codes:choices`,
        headers: input.headers,
        signal: input.signal,
      }),
    listProviderChoices: (input = {}) =>
      send<ProviderChoiceListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/providers:choices",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listProviderEnrollments: (input) =>
      send<Envelope_list_EnrollmentResource__>(config, {
        method: "GET",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}/enrollments`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listProviderIdentifiers: (input) =>
      send<Envelope_list_ProviderIdentifierResource__>(config, {
        method: "GET",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}/identifiers`,
        headers: input.headers,
        signal: input.signal,
      }),
    listProviders: (input = {}) =>
      send<Envelope_list_ProviderResource__>(config, {
        method: "GET",
        path: "/api/v1/providers",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listRateSuggestions: (input = {}) =>
      send<RateSuggestionListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/fee-schedule-rate-suggestions",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listReferrals: (input = {}) =>
      send<ReferralListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/referrals",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listRefunds: (input = {}) =>
      send<RefundListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/refunds",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listRemittanceExtractions: (input = {}) =>
      send<RemittanceExtractionListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/remittance-extractions",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listRemittances: (input = {}) =>
      send<RemittanceListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/remittances",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listReportDefinitions: (input = {}) =>
      send<ReportDefinitionListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/report-definitions",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listRoleGrants: (input) =>
      send<Envelope_list_RoleGrantResource__>(config, {
        method: "GET",
        path: `/api/v1/users/${encodeURIComponent(String(input.path.user_id))}/role-grants`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listRoles: (input = {}) =>
      send<Envelope_list_RoleResource__>(config, {
        method: "GET",
        path: "/api/v1/roles",
        headers: input.headers,
        signal: input.signal,
      }),
    listScheduleBlocks: (input = {}) =>
      send<Envelope_list_ScheduleBlockResource__>(config, {
        method: "GET",
        path: "/api/v1/schedule-blocks",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listScheduleTemplates: (input = {}) =>
      send<Envelope_list_TemplateResource__>(config, {
        method: "GET",
        path: "/api/v1/schedule-templates",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listScrubRules: (input = {}) =>
      send<Envelope_list_ScrubRuleResource__>(config, {
        method: "GET",
        path: "/api/v1/scrub-rules",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listServiceMappings: (input = {}) =>
      send<Envelope_list_ServiceMappingResource__>(config, {
        method: "GET",
        path: "/api/v1/service-map",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listSettingDefinitions: (input = {}) =>
      send<Envelope_list_SettingDefinitionResource__>(config, {
        method: "GET",
        path: "/api/v1/setting-definitions",
        headers: input.headers,
        signal: input.signal,
      }),
    listSettings: (input = {}) =>
      send<Envelope_list_SettingResource__>(config, {
        method: "GET",
        path: "/api/v1/settings",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listSpecialtyPacks: (input = {}) =>
      send<SpecialtyPackListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/specialty-packs",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listSuperbillExtractions: (input) =>
      send<SuperbillExtractionListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/encounters/${encodeURIComponent(String(input.path.encounter_id))}/superbill-extractions`,
        headers: input.headers,
        signal: input.signal,
      }),
    listSupportSessions: (input = {}) =>
      send<Envelope_list_SupportSessionResource__>(config, {
        method: "GET",
        path: "/api/v1/support-sessions",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listSweepRuns: (input = {}) =>
      send<SweepRunListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/sweep-runs",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listUnitMethods: (input) =>
      send<UnitMethodListEnvelope>(config, {
        method: "GET",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/unit-methods`,
        headers: input.headers,
        signal: input.signal,
      }),
    listUnmatchedBankDeposits: (input = {}) =>
      send<UnmatchedDepositListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/bank-deposits",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listUsers: (input = {}) =>
      send<Envelope_list_UserResource__>(config, {
        method: "GET",
        path: "/api/v1/users",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listVisitTypes: (input = {}) =>
      send<Envelope_list_VisitTypeResource__>(config, {
        method: "GET",
        path: "/api/v1/visit-types",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listVoiceAppointments: (input = {}) =>
      send<VoiceAppointmentEnvelope>(config, {
        method: "GET",
        path: "/api/v1/integrations/voice/appointments",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listVoiceBalances: (input = {}) =>
      send<VoiceBalanceEnvelope>(config, {
        method: "GET",
        path: "/api/v1/integrations/voice/balances",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listWaitlist: (input = {}) =>
      send<WaitlistEntryListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/waitlist",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listWorkItems: (input = {}) =>
      send<WorkItemListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/work-items",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    listWritebackTasks: (input = {}) =>
      send<WritebackTaskListEnvelope>(config, {
        method: "GET",
        path: "/api/v1/writeback-tasks",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    markClinicalNoteEnteredInError: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:enter-in-error`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    markPatientEnteredInError: (input) =>
      send<PatientEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:mark-entered-in-error`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    mergePatient: (input) =>
      send<PatientMergeEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:merge`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    normaliseEligibilityBenefits: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/eligibility-responses/${encodeURIComponent(String(input.path.response_id))}:normalise-benefits`,
        headers: input.headers,
        signal: input.signal,
      }),
    openCodingReview: (input) =>
      send<CodingReviewEnvelope>(config, {
        method: "POST",
        path: "/api/v1/coding-reviews",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    overrideClaimScrubFinding: (input) =>
      send<ScrubOverrideEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/scrub-overrides`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    pausePolicyBand: (input) =>
      send<Envelope_PolicyBandResource_>(config, {
        method: "POST",
        path: `/api/v1/policy-bands/${encodeURIComponent(String(input.path.band_id))}:pause`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    placeAccountWithAgency: (input) =>
      send<PlacementEnvelope>(config, {
        method: "POST",
        path: "/api/v1/collection-placements",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    postRemittance: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/remittances/${encodeURIComponent(String(input.path.remittance_id))}:post`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    projectScoreboard: (input) =>
      send<Envelope_ScoreboardProjectionResource_>(config, {
        method: "POST",
        path: "/api/v1/reports/scoreboard:project",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    promotePayerRule: (input) =>
      send<Envelope_PayerRuleResource_>(config, {
        method: "POST",
        path: `/api/v1/payer-rules/${encodeURIComponent(String(input.path.rule_id))}:promote`,
        headers: input.headers,
        signal: input.signal,
      }),
    promoteScrubRule: (input) =>
      send<Envelope_ScrubRuleResource_>(config, {
        method: "POST",
        path: `/api/v1/scrub-rules/${encodeURIComponent(String(input.path.rule_id))}:promote`,
        headers: input.headers,
        signal: input.signal,
      }),
    publishConsentForm: (input) =>
      send<ConsentFormEnvelope>(config, {
        method: "POST",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/consent-forms`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    purchasePatientPackage: (input) =>
      send<PatientPackageEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/packages`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    quotePatientEstimate: (input) =>
      send<Envelope_EstimateQuoteResource_>(config, {
        method: "GET",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/estimate-quote`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    raiseDowncodeAppeals: (input) =>
      send<CandidateEnvelope>(config, {
        method: "POST",
        path: "/api/v1/downcodes:appeal",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    raiseFeeScheduleReviews: (input = {}) =>
      send<Envelope_ReviewSweepResource_>(config, {
        method: "POST",
        path: "/api/v1/fee-schedules:raise-review-obligations",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    raiseUnderpaymentChallenges: (input) =>
      send<CandidateEnvelope>(config, {
        method: "POST",
        path: "/api/v1/underpayments:challenge",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    readInsuranceCard: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:read-insurance-card`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    receiveCoreProvisioning: (input) =>
      send<ProvisioningEnvelope>(config, {
        method: "POST",
        path: "/api/v1/provisioning/events",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    receiveHubWebhook: (input) =>
      send<void>(config, {
        method: "POST",
        path: `/api/v1/integrations/hub/webhooks/${encodeURIComponent(String(input.path.tenant_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
    receivePatientFeed: (input) =>
      send<PatientFeedEnvelope>(config, {
        method: "POST",
        path: "/api/v1/patient-feed",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recogniseChargeRevenue: (input) =>
      send<RevenueRecognitionEnvelope>(config, {
        method: "POST",
        path: "/api/v1/charges:recognise-revenue",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reconcileClaimSubmission: (input) =>
      send<ClaimSubmissionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/submissions/${encodeURIComponent(String(input.path.submission_id))}:reconcile`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reconcileEncounterCharges: (input) =>
      send<EncounterReconcileEnvelope>(config, {
        method: "POST",
        path: "/api/v1/encounters:reconcile-charges",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reconcilePatientEstimates: (input) =>
      send<Envelope_ReconciliationSweepResource_>(config, {
        method: "POST",
        path: "/api/v1/patient-estimates:reconcile",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordAppealOutcome: (input) =>
      send<AppealEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appeals/${encodeURIComponent(String(input.path.appeal_id))}:record-outcome`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordAppointmentArrival: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:arrive`,
        headers: input.headers,
        signal: input.signal,
      }),
    recordAppointmentCompletion: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:complete`,
        headers: input.headers,
        signal: input.signal,
      }),
    recordAppointmentNoShow: (input) =>
      send<AppointmentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:no-show`,
        headers: input.headers,
        signal: input.signal,
      }),
    recordClaimAcknowledgement: (input) =>
      send<ClaimAcknowledgementEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/acknowledgements`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordClaimFiling: (input) =>
      send<ClaimSubmissionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/filings`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordClaimFollowUpNote: (input) =>
      send<Envelope_FollowUpNoteResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/notes`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordClaimReceipt: (input) =>
      send<ClaimEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:record-receipt`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordClaimStatusCheck: (input) =>
      send<ClaimStatusCheckEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/status-checks`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordEligibilityVerification: (input) =>
      send<EligibilityEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/eligibility-verifications`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordPatientConsent: (input) =>
      send<ConsentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/consents`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordPatientFollowUpNote: (input) =>
      send<Envelope_FollowUpNoteResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/notes`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordPlacementEvent: (input) =>
      send<PlacementEnvelope>(config, {
        method: "POST",
        path: `/api/v1/collection-placements/${encodeURIComponent(String(input.path.placement_id))}/events`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordPriorAuthorization: (input) =>
      send<PriorAuthEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/prior-authorizations`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordPriorAuthorizationDecision: (input) =>
      send<PriorAuthEnvelope>(config, {
        method: "POST",
        path: `/api/v1/prior-authorizations/${encodeURIComponent(String(input.path.prior_auth_id))}:record-decision`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    recordReferral: (input) =>
      send<ReferralEnvelope>(config, {
        method: "POST",
        path: "/api/v1/referrals",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    refreshToken: (input = {}) =>
      send<TokenEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/refresh",
        headers: input.headers,
        signal: input.signal,
      }),
    registerPatient: (input) =>
      send<PatientEnvelope>(config, {
        method: "POST",
        path: "/api/v1/patients",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    rejectPayerRule: (input) =>
      send<Envelope_PayerRuleResource_>(config, {
        method: "POST",
        path: `/api/v1/payer-rules/${encodeURIComponent(String(input.path.rule_id))}:reject`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    rejectRemittanceExtraction: (input) =>
      send<RemittanceExtractionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/remittance-extractions/${encodeURIComponent(String(input.path.extraction_id))}:reject`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    releaseChargeBatch: (input) =>
      send<ChargeReleaseEnvelope>(config, {
        method: "POST",
        path: `/api/v1/charge-batches/${encodeURIComponent(String(input.path.batch_id))}:release`,
        headers: input.headers,
        signal: input.signal,
      }),
    removeWaitlistEntry: (input) =>
      send<WaitlistEntryEnvelope>(config, {
        method: "POST",
        path: `/api/v1/waitlist/${encodeURIComponent(String(input.path.entry_id))}:remove`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    renderCms1500: (input) =>
      send<void>(config, {
        method: "GET",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/cms-1500.pdf`,
        headers: input.headers,
        signal: input.signal,
      }),
    reopenClaim: (input) =>
      send<Envelope_ClaimClosureResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:reopen`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    repairAndResubmitClaim: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/acknowledgements/${encodeURIComponent(String(input.path.acknowledgement_id))}:repair-and-resubmit`,
        headers: input.headers,
        signal: input.signal,
      }),
    replaceClinicalNoteTimeEntries: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}/time-entries`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    requestAdjustment: (input) =>
      send<AdjustmentEnvelope>(config, {
        method: "POST",
        path: "/api/v1/adjustments",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    requestAppointmentVoiceCall: (input) =>
      send<VoiceCallRequestedEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appointments/${encodeURIComponent(String(input.path.appointment_id))}:request-voice-call`,
        headers: input.headers,
        signal: input.signal,
      }),
    requestBalanceVoiceCall: (input) =>
      send<VoiceCallRequestedEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:request-balance-call`,
        headers: input.headers,
        signal: input.signal,
      }),
    requestBooking: (input) =>
      send<BookingRequestReceivedEnvelope>(config, {
        method: "POST",
        path: `/api/v1/booking/${encodeURIComponent(String(input.path.token))}`,
        body: input.body,
        signal: input.signal,
      }),
    requestPasswordReset: (input) =>
      send<PasswordRecoveryEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/password:forgot",
        body: input.body,
        signal: input.signal,
      }),
    requestPayerVoiceCall: (input) =>
      send<VoiceCallRequestedEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:request-payer-call`,
        headers: input.headers,
        signal: input.signal,
      }),
    requestRefund: (input) =>
      send<RefundEnvelope>(config, {
        method: "POST",
        path: "/api/v1/refunds",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    resetPassword: (input) =>
      send<PasswordRecoveryEnvelope>(config, {
        method: "POST",
        path: "/api/v1/auth/password:reset",
        body: input.body,
        signal: input.signal,
      }),
    resetUserMfa: (input) =>
      send<MfaStatusEnvelope>(config, {
        method: "POST",
        path: `/api/v1/users/${encodeURIComponent(String(input.path.user_id))}/mfa:reset`,
        headers: input.headers,
        signal: input.signal,
      }),
    resolveDenial: (input) =>
      send<DenialEnvelope>(config, {
        method: "POST",
        path: `/api/v1/denials/${encodeURIComponent(String(input.path.denial_id))}:resolve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    resolveObligation: (input) =>
      send<ObligationEnvelope>(config, {
        method: "POST",
        path: `/api/v1/obligations/${encodeURIComponent(String(input.path.obligation_id))}:resolve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    resolvePayerToDirectory: (input) =>
      send<PayerEnvelope>(config, {
        method: "POST",
        path: `/api/v1/payers/${encodeURIComponent(String(input.path.payer_id))}:resolve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    resolveWorkItem: (input) =>
      send<WorkItemEnvelope>(config, {
        method: "POST",
        path: `/api/v1/work-items/${encodeURIComponent(String(input.path.work_item_id))}:resolve`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    resumePolicyBand: (input) =>
      send<Envelope_PolicyBandResource_>(config, {
        method: "POST",
        path: `/api/v1/policy-bands/${encodeURIComponent(String(input.path.band_id))}:resume`,
        headers: input.headers,
        signal: input.signal,
      }),
    retireConsentForm: (input) =>
      send<ConsentFormEnvelope>(config, {
        method: "POST",
        path: `/api/v1/consent-forms/${encodeURIComponent(String(input.path.form_id))}:retire`,
        headers: input.headers,
        signal: input.signal,
      }),
    retireCustomField: (input) =>
      send<CustomFieldDefinitionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/custom-fields/${encodeURIComponent(String(input.path.field_id))}:retire`,
        headers: input.headers,
        signal: input.signal,
      }),
    retireNoteTemplate: (input) =>
      send<NoteTemplateEnvelope>(config, {
        method: "POST",
        path: `/api/v1/note-templates/${encodeURIComponent(String(input.path.template_id))}:retire`,
        headers: input.headers,
        signal: input.signal,
      }),
    retryEmailOutboxMessage: (input) =>
      send<EmailLogEntryEnvelope>(config, {
        method: "POST",
        path: `/api/v1/email-outbox/${encodeURIComponent(String(input.path.message_id))}:retry`,
        headers: input.headers,
        signal: input.signal,
      }),
    reversePatientPayment: (input) =>
      send<PatientPaymentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/payments/${encodeURIComponent(String(input.path.payment_id))}:reverse`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reversePostingRun: (input) =>
      send<PostingReversalEnvelope>(config, {
        method: "POST",
        path: `/api/v1/posting-runs/${encodeURIComponent(String(input.path.posting_run_id))}:reverse`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    revertSetting: (input) =>
      send<Envelope_SettingResource_>(config, {
        method: "POST",
        path: `/api/v1/settings/${encodeURIComponent(String(input.path.setting_id))}:revert`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewClaimAiSuggestion: (input) =>
      send<ClaimSuggestionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/ai-suggestions/${encodeURIComponent(String(input.path.suggestion_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewClinicalNoteAiSuggestion: (input) =>
      send<NoteSuggestionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}/ai-suggestions/${encodeURIComponent(String(input.path.suggestion_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewCodingProposal: (input) =>
      send<CodingProposalEnvelope>(config, {
        method: "POST",
        path: `/api/v1/coding-proposals/${encodeURIComponent(String(input.path.proposal_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewDenialAiSuggestion: (input) =>
      send<AiSuggestionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/denials/${encodeURIComponent(String(input.path.denial_id))}/ai-suggestions/${encodeURIComponent(String(input.path.suggestion_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewDocumentClassification: (input) =>
      send<DocumentClassificationEnvelope>(config, {
        method: "POST",
        path: `/api/v1/document-classifications/${encodeURIComponent(String(input.path.suggestion_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewImportMapping: (input) =>
      send<ImportMappingSuggestionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/import-mappings/${encodeURIComponent(String(input.path.suggestion_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewPatientExplanationSuggestion: (input) =>
      send<Envelope_ExplanationSuggestionResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/explanation-suggestions/${encodeURIComponent(String(input.path.suggestion_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    reviewSuperbillExtraction: (input) =>
      send<SuperbillExtractionEnvelope>(config, {
        method: "POST",
        path: `/api/v1/superbill-extractions/${encodeURIComponent(String(input.path.extraction_id))}:review`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    revokeCarePlanSignoff: (input) =>
      send<CarePlanSignoffEnvelope>(config, {
        method: "POST",
        path: `/api/v1/care-plan-signoffs/${encodeURIComponent(String(input.path.signoff_id))}:revoke`,
        headers: input.headers,
        signal: input.signal,
      }),
    revokeConsentRequest: (input) =>
      send<ConsentRequestEnvelope>(config, {
        method: "POST",
        path: `/api/v1/consent-requests/${encodeURIComponent(String(input.path.request_row_id))}:revoke`,
        headers: input.headers,
        signal: input.signal,
      }),
    revokeIntakeInvitation: (input) =>
      send<IntakeInvitationEnvelope>(config, {
        method: "POST",
        path: `/api/v1/intake-invitations/${encodeURIComponent(String(input.path.invitation_id))}:revoke`,
        headers: input.headers,
        signal: input.signal,
      }),
    revokeRoleGrant: (input) =>
      send<Envelope_RoleGrantResource_>(config, {
        method: "POST",
        path: `/api/v1/role-grants/${encodeURIComponent(String(input.path.grant_id))}:revoke`,
        headers: input.headers,
        signal: input.signal,
      }),
    saveChargeTemplate: (input) =>
      send<ChargeTemplateEnvelope>(config, {
        method: "POST",
        path: "/api/v1/charge-templates",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    saveReportDefinition: (input) =>
      send<ReportDefinitionEnvelope>(config, {
        method: "POST",
        path: "/api/v1/report-definitions",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    saveServiceMapping: (input) =>
      send<Envelope_ServiceMappingResource_>(config, {
        method: "PUT",
        path: "/api/v1/service-map",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    searchPayerDirectory: (input = {}) =>
      send<PayerDirectoryEnvelope>(config, {
        method: "GET",
        path: "/api/v1/payers/directory",
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    sendAppointmentReminders: (input) =>
      send<SendRemindersEnvelope>(config, {
        method: "POST",
        path: "/api/v1/appointments:send-reminders",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    sendPatientStatement: (input) =>
      send<Envelope_PatientStatementResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/statements/${encodeURIComponent(String(input.path.statement_id))}:send`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    setOwnDefaultPractice: (input) =>
      send<DefaultPracticeEnvelope>(config, {
        method: "PUT",
        path: "/api/v1/me/default-practice",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    setPatientAddress: (input) =>
      send<PatientAddressSetEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/address`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    setPatientCustomFields: (input) =>
      send<PatientCustomFieldsEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/custom-fields`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    setPayerNcci: (input) =>
      send<PayerEnvelope>(config, {
        method: "POST",
        path: `/api/v1/payers/${encodeURIComponent(String(input.path.payer_id))}:set-ncci`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    setPayerRoute: (input) =>
      send<PayerEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/payers/${encodeURIComponent(String(input.path.payer_id))}/routes/${encodeURIComponent(String(input.path.transaction))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    setPracticeBookingLink: (input) =>
      send<BookingLinkEnvelope>(config, {
        method: "POST",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}:booking-link`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    settleExpiredPackages: (input) =>
      send<PackageSettleEnvelope>(config, {
        method: "POST",
        path: "/api/v1/packages:settle-expired",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    shadowEvaluateScrubRule: (input) =>
      send<Envelope_ShadowEvaluationResource_>(config, {
        method: "POST",
        path: `/api/v1/scrub-rules/${encodeURIComponent(String(input.path.rule_id))}:shadow-evaluate`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    signClinicalNote: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "POST",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}:sign`,
        headers: input.headers,
        signal: input.signal,
      }),
    signOffImport: (input) =>
      send<ImportBatchEnvelope>(config, {
        method: "POST",
        path: `/api/v1/imports/${encodeURIComponent(String(input.path.import_id))}:sign_off`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    signOut: (input = {}) =>
      send<void>(config, {
        method: "POST",
        path: "/api/v1/auth/sign-out",
        headers: input.headers,
        signal: input.signal,
      }),
    stageImport: (input) =>
      send<ImportBatchEnvelope>(config, {
        method: "POST",
        path: "/api/v1/imports",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    startSupportSession: (input) =>
      send<Envelope_SupportSessionResource_>(config, {
        method: "POST",
        path: "/api/v1/support-sessions",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    strandExpiredClaimSubmissions: (input = {}) =>
      send<StrandedReservationsEnvelope>(config, {
        method: "POST",
        path: "/api/v1/claim-submissions:strand-expired",
        headers: input.headers,
        signal: input.signal,
      }),
    submitAppeal: (input) =>
      send<AppealEnvelope>(config, {
        method: "POST",
        path: `/api/v1/appeals/${encodeURIComponent(String(input.path.appeal_id))}:submit`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    submitClaim: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:submit`,
        headers: input.headers,
        signal: input.signal,
      }),
    submitIntakeForm: (input) =>
      send<IntakeSubmittedEnvelope>(config, {
        method: "POST",
        path: `/api/v1/intake/${encodeURIComponent(String(input.path.token))}`,
        body: input.body,
        signal: input.signal,
      }),
    suggestClaimDenialPrevention: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:suggest-denial-prevention`,
        headers: input.headers,
        signal: input.signal,
      }),
    suggestDenialRootCause: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/denials/${encodeURIComponent(String(input.path.denial_id))}:suggest-root-cause`,
        headers: input.headers,
        signal: input.signal,
      }),
    suggestImportMapping: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: "/api/v1/import-mappings:suggest",
        query: input.query,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    suggestPatientBalanceExplanation: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}:suggest-explanation`,
        query: input.query,
        headers: input.headers,
        signal: input.signal,
      }),
    summariseClaimPayerCall: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:summarise-call`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    sweepProviderObligations: (input) =>
      send<Envelope_ProviderObligationSweepResource_>(config, {
        method: "POST",
        path: "/api/v1/providers:sweep-obligations",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    sweepUnderpayments: (input) =>
      send<SweepEnvelope>(config, {
        method: "POST",
        path: "/api/v1/underpayments:sweep",
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    takePatientPayment: (input) =>
      send<PatientPaymentEnvelope>(config, {
        method: "POST",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}/payments`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateCarePlan: (input) =>
      send<CarePlanEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/care-plans/${encodeURIComponent(String(input.path.care_plan_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateClinicalNote: (input) =>
      send<ClinicalNoteEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/clinical-notes/${encodeURIComponent(String(input.path.note_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateCoverage: (input) =>
      send<CoverageEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/coverages/${encodeURIComponent(String(input.path.coverage_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateLocation: (input) =>
      send<LocationEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/locations/${encodeURIComponent(String(input.path.location_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updatePackagePlan: (input) =>
      send<PackagePlanEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/package-plans/${encodeURIComponent(String(input.path.plan_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updatePatient: (input) =>
      send<PatientEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/patients/${encodeURIComponent(String(input.path.patient_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updatePayer: (input) =>
      send<PayerEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/payers/${encodeURIComponent(String(input.path.payer_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updatePractice: (input) =>
      send<PracticeEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateProvider: (input) =>
      send<Envelope_ProviderResource_>(config, {
        method: "PATCH",
        path: `/api/v1/providers/${encodeURIComponent(String(input.path.provider_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateProviderEnrollment: (input) =>
      send<Envelope_EnrollmentResource_>(config, {
        method: "PATCH",
        path: `/api/v1/provider-enrollments/${encodeURIComponent(String(input.path.enrollment_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateReferral: (input) =>
      send<ReferralEnvelope>(config, {
        method: "PATCH",
        path: `/api/v1/referrals/${encodeURIComponent(String(input.path.referral_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateScheduleTemplate: (input) =>
      send<Envelope_TemplateResource_>(config, {
        method: "PATCH",
        path: `/api/v1/schedule-templates/${encodeURIComponent(String(input.path.template_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    updateVisitType: (input) =>
      send<Envelope_VisitTypeResource_>(config, {
        method: "PATCH",
        path: `/api/v1/visit-types/${encodeURIComponent(String(input.path.visit_type_id))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    upsertChargeRule: (input) =>
      send<ChargeRuleEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/charge-rules/${encodeURIComponent(String(input.path.key))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    upsertCodeGroup: (input) =>
      send<CodeGroupEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/code-groups/${encodeURIComponent(String(input.path.key))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    upsertProcedureAttribute: (input) =>
      send<ProcedureAttributeEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/procedure-attributes/${encodeURIComponent(String(input.path.procedure_code_set))}/${encodeURIComponent(String(input.path.procedure_code))}`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    upsertUnitMethod: (input) =>
      send<UnitMethodEnvelope>(config, {
        method: "PUT",
        path: `/api/v1/practices/${encodeURIComponent(String(input.path.practice_id))}/unit-methods`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    validateClaim: (input) =>
      send<Envelope_OperationResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:validate`,
        headers: input.headers,
        signal: input.signal,
      }),
    verifyPayerIdentifier: (input) =>
      send<PayerEnvelope>(config, {
        method: "POST",
        path: `/api/v1/payers/${encodeURIComponent(String(input.path.payer_id))}/identifiers/${encodeURIComponent(String(input.path.transaction))}:verify`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    versionNoteTemplate: (input) =>
      send<NoteTemplateEnvelope>(config, {
        method: "POST",
        path: `/api/v1/note-templates/${encodeURIComponent(String(input.path.template_id))}/versions`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    voidCharge: (input) =>
      send<ChargeEnvelope>(config, {
        method: "POST",
        path: `/api/v1/charges/${encodeURIComponent(String(input.path.charge_id))}:void`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    voidClaim: (input) =>
      send<Envelope_ClaimClosureResource_>(config, {
        method: "POST",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}:void`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    voidReferral: (input) =>
      send<ReferralEnvelope>(config, {
        method: "POST",
        path: `/api/v1/referrals/${encodeURIComponent(String(input.path.referral_id))}:void`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    waiveObligation: (input) =>
      send<ObligationEnvelope>(config, {
        method: "POST",
        path: `/api/v1/obligations/${encodeURIComponent(String(input.path.obligation_id))}:waive`,
        headers: input.headers,
        body: input.body,
        signal: input.signal,
      }),
    withdrawClaimScrubOverride: (input) =>
      send<void>(config, {
        method: "DELETE",
        path: `/api/v1/claims/${encodeURIComponent(String(input.path.claim_id))}/scrub-overrides/${encodeURIComponent(String(input.path.override_id))}`,
        headers: input.headers,
        signal: input.signal,
      }),
  };
}

/** Narrow a caught value to an API failure, with its problem document typed. */
export function isSarvaApiError(
  error: unknown,
): error is SarvaApiError & { problem: Problem } {
  return error instanceof SarvaApiError;
}
